
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94e4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94e4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jYqtV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e8a829a2b672c9cd$export$ffb0004e005737fa; }, function (v) { return $e8a829a2b672c9cd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e8a829a2b672c9cd$export$34b9dba7ce09269b; }, function (v) { return $e8a829a2b672c9cd$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e8a829a2b672c9cd$export$25062201e9e25d76; }, function (v) { return $e8a829a2b672c9cd$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8a829a2b672c9cd$export$ffb0004e005737fa;
var $e8a829a2b672c9cd$export$34b9dba7ce09269b;
var $e8a829a2b672c9cd$export$25062201e9e25d76;
"use strict";
var $e8a829a2b672c9cd$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e8a829a2b672c9cd$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $e8a829a2b672c9cd$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $e8a829a2b672c9cd$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$e8a829a2b672c9cd$export$ffb0004e005737fa = $e8a829a2b672c9cd$var$REACT_FRAGMENT_TYPE;
$e8a829a2b672c9cd$export$34b9dba7ce09269b = $e8a829a2b672c9cd$var$jsxProd;
$e8a829a2b672c9cd$export$25062201e9e25d76 = $e8a829a2b672c9cd$var$jsxProd;

});

parcelRegister("He5iZ", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $081ef12b46fbcaa0$export$882461b6382ed46c; }, function (v) { return $081ef12b46fbcaa0$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $081ef12b46fbcaa0$export$757ceba2d55c277e; }, function (v) { return $081ef12b46fbcaa0$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $081ef12b46fbcaa0$export$83d89fbfd8236492; }, function (v) { return $081ef12b46fbcaa0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $081ef12b46fbcaa0$export$882461b6382ed46c;
var $081ef12b46fbcaa0$export$757ceba2d55c277e;
var $081ef12b46fbcaa0$export$83d89fbfd8236492;
"use strict";

var $fndEB = parcelRequire("fndEB");

var $jGswQ = parcelRequire("jGswQ");

var $5hICV = parcelRequire("5hICV");
function $081ef12b46fbcaa0$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $081ef12b46fbcaa0$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $081ef12b46fbcaa0$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $081ef12b46fbcaa0$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $081ef12b46fbcaa0$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $081ef12b46fbcaa0$var$assertIsMounted(fiber) {
    if ($081ef12b46fbcaa0$var$getNearestMountedFiber(fiber) !== fiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
}
function $081ef12b46fbcaa0$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $081ef12b46fbcaa0$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $081ef12b46fbcaa0$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $081ef12b46fbcaa0$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $081ef12b46fbcaa0$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $081ef12b46fbcaa0$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $081ef12b46fbcaa0$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $081ef12b46fbcaa0$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $081ef12b46fbcaa0$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $081ef12b46fbcaa0$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $081ef12b46fbcaa0$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(559));
    }
}
var $081ef12b46fbcaa0$var$searchTarget = null, $081ef12b46fbcaa0$var$searchBoundary = null;
function $081ef12b46fbcaa0$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($081ef12b46fbcaa0$var$searchTarget = child, !0) : !1;
}
function $081ef12b46fbcaa0$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($081ef12b46fbcaa0$var$searchBoundary = child, !1) : child === target ? (null !== $081ef12b46fbcaa0$var$searchBoundary && ($081ef12b46fbcaa0$var$searchTarget = child), !0) : !1;
}
function $081ef12b46fbcaa0$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $081ef12b46fbcaa0$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $081ef12b46fbcaa0$var$assign = Object.assign, $081ef12b46fbcaa0$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $081ef12b46fbcaa0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $081ef12b46fbcaa0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $081ef12b46fbcaa0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $081ef12b46fbcaa0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $081ef12b46fbcaa0$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $081ef12b46fbcaa0$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $081ef12b46fbcaa0$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $081ef12b46fbcaa0$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $081ef12b46fbcaa0$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $081ef12b46fbcaa0$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $081ef12b46fbcaa0$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$081ef12b46fbcaa0$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $081ef12b46fbcaa0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $081ef12b46fbcaa0$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $081ef12b46fbcaa0$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $081ef12b46fbcaa0$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $081ef12b46fbcaa0$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $081ef12b46fbcaa0$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $081ef12b46fbcaa0$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $081ef12b46fbcaa0$var$getComponentNameFromType(type.type) || "Memo";
        case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $081ef12b46fbcaa0$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $081ef12b46fbcaa0$var$isArrayImpl = Array.isArray, $081ef12b46fbcaa0$var$ReactSharedInternals = $jGswQ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $081ef12b46fbcaa0$var$ReactDOMSharedInternals = $5hICV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $081ef12b46fbcaa0$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $081ef12b46fbcaa0$var$valueStack = [], $081ef12b46fbcaa0$var$index = -1;
function $081ef12b46fbcaa0$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $081ef12b46fbcaa0$var$pop(cursor) {
    0 > $081ef12b46fbcaa0$var$index || (cursor.current = $081ef12b46fbcaa0$var$valueStack[$081ef12b46fbcaa0$var$index], $081ef12b46fbcaa0$var$valueStack[$081ef12b46fbcaa0$var$index] = null, $081ef12b46fbcaa0$var$index--);
}
function $081ef12b46fbcaa0$var$push(cursor, value) {
    $081ef12b46fbcaa0$var$index++;
    $081ef12b46fbcaa0$var$valueStack[$081ef12b46fbcaa0$var$index] = cursor.current;
    cursor.current = value;
}
var $081ef12b46fbcaa0$var$contextStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$contextFiberStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$rootInstanceStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$hostTransitionProviderCursor = $081ef12b46fbcaa0$var$createCursor(null);
function $081ef12b46fbcaa0$var$pushHostContainer(fiber, nextRootInstance) {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$rootInstanceStackCursor, nextRootInstance);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextFiberStackCursor, fiber);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $081ef12b46fbcaa0$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $081ef12b46fbcaa0$var$getOwnHostContext(nextRootInstance), fiber = $081ef12b46fbcaa0$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextStackCursor);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextStackCursor, fiber);
}
function $081ef12b46fbcaa0$var$popHostContainer() {
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextFiberStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$rootInstanceStackCursor);
}
function $081ef12b46fbcaa0$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($081ef12b46fbcaa0$var$HostTransitionContext._currentValue = stateHook.memoizedState, $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$hostTransitionProviderCursor, fiber));
    stateHook = $081ef12b46fbcaa0$var$contextStackCursor.current;
    var JSCompiler_inline_result = $081ef12b46fbcaa0$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextFiberStackCursor, fiber), $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$contextStackCursor, JSCompiler_inline_result));
}
function $081ef12b46fbcaa0$var$popHostContext(fiber) {
    $081ef12b46fbcaa0$var$contextFiberStackCursor.current === fiber && ($081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextStackCursor), $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$contextFiberStackCursor));
    $081ef12b46fbcaa0$var$hostTransitionProviderCursor.current === fiber && ($081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$hostTransitionProviderCursor), $081ef12b46fbcaa0$var$HostTransitionContext._currentValue = $081ef12b46fbcaa0$var$sharedNotPendingObject);
}
var $081ef12b46fbcaa0$var$prefix, $081ef12b46fbcaa0$var$suffix;
function $081ef12b46fbcaa0$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $081ef12b46fbcaa0$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $081ef12b46fbcaa0$var$prefix = match && match[1] || "";
        $081ef12b46fbcaa0$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $081ef12b46fbcaa0$var$prefix + name + $081ef12b46fbcaa0$var$suffix;
}
var $081ef12b46fbcaa0$var$reentry = !1;
function $081ef12b46fbcaa0$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $081ef12b46fbcaa0$var$reentry) return "";
    $081ef12b46fbcaa0$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $081ef12b46fbcaa0$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $081ef12b46fbcaa0$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $081ef12b46fbcaa0$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Suspense Fallback") : $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $081ef12b46fbcaa0$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $081ef12b46fbcaa0$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $081ef12b46fbcaa0$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $081ef12b46fbcaa0$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $081ef12b46fbcaa0$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $081ef12b46fbcaa0$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $081ef12b46fbcaa0$var$hasOwnProperty = Object.prototype.hasOwnProperty, $081ef12b46fbcaa0$var$scheduleCallback$3 = $fndEB.unstable_scheduleCallback, $081ef12b46fbcaa0$var$cancelCallback$1 = $fndEB.unstable_cancelCallback, $081ef12b46fbcaa0$var$shouldYield = $fndEB.unstable_shouldYield, $081ef12b46fbcaa0$var$requestPaint = $fndEB.unstable_requestPaint, $081ef12b46fbcaa0$var$now = $fndEB.unstable_now, $081ef12b46fbcaa0$var$getCurrentPriorityLevel = $fndEB.unstable_getCurrentPriorityLevel, $081ef12b46fbcaa0$var$ImmediatePriority = $fndEB.unstable_ImmediatePriority, $081ef12b46fbcaa0$var$UserBlockingPriority = $fndEB.unstable_UserBlockingPriority, $081ef12b46fbcaa0$var$NormalPriority$1 = $fndEB.unstable_NormalPriority, $081ef12b46fbcaa0$var$LowPriority = $fndEB.unstable_LowPriority, $081ef12b46fbcaa0$var$IdlePriority = $fndEB.unstable_IdlePriority, $081ef12b46fbcaa0$var$log$1 = $fndEB.log, $081ef12b46fbcaa0$var$unstable_setDisableYieldValue = $fndEB.unstable_setDisableYieldValue, $081ef12b46fbcaa0$var$rendererID = null, $081ef12b46fbcaa0$var$injectedHook = null;
function $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $081ef12b46fbcaa0$var$log$1 && $081ef12b46fbcaa0$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.setStrictMode) try {
        $081ef12b46fbcaa0$var$injectedHook.setStrictMode($081ef12b46fbcaa0$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $081ef12b46fbcaa0$var$clz32 = Math.clz32 ? Math.clz32 : $081ef12b46fbcaa0$var$clz32Fallback, $081ef12b46fbcaa0$var$log = Math.log, $081ef12b46fbcaa0$var$LN2 = Math.LN2;
function $081ef12b46fbcaa0$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($081ef12b46fbcaa0$var$log(x) / $081ef12b46fbcaa0$var$LN2 | 0) | 0;
}
var $081ef12b46fbcaa0$var$nextTransitionUpdateLane = 256, $081ef12b46fbcaa0$var$nextTransitionDeferredLane = 262144, $081ef12b46fbcaa0$var$nextRetryLane = 4194304;
function $081ef12b46fbcaa0$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $081ef12b46fbcaa0$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $081ef12b46fbcaa0$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $081ef12b46fbcaa0$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $081ef12b46fbcaa0$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $081ef12b46fbcaa0$var$claimNextRetryLane() {
    var lane = $081ef12b46fbcaa0$var$nextRetryLane;
    $081ef12b46fbcaa0$var$nextRetryLane <<= 1;
    0 === ($081ef12b46fbcaa0$var$nextRetryLane & 62914560) && ($081ef12b46fbcaa0$var$nextRetryLane = 4194304);
    return lane;
}
function $081ef12b46fbcaa0$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $081ef12b46fbcaa0$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $081ef12b46fbcaa0$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $081ef12b46fbcaa0$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $081ef12b46fbcaa0$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $081ef12b46fbcaa0$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $081ef12b46fbcaa0$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $081ef12b46fbcaa0$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $081ef12b46fbcaa0$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $081ef12b46fbcaa0$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $081ef12b46fbcaa0$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $081ef12b46fbcaa0$var$resolveUpdatePriority() {
    var updatePriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $081ef12b46fbcaa0$var$getEventPriority(updatePriority.type);
}
function $081ef12b46fbcaa0$var$runWithPriority(priority, fn) {
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        return $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $081ef12b46fbcaa0$var$randomKey = Math.random().toString(36).slice(2), $081ef12b46fbcaa0$var$internalInstanceKey = "__reactFiber$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalPropsKey = "__reactProps$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalContainerInstanceKey = "__reactContainer$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalEventHandlersKey = "__reactEvents$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalEventHandlerListenersKey = "__reactListeners$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalEventHandlesSetKey = "__reactHandles$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalRootNodeResourcesKey = "__reactResources$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalHoistableMarker = "__reactMarker$" + $081ef12b46fbcaa0$var$randomKey, $081ef12b46fbcaa0$var$internalLoadPendingKey = "__reactLoad$" + $081ef12b46fbcaa0$var$randomKey;
function $081ef12b46fbcaa0$var$detachDeletedInstance(node) {
    delete node[$081ef12b46fbcaa0$var$internalInstanceKey];
    delete node[$081ef12b46fbcaa0$var$internalPropsKey];
    delete node[$081ef12b46fbcaa0$var$internalEventHandlerListenersKey];
    delete node[$081ef12b46fbcaa0$var$internalEventHandlesSetKey];
}
function $081ef12b46fbcaa0$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$081ef12b46fbcaa0$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$081ef12b46fbcaa0$var$internalContainerInstanceKey] || parentNode[$081ef12b46fbcaa0$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $081ef12b46fbcaa0$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$081ef12b46fbcaa0$var$internalInstanceKey]) return parentNode;
                targetNode = $081ef12b46fbcaa0$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $081ef12b46fbcaa0$var$getInstanceFromNode(node) {
    if (node = node[$081ef12b46fbcaa0$var$internalInstanceKey] || node[$081ef12b46fbcaa0$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $081ef12b46fbcaa0$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(33));
}
function $081ef12b46fbcaa0$var$getResourcesFromRoot(root) {
    var resources = root[$081ef12b46fbcaa0$var$internalRootNodeResourcesKey];
    resources || (resources = root[$081ef12b46fbcaa0$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $081ef12b46fbcaa0$var$markNodeAsHoistable(node) {
    node[$081ef12b46fbcaa0$var$internalHoistableMarker] = !0;
}
function $081ef12b46fbcaa0$var$clearPendingLoadOnNode(node) {
    node[$081ef12b46fbcaa0$var$internalLoadPendingKey] = void 0;
}
var $081ef12b46fbcaa0$var$allNativeEvents = new Set(), $081ef12b46fbcaa0$var$registrationNameDependencies = {};
function $081ef12b46fbcaa0$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $081ef12b46fbcaa0$var$registerDirectEvent(registrationName, dependencies);
    $081ef12b46fbcaa0$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $081ef12b46fbcaa0$var$registerDirectEvent(registrationName, dependencies) {
    $081ef12b46fbcaa0$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$081ef12b46fbcaa0$var$allNativeEvents.add(dependencies[registrationName]);
}
var $081ef12b46fbcaa0$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $081ef12b46fbcaa0$var$illegalAttributeNameCache = {}, $081ef12b46fbcaa0$var$validatedAttributeNameCache = {};
function $081ef12b46fbcaa0$var$isAttributeNameSafe(attributeName) {
    if ($081ef12b46fbcaa0$var$hasOwnProperty.call($081ef12b46fbcaa0$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($081ef12b46fbcaa0$var$hasOwnProperty.call($081ef12b46fbcaa0$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($081ef12b46fbcaa0$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $081ef12b46fbcaa0$var$validatedAttributeNameCache[attributeName] = !0;
    $081ef12b46fbcaa0$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $081ef12b46fbcaa0$var$viewTransitionMutationContext = !1;
function $081ef12b46fbcaa0$var$pushMutationContext() {
    var prev = $081ef12b46fbcaa0$var$viewTransitionMutationContext;
    $081ef12b46fbcaa0$var$viewTransitionMutationContext = !1;
    return prev;
}
function $081ef12b46fbcaa0$var$setValueForAttribute(node, name, value) {
    if ($081ef12b46fbcaa0$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $081ef12b46fbcaa0$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $081ef12b46fbcaa0$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $081ef12b46fbcaa0$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $081ef12b46fbcaa0$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $081ef12b46fbcaa0$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $081ef12b46fbcaa0$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $081ef12b46fbcaa0$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $081ef12b46fbcaa0$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $081ef12b46fbcaa0$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $081ef12b46fbcaa0$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $081ef12b46fbcaa0$var$getToStringValue(value);
        } else element.value !== "" + $081ef12b46fbcaa0$var$getToStringValue(value) && (element.value = "" + $081ef12b46fbcaa0$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $081ef12b46fbcaa0$var$setDefaultValue(element, $081ef12b46fbcaa0$var$getToStringValue(element.value)) : $081ef12b46fbcaa0$var$setDefaultValue(element, $081ef12b46fbcaa0$var$getToStringValue(value)) : null != defaultValue ? $081ef12b46fbcaa0$var$setDefaultValue(element, $081ef12b46fbcaa0$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $081ef12b46fbcaa0$var$getToStringValue(name) : element.removeAttribute("name");
}
function $081ef12b46fbcaa0$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $081ef12b46fbcaa0$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $081ef12b46fbcaa0$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $081ef12b46fbcaa0$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $081ef12b46fbcaa0$var$track(element);
}
function $081ef12b46fbcaa0$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $081ef12b46fbcaa0$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $081ef12b46fbcaa0$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $081ef12b46fbcaa0$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $081ef12b46fbcaa0$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $081ef12b46fbcaa0$var$getToStringValue(defaultValue) : "";
}
function $081ef12b46fbcaa0$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(92));
            if ($081ef12b46fbcaa0$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $081ef12b46fbcaa0$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $081ef12b46fbcaa0$var$track(element);
}
function $081ef12b46fbcaa0$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $081ef12b46fbcaa0$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $081ef12b46fbcaa0$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $081ef12b46fbcaa0$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $081ef12b46fbcaa0$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($081ef12b46fbcaa0$var$setValueForStyle(node, styleName$16, styleName), $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $081ef12b46fbcaa0$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $081ef12b46fbcaa0$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $081ef12b46fbcaa0$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $081ef12b46fbcaa0$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $081ef12b46fbcaa0$var$sanitizeURL(url) {
    return $081ef12b46fbcaa0$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $081ef12b46fbcaa0$var$noop$1() {}
var $081ef12b46fbcaa0$var$currentReplayingEvent = null;
function $081ef12b46fbcaa0$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $081ef12b46fbcaa0$var$restoreTarget = null, $081ef12b46fbcaa0$var$restoreQueue = null;
function $081ef12b46fbcaa0$var$restoreStateOfTarget(target) {
    var internalInstance = $081ef12b46fbcaa0$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$081ef12b46fbcaa0$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $081ef12b46fbcaa0$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$081ef12b46fbcaa0$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(90));
                            $081ef12b46fbcaa0$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $081ef12b46fbcaa0$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $081ef12b46fbcaa0$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $081ef12b46fbcaa0$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $081ef12b46fbcaa0$var$isInsideEventHandler = !1;
function $081ef12b46fbcaa0$var$batchedUpdates$1(fn, a, b) {
    if ($081ef12b46fbcaa0$var$isInsideEventHandler) return fn(a, b);
    $081ef12b46fbcaa0$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($081ef12b46fbcaa0$var$isInsideEventHandler = !1, null !== $081ef12b46fbcaa0$var$restoreTarget || null !== $081ef12b46fbcaa0$var$restoreQueue) {
            if ($081ef12b46fbcaa0$var$flushSyncWork$1(), $081ef12b46fbcaa0$var$restoreTarget && (a = $081ef12b46fbcaa0$var$restoreTarget, fn = $081ef12b46fbcaa0$var$restoreQueue, $081ef12b46fbcaa0$var$restoreQueue = $081ef12b46fbcaa0$var$restoreTarget = null, $081ef12b46fbcaa0$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$081ef12b46fbcaa0$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $081ef12b46fbcaa0$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$081ef12b46fbcaa0$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $081ef12b46fbcaa0$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $081ef12b46fbcaa0$var$passiveBrowserEventsSupported = !1;
if ($081ef12b46fbcaa0$var$canUseDOM) try {
    var $081ef12b46fbcaa0$var$options = {};
    Object.defineProperty($081ef12b46fbcaa0$var$options, "passive", {
        get: function() {
            $081ef12b46fbcaa0$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $081ef12b46fbcaa0$var$options, $081ef12b46fbcaa0$var$options);
    window.removeEventListener("test", $081ef12b46fbcaa0$var$options, $081ef12b46fbcaa0$var$options);
} catch (e) {
    $081ef12b46fbcaa0$var$passiveBrowserEventsSupported = !1;
}
var $081ef12b46fbcaa0$var$root = null, $081ef12b46fbcaa0$var$startText = null, $081ef12b46fbcaa0$var$fallbackText = null;
function $081ef12b46fbcaa0$var$getData() {
    if ($081ef12b46fbcaa0$var$fallbackText) return $081ef12b46fbcaa0$var$fallbackText;
    var start, startValue = $081ef12b46fbcaa0$var$startText, startLength = startValue.length, end, endValue = "value" in $081ef12b46fbcaa0$var$root ? $081ef12b46fbcaa0$var$root.value : $081ef12b46fbcaa0$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $081ef12b46fbcaa0$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $081ef12b46fbcaa0$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $081ef12b46fbcaa0$var$functionThatReturnsTrue() {
    return !0;
}
function $081ef12b46fbcaa0$var$functionThatReturnsFalse() {
    return !1;
}
function $081ef12b46fbcaa0$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $081ef12b46fbcaa0$var$functionThatReturnsTrue : $081ef12b46fbcaa0$var$functionThatReturnsFalse;
        this.isPropagationStopped = $081ef12b46fbcaa0$var$functionThatReturnsFalse;
        return this;
    }
    $081ef12b46fbcaa0$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $081ef12b46fbcaa0$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $081ef12b46fbcaa0$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $081ef12b46fbcaa0$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $081ef12b46fbcaa0$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $081ef12b46fbcaa0$var$SyntheticEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$EventInterface), $081ef12b46fbcaa0$var$UIEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    view: 0,
    detail: 0
}), $081ef12b46fbcaa0$var$SyntheticUIEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$UIEventInterface), $081ef12b46fbcaa0$var$lastMovementX, $081ef12b46fbcaa0$var$lastMovementY, $081ef12b46fbcaa0$var$lastMouseEvent, $081ef12b46fbcaa0$var$MouseEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $081ef12b46fbcaa0$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $081ef12b46fbcaa0$var$lastMouseEvent && ($081ef12b46fbcaa0$var$lastMouseEvent && "mousemove" === event.type ? ($081ef12b46fbcaa0$var$lastMovementX = event.screenX - $081ef12b46fbcaa0$var$lastMouseEvent.screenX, $081ef12b46fbcaa0$var$lastMovementY = event.screenY - $081ef12b46fbcaa0$var$lastMouseEvent.screenY) : $081ef12b46fbcaa0$var$lastMovementY = $081ef12b46fbcaa0$var$lastMovementX = 0, $081ef12b46fbcaa0$var$lastMouseEvent = event);
        return $081ef12b46fbcaa0$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $081ef12b46fbcaa0$var$lastMovementY;
    }
}), $081ef12b46fbcaa0$var$SyntheticMouseEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$MouseEventInterface), $081ef12b46fbcaa0$var$DragEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$MouseEventInterface, {
    dataTransfer: 0
}), $081ef12b46fbcaa0$var$SyntheticDragEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$DragEventInterface), $081ef12b46fbcaa0$var$FocusEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    relatedTarget: 0
}), $081ef12b46fbcaa0$var$SyntheticFocusEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$FocusEventInterface), $081ef12b46fbcaa0$var$AnimationEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $081ef12b46fbcaa0$var$SyntheticAnimationEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$AnimationEventInterface), $081ef12b46fbcaa0$var$ClipboardEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $081ef12b46fbcaa0$var$SyntheticClipboardEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$ClipboardEventInterface), $081ef12b46fbcaa0$var$CompositionEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    data: 0
}), $081ef12b46fbcaa0$var$SyntheticCompositionEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$CompositionEventInterface), $081ef12b46fbcaa0$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $081ef12b46fbcaa0$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $081ef12b46fbcaa0$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $081ef12b46fbcaa0$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $081ef12b46fbcaa0$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $081ef12b46fbcaa0$var$getEventModifierState() {
    return $081ef12b46fbcaa0$var$modifierStateGetter;
}
var $081ef12b46fbcaa0$var$KeyboardEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $081ef12b46fbcaa0$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $081ef12b46fbcaa0$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $081ef12b46fbcaa0$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $081ef12b46fbcaa0$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $081ef12b46fbcaa0$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $081ef12b46fbcaa0$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $081ef12b46fbcaa0$var$SyntheticKeyboardEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$KeyboardEventInterface), $081ef12b46fbcaa0$var$PointerEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $081ef12b46fbcaa0$var$SyntheticPointerEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$PointerEventInterface), $081ef12b46fbcaa0$var$SubmitEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    submitter: 0
}), $081ef12b46fbcaa0$var$SyntheticSubmitEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$SubmitEventInterface), $081ef12b46fbcaa0$var$TouchEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $081ef12b46fbcaa0$var$getEventModifierState
}), $081ef12b46fbcaa0$var$SyntheticTouchEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$TouchEventInterface), $081ef12b46fbcaa0$var$TransitionEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $081ef12b46fbcaa0$var$SyntheticTransitionEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$TransitionEventInterface), $081ef12b46fbcaa0$var$WheelEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $081ef12b46fbcaa0$var$SyntheticWheelEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$WheelEventInterface), $081ef12b46fbcaa0$var$ToggleEventInterface = $081ef12b46fbcaa0$var$assign({}, $081ef12b46fbcaa0$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $081ef12b46fbcaa0$var$SyntheticToggleEvent = $081ef12b46fbcaa0$var$createSyntheticEvent($081ef12b46fbcaa0$var$ToggleEventInterface), $081ef12b46fbcaa0$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $081ef12b46fbcaa0$var$canUseCompositionEvent = $081ef12b46fbcaa0$var$canUseDOM && "CompositionEvent" in window, $081ef12b46fbcaa0$var$documentMode = null;
$081ef12b46fbcaa0$var$canUseDOM && "documentMode" in document && ($081ef12b46fbcaa0$var$documentMode = document.documentMode);
var $081ef12b46fbcaa0$var$canUseTextInputEvent = $081ef12b46fbcaa0$var$canUseDOM && "TextEvent" in window && !$081ef12b46fbcaa0$var$documentMode, $081ef12b46fbcaa0$var$useFallbackCompositionData = $081ef12b46fbcaa0$var$canUseDOM && (!$081ef12b46fbcaa0$var$canUseCompositionEvent || $081ef12b46fbcaa0$var$documentMode && 8 < $081ef12b46fbcaa0$var$documentMode && 11 >= $081ef12b46fbcaa0$var$documentMode), $081ef12b46fbcaa0$var$SPACEBAR_CHAR = String.fromCharCode(32), $081ef12b46fbcaa0$var$hasSpaceKeypress = !1;
function $081ef12b46fbcaa0$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $081ef12b46fbcaa0$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $081ef12b46fbcaa0$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $081ef12b46fbcaa0$var$isComposing = !1;
function $081ef12b46fbcaa0$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $081ef12b46fbcaa0$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $081ef12b46fbcaa0$var$hasSpaceKeypress = !0;
            return $081ef12b46fbcaa0$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $081ef12b46fbcaa0$var$SPACEBAR_CHAR && $081ef12b46fbcaa0$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $081ef12b46fbcaa0$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($081ef12b46fbcaa0$var$isComposing) return "compositionend" === domEventName || !$081ef12b46fbcaa0$var$canUseCompositionEvent && $081ef12b46fbcaa0$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $081ef12b46fbcaa0$var$getData(), $081ef12b46fbcaa0$var$fallbackText = $081ef12b46fbcaa0$var$startText = $081ef12b46fbcaa0$var$root = null, $081ef12b46fbcaa0$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $081ef12b46fbcaa0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $081ef12b46fbcaa0$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $081ef12b46fbcaa0$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$081ef12b46fbcaa0$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $081ef12b46fbcaa0$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $081ef12b46fbcaa0$var$restoreTarget ? $081ef12b46fbcaa0$var$restoreQueue ? $081ef12b46fbcaa0$var$restoreQueue.push(target) : $081ef12b46fbcaa0$var$restoreQueue = [
        target
    ] : $081ef12b46fbcaa0$var$restoreTarget = target;
    inst = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $081ef12b46fbcaa0$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $081ef12b46fbcaa0$var$activeElement$1 = null, $081ef12b46fbcaa0$var$activeElementInst$1 = null;
function $081ef12b46fbcaa0$var$runEventInBatch(dispatchQueue) {
    $081ef12b46fbcaa0$var$processDispatchQueue(dispatchQueue, 0);
}
function $081ef12b46fbcaa0$var$getInstIfValueChanged(targetInst) {
    var targetNode = $081ef12b46fbcaa0$var$getNodeFromInstance(targetInst);
    if ($081ef12b46fbcaa0$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $081ef12b46fbcaa0$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $081ef12b46fbcaa0$var$isInputEventSupported = !1;
if ($081ef12b46fbcaa0$var$canUseDOM) {
    var $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$318;
    if ($081ef12b46fbcaa0$var$canUseDOM) {
        var $081ef12b46fbcaa0$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$081ef12b46fbcaa0$var$isSupported$jscomp$inline_474) {
            var $081ef12b46fbcaa0$var$element$jscomp$inline_475 = document.createElement("div");
            $081ef12b46fbcaa0$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $081ef12b46fbcaa0$var$isSupported$jscomp$inline_474 = "function" === typeof $081ef12b46fbcaa0$var$element$jscomp$inline_475.oninput;
        }
        $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$318 = $081ef12b46fbcaa0$var$isSupported$jscomp$inline_474;
    } else $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$318 = !1;
    $081ef12b46fbcaa0$var$isInputEventSupported = $081ef12b46fbcaa0$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $081ef12b46fbcaa0$var$stopWatchingForValueChange() {
    $081ef12b46fbcaa0$var$activeElement$1 && ($081ef12b46fbcaa0$var$activeElement$1.detachEvent("onpropertychange", $081ef12b46fbcaa0$var$handlePropertyChange), $081ef12b46fbcaa0$var$activeElementInst$1 = $081ef12b46fbcaa0$var$activeElement$1 = null);
}
function $081ef12b46fbcaa0$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $081ef12b46fbcaa0$var$getInstIfValueChanged($081ef12b46fbcaa0$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $081ef12b46fbcaa0$var$createAndAccumulateChangeEvent(dispatchQueue, $081ef12b46fbcaa0$var$activeElementInst$1, nativeEvent, $081ef12b46fbcaa0$var$getEventTarget(nativeEvent));
        $081ef12b46fbcaa0$var$batchedUpdates$1($081ef12b46fbcaa0$var$runEventInBatch, dispatchQueue);
    }
}
function $081ef12b46fbcaa0$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($081ef12b46fbcaa0$var$stopWatchingForValueChange(), $081ef12b46fbcaa0$var$activeElement$1 = target, $081ef12b46fbcaa0$var$activeElementInst$1 = targetInst, $081ef12b46fbcaa0$var$activeElement$1.attachEvent("onpropertychange", $081ef12b46fbcaa0$var$handlePropertyChange)) : "focusout" === domEventName && $081ef12b46fbcaa0$var$stopWatchingForValueChange();
}
function $081ef12b46fbcaa0$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $081ef12b46fbcaa0$var$getInstIfValueChanged($081ef12b46fbcaa0$var$activeElementInst$1);
}
function $081ef12b46fbcaa0$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $081ef12b46fbcaa0$var$getInstIfValueChanged(targetInst);
}
function $081ef12b46fbcaa0$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $081ef12b46fbcaa0$var$getInstIfValueChanged(targetInst);
}
function $081ef12b46fbcaa0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $081ef12b46fbcaa0$var$objectIs = "function" === typeof Object.is ? Object.is : $081ef12b46fbcaa0$var$is;
function $081ef12b46fbcaa0$var$shallowEqual(objA, objB) {
    if ($081ef12b46fbcaa0$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$081ef12b46fbcaa0$var$hasOwnProperty.call(objB, currentKey) || !$081ef12b46fbcaa0$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $081ef12b46fbcaa0$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $081ef12b46fbcaa0$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $081ef12b46fbcaa0$var$getNodeForCharacterOffset(root, offset) {
    var node = $081ef12b46fbcaa0$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $081ef12b46fbcaa0$var$getLeafNode(node);
    }
}
function $081ef12b46fbcaa0$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $081ef12b46fbcaa0$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $081ef12b46fbcaa0$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $081ef12b46fbcaa0$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $081ef12b46fbcaa0$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $081ef12b46fbcaa0$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $081ef12b46fbcaa0$var$skipSelectionChangeEvent = $081ef12b46fbcaa0$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $081ef12b46fbcaa0$var$activeElement = null, $081ef12b46fbcaa0$var$activeElementInst = null, $081ef12b46fbcaa0$var$lastSelection = null, $081ef12b46fbcaa0$var$mouseDown = !1;
function $081ef12b46fbcaa0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $081ef12b46fbcaa0$var$mouseDown || null == $081ef12b46fbcaa0$var$activeElement || $081ef12b46fbcaa0$var$activeElement !== $081ef12b46fbcaa0$var$getActiveElement(doc) || (doc = $081ef12b46fbcaa0$var$activeElement, "selectionStart" in doc && $081ef12b46fbcaa0$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $081ef12b46fbcaa0$var$lastSelection && $081ef12b46fbcaa0$var$shallowEqual($081ef12b46fbcaa0$var$lastSelection, doc) || ($081ef12b46fbcaa0$var$lastSelection = doc, doc = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners($081ef12b46fbcaa0$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $081ef12b46fbcaa0$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $081ef12b46fbcaa0$var$activeElement)));
}
function $081ef12b46fbcaa0$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $081ef12b46fbcaa0$var$vendorPrefixes = {
    animationend: $081ef12b46fbcaa0$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $081ef12b46fbcaa0$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $081ef12b46fbcaa0$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $081ef12b46fbcaa0$var$makePrefixMap("Transition", "TransitionEnd")
}, $081ef12b46fbcaa0$var$prefixedEventNames = {}, $081ef12b46fbcaa0$var$style = {};
$081ef12b46fbcaa0$var$canUseDOM && ($081ef12b46fbcaa0$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $081ef12b46fbcaa0$var$vendorPrefixes.animationend.animation, delete $081ef12b46fbcaa0$var$vendorPrefixes.animationiteration.animation, delete $081ef12b46fbcaa0$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $081ef12b46fbcaa0$var$vendorPrefixes.transitionend.transition);
function $081ef12b46fbcaa0$var$getVendorPrefixedEventName(eventName) {
    if ($081ef12b46fbcaa0$var$prefixedEventNames[eventName]) return $081ef12b46fbcaa0$var$prefixedEventNames[eventName];
    if (!$081ef12b46fbcaa0$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $081ef12b46fbcaa0$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $081ef12b46fbcaa0$var$style) return $081ef12b46fbcaa0$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $081ef12b46fbcaa0$var$ANIMATION_END = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("animationend"), $081ef12b46fbcaa0$var$ANIMATION_ITERATION = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("animationiteration"), $081ef12b46fbcaa0$var$ANIMATION_START = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("animationstart"), $081ef12b46fbcaa0$var$TRANSITION_RUN = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitionrun"), $081ef12b46fbcaa0$var$TRANSITION_START = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitionstart"), $081ef12b46fbcaa0$var$TRANSITION_CANCEL = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitioncancel"), $081ef12b46fbcaa0$var$TRANSITION_END = $081ef12b46fbcaa0$var$getVendorPrefixedEventName("transitionend"), $081ef12b46fbcaa0$var$topLevelEventsToReactNames = new Map(), $081ef12b46fbcaa0$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$081ef12b46fbcaa0$var$simpleEventPluginEvents.push("scrollEnd");
function $081ef12b46fbcaa0$var$registerSimpleEvent(domEventName, reactName) {
    $081ef12b46fbcaa0$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $081ef12b46fbcaa0$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $081ef12b46fbcaa0$var$globalClientIdCounter$1 = 0;
function $081ef12b46fbcaa0$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $081ef12b46fbcaa0$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $081ef12b46fbcaa0$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $081ef12b46fbcaa0$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $081ef12b46fbcaa0$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $081ef12b46fbcaa0$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $081ef12b46fbcaa0$var$getClassNameByType(defaultClass);
    eventClass = $081ef12b46fbcaa0$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $081ef12b46fbcaa0$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $081ef12b46fbcaa0$var$concurrentQueues = [], $081ef12b46fbcaa0$var$concurrentQueuesIndex = 0, $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes = 0;
function $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $081ef12b46fbcaa0$var$concurrentQueuesIndex, i = $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes = $081ef12b46fbcaa0$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        var queue = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        var update = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        var lane = $081ef12b46fbcaa0$var$concurrentQueues[i];
        $081ef12b46fbcaa0$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $081ef12b46fbcaa0$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = fiber;
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = queue;
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = update;
    $081ef12b46fbcaa0$var$concurrentQueues[$081ef12b46fbcaa0$var$concurrentQueuesIndex++] = lane;
    $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
}
function $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, null, null, lane);
    return $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
}
function $081ef12b46fbcaa0$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $081ef12b46fbcaa0$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $081ef12b46fbcaa0$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $081ef12b46fbcaa0$var$nestedUpdateCount) throw $081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = null, Error($081ef12b46fbcaa0$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $081ef12b46fbcaa0$var$emptyContextObject = {};
function $081ef12b46fbcaa0$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $081ef12b46fbcaa0$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $081ef12b46fbcaa0$var$FiberNode(tag, pendingProps, key, mode);
}
function $081ef12b46fbcaa0$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $081ef12b46fbcaa0$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $081ef12b46fbcaa0$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $081ef12b46fbcaa0$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $081ef12b46fbcaa0$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $081ef12b46fbcaa0$var$isHostHoistableType(type, pendingProps, $081ef12b46fbcaa0$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $081ef12b46fbcaa0$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE:
            return $081ef12b46fbcaa0$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $081ef12b46fbcaa0$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $081ef12b46fbcaa0$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $081ef12b46fbcaa0$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $081ef12b46fbcaa0$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $081ef12b46fbcaa0$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $081ef12b46fbcaa0$var$REACT_LEGACY_HIDDEN_TYPE:
        case $081ef12b46fbcaa0$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $081ef12b46fbcaa0$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $081ef12b46fbcaa0$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $081ef12b46fbcaa0$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $081ef12b46fbcaa0$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $081ef12b46fbcaa0$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $081ef12b46fbcaa0$var$createFiberFromText(content, mode, lanes) {
    content = $081ef12b46fbcaa0$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $081ef12b46fbcaa0$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $081ef12b46fbcaa0$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $081ef12b46fbcaa0$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $081ef12b46fbcaa0$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $081ef12b46fbcaa0$var$CapturedStacks = new WeakMap();
function $081ef12b46fbcaa0$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $081ef12b46fbcaa0$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $081ef12b46fbcaa0$var$getStackByFiberInDevAndProd(source)
        };
        $081ef12b46fbcaa0$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $081ef12b46fbcaa0$var$getStackByFiberInDevAndProd(source)
    };
}
var $081ef12b46fbcaa0$var$forkStack = [], $081ef12b46fbcaa0$var$forkStackIndex = 0, $081ef12b46fbcaa0$var$treeForkProvider = null, $081ef12b46fbcaa0$var$treeForkCount = 0, $081ef12b46fbcaa0$var$idStack = [], $081ef12b46fbcaa0$var$idStackIndex = 0, $081ef12b46fbcaa0$var$treeContextProvider = null, $081ef12b46fbcaa0$var$treeContextId = 1, $081ef12b46fbcaa0$var$treeContextOverflow = "";
function $081ef12b46fbcaa0$var$pushTreeFork(workInProgress, totalChildren) {
    $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex++] = $081ef12b46fbcaa0$var$treeForkCount;
    $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex++] = $081ef12b46fbcaa0$var$treeForkProvider;
    $081ef12b46fbcaa0$var$treeForkProvider = workInProgress;
    $081ef12b46fbcaa0$var$treeForkCount = totalChildren;
}
function $081ef12b46fbcaa0$var$pushTreeId(workInProgress, totalChildren, index) {
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextId;
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextOverflow;
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextProvider;
    $081ef12b46fbcaa0$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $081ef12b46fbcaa0$var$treeContextId;
    workInProgress = $081ef12b46fbcaa0$var$treeContextOverflow;
    var baseLength = 32 - $081ef12b46fbcaa0$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $081ef12b46fbcaa0$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $081ef12b46fbcaa0$var$treeContextId = 1 << 32 - $081ef12b46fbcaa0$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $081ef12b46fbcaa0$var$treeContextOverflow = length + workInProgress;
    } else $081ef12b46fbcaa0$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $081ef12b46fbcaa0$var$treeContextOverflow = workInProgress;
}
function $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($081ef12b46fbcaa0$var$pushTreeFork(workInProgress, 1), $081ef12b46fbcaa0$var$pushTreeId(workInProgress, 1, 0));
}
function $081ef12b46fbcaa0$var$popTreeContext(workInProgress) {
    for(; workInProgress === $081ef12b46fbcaa0$var$treeForkProvider;)$081ef12b46fbcaa0$var$treeForkProvider = $081ef12b46fbcaa0$var$forkStack[--$081ef12b46fbcaa0$var$forkStackIndex], $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex] = null, $081ef12b46fbcaa0$var$treeForkCount = $081ef12b46fbcaa0$var$forkStack[--$081ef12b46fbcaa0$var$forkStackIndex], $081ef12b46fbcaa0$var$forkStack[$081ef12b46fbcaa0$var$forkStackIndex] = null;
    for(; workInProgress === $081ef12b46fbcaa0$var$treeContextProvider;)$081ef12b46fbcaa0$var$treeContextProvider = $081ef12b46fbcaa0$var$idStack[--$081ef12b46fbcaa0$var$idStackIndex], $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex] = null, $081ef12b46fbcaa0$var$treeContextOverflow = $081ef12b46fbcaa0$var$idStack[--$081ef12b46fbcaa0$var$idStackIndex], $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex] = null, $081ef12b46fbcaa0$var$treeContextId = $081ef12b46fbcaa0$var$idStack[--$081ef12b46fbcaa0$var$idStackIndex], $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex] = null;
}
function $081ef12b46fbcaa0$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextId;
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextOverflow;
    $081ef12b46fbcaa0$var$idStack[$081ef12b46fbcaa0$var$idStackIndex++] = $081ef12b46fbcaa0$var$treeContextProvider;
    $081ef12b46fbcaa0$var$treeContextId = suspendedContext.id;
    $081ef12b46fbcaa0$var$treeContextOverflow = suspendedContext.overflow;
    $081ef12b46fbcaa0$var$treeContextProvider = workInProgress;
}
var $081ef12b46fbcaa0$var$hydrationParentFiber = null, $081ef12b46fbcaa0$var$nextHydratableInstance = null, $081ef12b46fbcaa0$var$isHydrating = !1, $081ef12b46fbcaa0$var$hydrationErrors = null, $081ef12b46fbcaa0$var$rootOrSingletonContext = !1, $081ef12b46fbcaa0$var$HydrationMismatchException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(519));
function $081ef12b46fbcaa0$var$throwOnHydrationMismatch(fiber) {
    var error = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $081ef12b46fbcaa0$var$queueHydrationError($081ef12b46fbcaa0$var$createCapturedValueAtFiber(error, fiber));
    throw $081ef12b46fbcaa0$var$HydrationMismatchException;
}
function $081ef12b46fbcaa0$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$081ef12b46fbcaa0$var$internalInstanceKey] = fiber;
    instance[$081ef12b46fbcaa0$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("cancel", instance);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $081ef12b46fbcaa0$var$mediaEventTypes.length; type++)$081ef12b46fbcaa0$var$listenToNonDelegatedEvent($081ef12b46fbcaa0$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", instance);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", instance);
            $081ef12b46fbcaa0$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", instance), $081ef12b46fbcaa0$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $081ef12b46fbcaa0$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($081ef12b46fbcaa0$var$listenToNonDelegatedEvent("beforetoggle", instance), $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $081ef12b46fbcaa0$var$noop$1), instance = !0) : instance = !1;
    instance || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(fiber, !0);
}
function $081ef12b46fbcaa0$var$popToNextHostParent(fiber) {
    for($081ef12b46fbcaa0$var$hydrationParentFiber = fiber.return; $081ef12b46fbcaa0$var$hydrationParentFiber;)switch($081ef12b46fbcaa0$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $081ef12b46fbcaa0$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $081ef12b46fbcaa0$var$rootOrSingletonContext = !0;
            return;
        default:
            $081ef12b46fbcaa0$var$hydrationParentFiber = $081ef12b46fbcaa0$var$hydrationParentFiber.return;
    }
}
function $081ef12b46fbcaa0$var$popHydrationState(fiber) {
    if (fiber !== $081ef12b46fbcaa0$var$hydrationParentFiber) return !1;
    if (!$081ef12b46fbcaa0$var$isHydrating) return $081ef12b46fbcaa0$var$popToNextHostParent(fiber), $081ef12b46fbcaa0$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $081ef12b46fbcaa0$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $081ef12b46fbcaa0$var$nextHydratableInstance && $081ef12b46fbcaa0$var$throwOnHydrationMismatch(fiber);
    $081ef12b46fbcaa0$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(317));
        $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(317));
        $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $081ef12b46fbcaa0$var$nextHydratableInstance, $081ef12b46fbcaa0$var$isSingletonScope(fiber.type) ? (fiber = $081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton, $081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton = null, $081ef12b46fbcaa0$var$nextHydratableInstance = fiber) : $081ef12b46fbcaa0$var$nextHydratableInstance = tag) : $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$hydrationParentFiber ? $081ef12b46fbcaa0$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $081ef12b46fbcaa0$var$resetHydrationState() {
    $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$hydrationParentFiber = null;
    $081ef12b46fbcaa0$var$isHydrating = !1;
}
function $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $081ef12b46fbcaa0$var$hydrationErrors;
    null !== queuedErrors && (null === $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors ? $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = queuedErrors : $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors.push.apply($081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, queuedErrors), $081ef12b46fbcaa0$var$hydrationErrors = null);
    return queuedErrors;
}
function $081ef12b46fbcaa0$var$queueHydrationError(error) {
    null === $081ef12b46fbcaa0$var$hydrationErrors ? $081ef12b46fbcaa0$var$hydrationErrors = [
        error
    ] : $081ef12b46fbcaa0$var$hydrationErrors.push(error);
}
var $081ef12b46fbcaa0$var$valueCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null, $081ef12b46fbcaa0$var$lastContextDependency = null;
function $081ef12b46fbcaa0$var$pushProvider(providerFiber, context, nextValue) {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $081ef12b46fbcaa0$var$popProvider(context) {
    context._currentValue = $081ef12b46fbcaa0$var$valueCursor.current;
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$valueCursor);
}
function $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $081ef12b46fbcaa0$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $081ef12b46fbcaa0$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($081ef12b46fbcaa0$var$HostTransitionContext) : current = [
                $081ef12b46fbcaa0$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $081ef12b46fbcaa0$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$081ef12b46fbcaa0$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = workInProgress;
    $081ef12b46fbcaa0$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $081ef12b46fbcaa0$var$readContext(context) {
    return $081ef12b46fbcaa0$var$readContextForConsumer($081ef12b46fbcaa0$var$currentlyRenderingFiber$1, context);
}
function $081ef12b46fbcaa0$var$readContextDuringReconciliation(consumer, context) {
    null === $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 && $081ef12b46fbcaa0$var$prepareToReadContext(consumer);
    return $081ef12b46fbcaa0$var$readContextForConsumer(consumer, context);
}
function $081ef12b46fbcaa0$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $081ef12b46fbcaa0$var$lastContextDependency) {
        if (null === consumer) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(308));
        $081ef12b46fbcaa0$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$lastContextDependency.next = context;
    return value;
}
var $081ef12b46fbcaa0$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $081ef12b46fbcaa0$var$scheduleCallback$2 = $fndEB.unstable_scheduleCallback, $081ef12b46fbcaa0$var$NormalPriority = $fndEB.unstable_NormalPriority, $081ef12b46fbcaa0$var$CacheContext = {
    $$typeof: $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $081ef12b46fbcaa0$var$createCache() {
    return {
        controller: new $081ef12b46fbcaa0$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $081ef12b46fbcaa0$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $081ef12b46fbcaa0$var$scheduleCallback$2($081ef12b46fbcaa0$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $081ef12b46fbcaa0$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $081ef12b46fbcaa0$var$entangledTransitionTypes = null;
function $081ef12b46fbcaa0$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $081ef12b46fbcaa0$var$currentEntangledListeners = null, $081ef12b46fbcaa0$var$currentEntangledPendingCount = 0, $081ef12b46fbcaa0$var$currentEntangledLane = 0, $081ef12b46fbcaa0$var$currentEntangledActionThenable = null;
function $081ef12b46fbcaa0$var$entangleAsyncAction(transition, thenable) {
    if (null === $081ef12b46fbcaa0$var$currentEntangledListeners) {
        var entangledListeners = $081ef12b46fbcaa0$var$currentEntangledListeners = [];
        $081ef12b46fbcaa0$var$currentEntangledPendingCount = 0;
        $081ef12b46fbcaa0$var$currentEntangledLane = $081ef12b46fbcaa0$var$requestTransitionLane();
        $081ef12b46fbcaa0$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $081ef12b46fbcaa0$var$currentEntangledPendingCount++;
    thenable.then($081ef12b46fbcaa0$var$pingEngtangledActionScope, $081ef12b46fbcaa0$var$pingEngtangledActionScope);
    return thenable;
}
function $081ef12b46fbcaa0$var$pingEngtangledActionScope() {
    if (0 === --$081ef12b46fbcaa0$var$currentEntangledPendingCount && ($081ef12b46fbcaa0$var$entangledTransitionTypes = null, null !== $081ef12b46fbcaa0$var$currentEntangledListeners)) {
        null !== $081ef12b46fbcaa0$var$currentEntangledActionThenable && ($081ef12b46fbcaa0$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $081ef12b46fbcaa0$var$currentEntangledListeners;
        $081ef12b46fbcaa0$var$currentEntangledListeners = null;
        $081ef12b46fbcaa0$var$currentEntangledLane = 0;
        $081ef12b46fbcaa0$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $081ef12b46fbcaa0$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $081ef12b46fbcaa0$var$prevOnStartTransitionFinish = $081ef12b46fbcaa0$var$ReactSharedInternals.S;
$081ef12b46fbcaa0$var$ReactSharedInternals.S = function(transition, returnValue) {
    $081ef12b46fbcaa0$var$globalMostRecentTransitionTime = $081ef12b46fbcaa0$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $081ef12b46fbcaa0$var$entangleAsyncAction(transition, returnValue);
    if (null !== $081ef12b46fbcaa0$var$entangledTransitionTypes) for(var root$28 = $081ef12b46fbcaa0$var$firstScheduledRoot; null !== root$28;)$081ef12b46fbcaa0$var$queueTransitionTypes(root$28, $081ef12b46fbcaa0$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $081ef12b46fbcaa0$var$firstScheduledRoot; null !== root$29;)$081ef12b46fbcaa0$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $081ef12b46fbcaa0$var$currentEntangledLane) {
            root$29 = $081ef12b46fbcaa0$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $081ef12b46fbcaa0$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $081ef12b46fbcaa0$var$prevOnStartTransitionFinish && $081ef12b46fbcaa0$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $081ef12b46fbcaa0$var$resumedCache = $081ef12b46fbcaa0$var$createCursor(null);
function $081ef12b46fbcaa0$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $081ef12b46fbcaa0$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $081ef12b46fbcaa0$var$workInProgressRoot.pooledCache;
}
function $081ef12b46fbcaa0$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$resumedCache, $081ef12b46fbcaa0$var$resumedCache.current) : $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$resumedCache, prevCachePool.pool);
}
function $081ef12b46fbcaa0$var$getSuspendedCache() {
    var cacheFromPool = $081ef12b46fbcaa0$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $081ef12b46fbcaa0$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $081ef12b46fbcaa0$var$SuspenseException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(460)), $081ef12b46fbcaa0$var$SuspenseyCommitException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(474)), $081ef12b46fbcaa0$var$SuspenseActionException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(542)), $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $081ef12b46fbcaa0$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $081ef12b46fbcaa0$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($081ef12b46fbcaa0$var$noop$1, $081ef12b46fbcaa0$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $081ef12b46fbcaa0$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($081ef12b46fbcaa0$var$noop$1, $081ef12b46fbcaa0$var$noop$1);
            else {
                thenableState = $081ef12b46fbcaa0$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $081ef12b46fbcaa0$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $081ef12b46fbcaa0$var$suspendedThenable = thenable;
            throw $081ef12b46fbcaa0$var$SuspenseException;
    }
}
function $081ef12b46fbcaa0$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $081ef12b46fbcaa0$var$suspendedThenable = x, $081ef12b46fbcaa0$var$SuspenseException;
        throw x;
    }
}
var $081ef12b46fbcaa0$var$suspendedThenable = null;
function $081ef12b46fbcaa0$var$getSuspendedThenable() {
    if (null === $081ef12b46fbcaa0$var$suspendedThenable) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(459));
    var thenable = $081ef12b46fbcaa0$var$suspendedThenable;
    $081ef12b46fbcaa0$var$suspendedThenable = null;
    return thenable;
}
function $081ef12b46fbcaa0$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $081ef12b46fbcaa0$var$SuspenseException || rejectedReason === $081ef12b46fbcaa0$var$SuspenseActionException) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(483));
}
var $081ef12b46fbcaa0$var$thenableState$1 = null, $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0;
function $081ef12b46fbcaa0$var$unwrapThenable(thenable) {
    var index = $081ef12b46fbcaa0$var$thenableIndexCounter$1;
    $081ef12b46fbcaa0$var$thenableIndexCounter$1 += 1;
    null === $081ef12b46fbcaa0$var$thenableState$1 && ($081ef12b46fbcaa0$var$thenableState$1 = []);
    return $081ef12b46fbcaa0$var$trackUsedThenable($081ef12b46fbcaa0$var$thenableState$1, thenable, index);
}
function $081ef12b46fbcaa0$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $081ef12b46fbcaa0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $081ef12b46fbcaa0$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $081ef12b46fbcaa0$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $081ef12b46fbcaa0$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $081ef12b46fbcaa0$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $081ef12b46fbcaa0$var$REACT_LAZY_TYPE && $081ef12b46fbcaa0$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $081ef12b46fbcaa0$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $081ef12b46fbcaa0$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $081ef12b46fbcaa0$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $081ef12b46fbcaa0$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $081ef12b46fbcaa0$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    return lanes = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $081ef12b46fbcaa0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    return newChild = $081ef12b46fbcaa0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    return newChild = $081ef12b46fbcaa0$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild) || $081ef12b46fbcaa0$var$getIteratorFn(newChild)) return newChild = $081ef12b46fbcaa0$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    return newChild = $081ef12b46fbcaa0$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild) || $081ef12b46fbcaa0$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    return newChild = $081ef12b46fbcaa0$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild) || $081ef12b46fbcaa0$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $081ef12b46fbcaa0$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $081ef12b46fbcaa0$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $081ef12b46fbcaa0$var$REACT_LAZY_TYPE && $081ef12b46fbcaa0$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $081ef12b46fbcaa0$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $081ef12b46fbcaa0$var$REACT_FRAGMENT_TYPE ? (lanes = $081ef12b46fbcaa0$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $081ef12b46fbcaa0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $081ef12b46fbcaa0$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $081ef12b46fbcaa0$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $081ef12b46fbcaa0$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $081ef12b46fbcaa0$var$REACT_LAZY_TYPE:
                    return newChild = $081ef12b46fbcaa0$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($081ef12b46fbcaa0$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($081ef12b46fbcaa0$var$getIteratorFn(newChild)) {
                key = $081ef12b46fbcaa0$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $081ef12b46fbcaa0$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $081ef12b46fbcaa0$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $081ef12b46fbcaa0$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $081ef12b46fbcaa0$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $081ef12b46fbcaa0$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $081ef12b46fbcaa0$var$SuspenseException || x === $081ef12b46fbcaa0$var$SuspenseActionException) throw x;
            var fiber = $081ef12b46fbcaa0$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $081ef12b46fbcaa0$var$reconcileChildFibers = $081ef12b46fbcaa0$var$createChildReconciler(!0), $081ef12b46fbcaa0$var$mountChildFibers = $081ef12b46fbcaa0$var$createChildReconciler(!1), $081ef12b46fbcaa0$var$hasForceUpdate = !1;
function $081ef12b46fbcaa0$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $081ef12b46fbcaa0$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $081ef12b46fbcaa0$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
        $081ef12b46fbcaa0$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $081ef12b46fbcaa0$var$getRootForUpdatedFiber(fiber);
}
function $081ef12b46fbcaa0$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $081ef12b46fbcaa0$var$markRootEntangled(root, lane);
    }
}
function $081ef12b46fbcaa0$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction = !1;
function $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $081ef12b46fbcaa0$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $081ef12b46fbcaa0$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $081ef12b46fbcaa0$var$currentEntangledLane && ($081ef12b46fbcaa0$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $081ef12b46fbcaa0$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $081ef12b46fbcaa0$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $081ef12b46fbcaa0$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $081ef12b46fbcaa0$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$081ef12b46fbcaa0$var$callCallback(callbacks[updateQueue], context);
}
var $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor = $081ef12b46fbcaa0$var$createCursor(0);
function $081ef12b46fbcaa0$var$pushHiddenContext(fiber, context) {
    fiber = $081ef12b46fbcaa0$var$entangledRenderLanes;
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor, fiber);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$currentTreeHiddenStackCursor, context);
    $081ef12b46fbcaa0$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $081ef12b46fbcaa0$var$reuseHiddenContextOnStack() {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor, $081ef12b46fbcaa0$var$entangledRenderLanes);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$currentTreeHiddenStackCursor, $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current);
}
function $081ef12b46fbcaa0$var$popHiddenContext() {
    $081ef12b46fbcaa0$var$entangledRenderLanes = $081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor.current;
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$currentTreeHiddenStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$prevEntangledRenderLanesCursor);
}
var $081ef12b46fbcaa0$var$suspenseHandlerStackCursor = $081ef12b46fbcaa0$var$createCursor(null), $081ef12b46fbcaa0$var$shellBoundary = null;
function $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current & 1);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, handler);
    null === $081ef12b46fbcaa0$var$shellBoundary && (null === current || null !== $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current ? $081ef12b46fbcaa0$var$shellBoundary = handler : null !== current.memoizedState && ($081ef12b46fbcaa0$var$shellBoundary = handler));
}
function $081ef12b46fbcaa0$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, fiber);
    null === $081ef12b46fbcaa0$var$shellBoundary && ($081ef12b46fbcaa0$var$shellBoundary = fiber);
}
function $081ef12b46fbcaa0$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current), $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, fiber), null === $081ef12b46fbcaa0$var$shellBoundary && ($081ef12b46fbcaa0$var$shellBoundary = fiber)) : $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack();
}
function $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack() {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, $081ef12b46fbcaa0$var$suspenseStackCursor.current);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current);
}
function $081ef12b46fbcaa0$var$popSuspenseHandler(fiber) {
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseHandlerStackCursor);
    $081ef12b46fbcaa0$var$shellBoundary === fiber && ($081ef12b46fbcaa0$var$shellBoundary = null);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseStackCursor);
}
var $081ef12b46fbcaa0$var$suspenseStackCursor = $081ef12b46fbcaa0$var$createCursor(0);
function $081ef12b46fbcaa0$var$pushSuspenseListContext(fiber, newContext) {
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current);
    $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, newContext);
}
function $081ef12b46fbcaa0$var$popSuspenseListContext(fiber) {
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseStackCursor);
    $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$suspenseHandlerStackCursor);
    $081ef12b46fbcaa0$var$shellBoundary === fiber && ($081ef12b46fbcaa0$var$shellBoundary = null);
}
function $081ef12b46fbcaa0$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $081ef12b46fbcaa0$var$isSuspenseInstancePending(state) || $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $081ef12b46fbcaa0$var$renderLanes = 0, $081ef12b46fbcaa0$var$currentlyRenderingFiber = null, $081ef12b46fbcaa0$var$currentHook = null, $081ef12b46fbcaa0$var$workInProgressHook = null, $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !1, $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $081ef12b46fbcaa0$var$localIdCounter = 0, $081ef12b46fbcaa0$var$thenableIndexCounter = 0, $081ef12b46fbcaa0$var$thenableState = null, $081ef12b46fbcaa0$var$globalClientIdCounter = 0;
function $081ef12b46fbcaa0$var$throwInvalidHookError() {
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(321));
}
function $081ef12b46fbcaa0$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$081ef12b46fbcaa0$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $081ef12b46fbcaa0$var$renderLanes = nextRenderLanes;
    $081ef12b46fbcaa0$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $081ef12b46fbcaa0$var$HooksDispatcherOnMount : $081ef12b46fbcaa0$var$HooksDispatcherOnUpdate;
    $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $081ef12b46fbcaa0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $081ef12b46fbcaa0$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $081ef12b46fbcaa0$var$finishRenderingHooks(current) {
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $081ef12b46fbcaa0$var$currentHook && null !== $081ef12b46fbcaa0$var$currentHook.next;
    $081ef12b46fbcaa0$var$renderLanes = 0;
    $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$currentHook = $081ef12b46fbcaa0$var$currentlyRenderingFiber = null;
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !1;
    $081ef12b46fbcaa0$var$thenableIndexCounter = 0;
    $081ef12b46fbcaa0$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(300));
    null === current || $081ef12b46fbcaa0$var$didReceiveUpdate || (current = current.dependencies, null !== current && $081ef12b46fbcaa0$var$checkIfContextChanged(current) && ($081ef12b46fbcaa0$var$didReceiveUpdate = !0));
}
function $081ef12b46fbcaa0$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass && ($081ef12b46fbcaa0$var$thenableState = null);
        $081ef12b46fbcaa0$var$thenableIndexCounter = 0;
        $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $081ef12b46fbcaa0$var$TransitionAwareHostComponent() {
    var dispatcher = $081ef12b46fbcaa0$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $081ef12b46fbcaa0$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $081ef12b46fbcaa0$var$currentHook ? $081ef12b46fbcaa0$var$currentHook.memoizedState : null) !== dispatcher && ($081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $081ef12b46fbcaa0$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $081ef12b46fbcaa0$var$localIdCounter;
    $081ef12b46fbcaa0$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $081ef12b46fbcaa0$var$resetHooksOnUnwind(workInProgress) {
    if ($081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !1;
    }
    $081ef12b46fbcaa0$var$renderLanes = 0;
    $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$currentHook = $081ef12b46fbcaa0$var$currentlyRenderingFiber = null;
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $081ef12b46fbcaa0$var$thenableIndexCounter = $081ef12b46fbcaa0$var$localIdCounter = 0;
    $081ef12b46fbcaa0$var$thenableState = null;
}
function $081ef12b46fbcaa0$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $081ef12b46fbcaa0$var$workInProgressHook ? $081ef12b46fbcaa0$var$currentlyRenderingFiber.memoizedState = $081ef12b46fbcaa0$var$workInProgressHook = hook : $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$workInProgressHook.next = hook;
    return $081ef12b46fbcaa0$var$workInProgressHook;
}
function $081ef12b46fbcaa0$var$updateWorkInProgressHook() {
    if (null === $081ef12b46fbcaa0$var$currentHook) {
        var nextCurrentHook = $081ef12b46fbcaa0$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $081ef12b46fbcaa0$var$currentHook.next;
    var nextWorkInProgressHook = null === $081ef12b46fbcaa0$var$workInProgressHook ? $081ef12b46fbcaa0$var$currentlyRenderingFiber.memoizedState : $081ef12b46fbcaa0$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $081ef12b46fbcaa0$var$workInProgressHook = nextWorkInProgressHook, $081ef12b46fbcaa0$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $081ef12b46fbcaa0$var$currentlyRenderingFiber.alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(467));
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(310));
        }
        $081ef12b46fbcaa0$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $081ef12b46fbcaa0$var$currentHook.memoizedState,
            baseState: $081ef12b46fbcaa0$var$currentHook.baseState,
            baseQueue: $081ef12b46fbcaa0$var$currentHook.baseQueue,
            queue: $081ef12b46fbcaa0$var$currentHook.queue,
            next: null
        };
        null === $081ef12b46fbcaa0$var$workInProgressHook ? $081ef12b46fbcaa0$var$currentlyRenderingFiber.memoizedState = $081ef12b46fbcaa0$var$workInProgressHook = nextCurrentHook : $081ef12b46fbcaa0$var$workInProgressHook = $081ef12b46fbcaa0$var$workInProgressHook.next = nextCurrentHook;
    }
    return $081ef12b46fbcaa0$var$workInProgressHook;
}
function $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $081ef12b46fbcaa0$var$useThenable(thenable) {
    var index = $081ef12b46fbcaa0$var$thenableIndexCounter;
    $081ef12b46fbcaa0$var$thenableIndexCounter += 1;
    null === $081ef12b46fbcaa0$var$thenableState && ($081ef12b46fbcaa0$var$thenableState = []);
    thenable = $081ef12b46fbcaa0$var$trackUsedThenable($081ef12b46fbcaa0$var$thenableState, thenable, index);
    index = $081ef12b46fbcaa0$var$currentlyRenderingFiber;
    null === (null === $081ef12b46fbcaa0$var$workInProgressHook ? index.memoizedState : $081ef12b46fbcaa0$var$workInProgressHook.next) && (index = index.alternate, $081ef12b46fbcaa0$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $081ef12b46fbcaa0$var$HooksDispatcherOnMount : $081ef12b46fbcaa0$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $081ef12b46fbcaa0$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $081ef12b46fbcaa0$var$useThenable(usable);
        if (usable.$$typeof === $081ef12b46fbcaa0$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) return $081ef12b46fbcaa0$var$readContext(usable);
    }
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(438, String(usable)));
}
function $081ef12b46fbcaa0$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $081ef12b46fbcaa0$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $081ef12b46fbcaa0$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $081ef12b46fbcaa0$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $081ef12b46fbcaa0$var$updateReducer(reducer) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    return $081ef12b46fbcaa0$var$updateReducerImpl(hook, $081ef12b46fbcaa0$var$currentHook, reducer);
}
function $081ef12b46fbcaa0$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($081ef12b46fbcaa0$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $081ef12b46fbcaa0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($081ef12b46fbcaa0$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $081ef12b46fbcaa0$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= revertLane, $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= updateLane, $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$081ef12b46fbcaa0$var$objectIs(pendingQueue, hook.memoizedState) && ($081ef12b46fbcaa0$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $081ef12b46fbcaa0$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $081ef12b46fbcaa0$var$rerenderReducer(reducer) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $081ef12b46fbcaa0$var$objectIs(newState, hook.memoizedState) || ($081ef12b46fbcaa0$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $081ef12b46fbcaa0$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $081ef12b46fbcaa0$var$currentlyRenderingFiber, hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $081ef12b46fbcaa0$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$081ef12b46fbcaa0$var$objectIs(($081ef12b46fbcaa0$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $081ef12b46fbcaa0$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $081ef12b46fbcaa0$var$updateEffect($081ef12b46fbcaa0$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $081ef12b46fbcaa0$var$workInProgressHook && 0 !== ($081ef12b46fbcaa0$var$workInProgressHook.memoizedState.tag & 1);
    $081ef12b46fbcaa0$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $081ef12b46fbcaa0$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $081ef12b46fbcaa0$var$workInProgressRoot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($081ef12b46fbcaa0$var$renderLanes & 127) || $081ef12b46fbcaa0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $081ef12b46fbcaa0$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $081ef12b46fbcaa0$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $081ef12b46fbcaa0$var$checkIfSnapshotChanged(inst) && $081ef12b46fbcaa0$var$forceStoreRerender(fiber);
}
function $081ef12b46fbcaa0$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $081ef12b46fbcaa0$var$checkIfSnapshotChanged(inst) && $081ef12b46fbcaa0$var$forceStoreRerender(fiber);
    });
}
function $081ef12b46fbcaa0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$081ef12b46fbcaa0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $081ef12b46fbcaa0$var$forceStoreRerender(fiber) {
    var root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $081ef12b46fbcaa0$var$mountStateImpl(initialState) {
    var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $081ef12b46fbcaa0$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $081ef12b46fbcaa0$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $081ef12b46fbcaa0$var$updateReducerImpl(hook, $081ef12b46fbcaa0$var$currentHook, "function" === typeof reducer ? reducer : $081ef12b46fbcaa0$var$basicStateReducer);
}
function $081ef12b46fbcaa0$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $081ef12b46fbcaa0$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $081ef12b46fbcaa0$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $081ef12b46fbcaa0$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $081ef12b46fbcaa0$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $081ef12b46fbcaa0$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $081ef12b46fbcaa0$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $081ef12b46fbcaa0$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $081ef12b46fbcaa0$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $081ef12b46fbcaa0$var$onActionError(actionQueue, node, error$70);
    }
}
function $081ef12b46fbcaa0$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $081ef12b46fbcaa0$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $081ef12b46fbcaa0$var$onActionError(actionQueue, node, error);
    }) : $081ef12b46fbcaa0$var$onActionSuccess(actionQueue, node, returnValue);
}
function $081ef12b46fbcaa0$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $081ef12b46fbcaa0$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $081ef12b46fbcaa0$var$runActionStateAction(actionQueue, nextState)));
}
function $081ef12b46fbcaa0$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $081ef12b46fbcaa0$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $081ef12b46fbcaa0$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $081ef12b46fbcaa0$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $081ef12b46fbcaa0$var$mountActionState(action, initialStateProp) {
    if ($081ef12b46fbcaa0$var$isHydrating) {
        var ssrFormState = $081ef12b46fbcaa0$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $081ef12b46fbcaa0$var$currentlyRenderingFiber;
                if ($081ef12b46fbcaa0$var$isHydrating) {
                    if ($081ef12b46fbcaa0$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $081ef12b46fbcaa0$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $081ef12b46fbcaa0$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $081ef12b46fbcaa0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $081ef12b46fbcaa0$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $081ef12b46fbcaa0$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $081ef12b46fbcaa0$var$dispatchSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $081ef12b46fbcaa0$var$mountStateImpl(!1);
    inRootOrSingleton = $081ef12b46fbcaa0$var$dispatchOptimisticSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $081ef12b46fbcaa0$var$dispatchActionState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $081ef12b46fbcaa0$var$updateActionState(action) {
    var stateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    return $081ef12b46fbcaa0$var$updateActionStateImpl(stateHook, $081ef12b46fbcaa0$var$currentHook, action);
}
function $081ef12b46fbcaa0$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $081ef12b46fbcaa0$var$updateReducerImpl(stateHook, currentStateHook, $081ef12b46fbcaa0$var$actionStateReducer)[0];
    stateHook = $081ef12b46fbcaa0$var$updateReducer($081ef12b46fbcaa0$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $081ef12b46fbcaa0$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $081ef12b46fbcaa0$var$SuspenseException) throw $081ef12b46fbcaa0$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= 2048, $081ef12b46fbcaa0$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $081ef12b46fbcaa0$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $081ef12b46fbcaa0$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $081ef12b46fbcaa0$var$rerenderActionState(action) {
    var stateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook(), currentStateHook = $081ef12b46fbcaa0$var$currentHook;
    if (null !== currentStateHook) return $081ef12b46fbcaa0$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $081ef12b46fbcaa0$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $081ef12b46fbcaa0$var$updateRef() {
    return $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
}
function $081ef12b46fbcaa0$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $081ef12b46fbcaa0$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $081ef12b46fbcaa0$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $081ef12b46fbcaa0$var$currentHook && null !== deps && $081ef12b46fbcaa0$var$areHookInputsEqual(deps, $081ef12b46fbcaa0$var$currentHook.memoizedState.deps) ? hook.memoizedState = $081ef12b46fbcaa0$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $081ef12b46fbcaa0$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $081ef12b46fbcaa0$var$mountEffect(create, deps) {
    $081ef12b46fbcaa0$var$mountEffectImpl(8390656, 8, create, deps);
}
function $081ef12b46fbcaa0$var$updateEffect(create, deps) {
    $081ef12b46fbcaa0$var$updateEffectImpl(2048, 8, create, deps);
}
function $081ef12b46fbcaa0$var$useEffectEventImpl(payload) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $081ef12b46fbcaa0$var$createFunctionComponentUpdateQueue(), $081ef12b46fbcaa0$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $081ef12b46fbcaa0$var$updateEvent(callback) {
    var ref = $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
    $081ef12b46fbcaa0$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($081ef12b46fbcaa0$var$executionContext & 2)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $081ef12b46fbcaa0$var$updateInsertionEffect(create, deps) {
    return $081ef12b46fbcaa0$var$updateEffectImpl(4, 2, create, deps);
}
function $081ef12b46fbcaa0$var$updateLayoutEffect(create, deps) {
    return $081ef12b46fbcaa0$var$updateEffectImpl(4, 4, create, deps);
}
function $081ef12b46fbcaa0$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $081ef12b46fbcaa0$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $081ef12b46fbcaa0$var$updateEffectImpl(4, 4, $081ef12b46fbcaa0$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $081ef12b46fbcaa0$var$mountDebugValue() {}
function $081ef12b46fbcaa0$var$updateCallback(callback, deps) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $081ef12b46fbcaa0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $081ef12b46fbcaa0$var$updateMemo(nextCreate, deps) {
    var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $081ef12b46fbcaa0$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($081ef12b46fbcaa0$var$renderLanes & 1073741824) && 0 === ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $081ef12b46fbcaa0$var$requestDeferredLane();
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= hook;
    $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $081ef12b46fbcaa0$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($081ef12b46fbcaa0$var$objectIs(value, prevValue)) return value;
    if (null !== $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current) return hook = $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue), $081ef12b46fbcaa0$var$objectIs(hook, prevValue) || ($081ef12b46fbcaa0$var$didReceiveUpdate = !0), hook;
    if (0 === ($081ef12b46fbcaa0$var$renderLanes & 106) || 0 !== ($081ef12b46fbcaa0$var$renderLanes & 1073741824) && 0 === ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 261930)) return $081ef12b46fbcaa0$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $081ef12b46fbcaa0$var$requestDeferredLane();
    $081ef12b46fbcaa0$var$currentlyRenderingFiber.lanes |= hook;
    $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $081ef12b46fbcaa0$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $081ef12b46fbcaa0$var$ReactSharedInternals.T = currentTransition;
    $081ef12b46fbcaa0$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $081ef12b46fbcaa0$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $081ef12b46fbcaa0$var$chainThenableValue(returnValue, finishedState);
            $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $081ef12b46fbcaa0$var$requestUpdateLane(fiber));
        } else $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, finishedState, $081ef12b46fbcaa0$var$requestUpdateLane(fiber));
    } catch (error) {
        $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $081ef12b46fbcaa0$var$requestUpdateLane());
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $081ef12b46fbcaa0$var$noop() {}
function $081ef12b46fbcaa0$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(476));
    var queue = $081ef12b46fbcaa0$var$ensureFormComponentIsStateful(formFiber).queue;
    $081ef12b46fbcaa0$var$startTransition(formFiber, queue, pendingState, $081ef12b46fbcaa0$var$sharedNotPendingObject, null === action ? $081ef12b46fbcaa0$var$noop : function() {
        $081ef12b46fbcaa0$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $081ef12b46fbcaa0$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $081ef12b46fbcaa0$var$sharedNotPendingObject,
        baseState: $081ef12b46fbcaa0$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $081ef12b46fbcaa0$var$basicStateReducer,
            lastRenderedState: $081ef12b46fbcaa0$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $081ef12b46fbcaa0$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $081ef12b46fbcaa0$var$requestFormReset$1(formFiber) {
    var stateHook = $081ef12b46fbcaa0$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $081ef12b46fbcaa0$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $081ef12b46fbcaa0$var$requestUpdateLane());
}
function $081ef12b46fbcaa0$var$useHostTransitionStatus() {
    return $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$HostTransitionContext);
}
function $081ef12b46fbcaa0$var$updateId() {
    return $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
}
function $081ef12b46fbcaa0$var$updateRefresh() {
    return $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
}
function $081ef12b46fbcaa0$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
                fiber = $081ef12b46fbcaa0$var$createUpdate(lane);
                var root$73 = $081ef12b46fbcaa0$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root$73, provider, lane), $081ef12b46fbcaa0$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $081ef12b46fbcaa0$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $081ef12b46fbcaa0$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber) ? $081ef12b46fbcaa0$var$enqueueRenderPhaseUpdate(queue, action) : (action = $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(action, fiber, lane), $081ef12b46fbcaa0$var$entangleTransitionUpdate(action, queue, lane)));
}
function $081ef12b46fbcaa0$var$dispatchSetState(fiber, queue, action) {
    var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
    $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $081ef12b46fbcaa0$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber)) $081ef12b46fbcaa0$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($081ef12b46fbcaa0$var$objectIs(eagerState, currentState)) return $081ef12b46fbcaa0$var$enqueueUpdate$1(fiber, queue, update, 0), null === $081ef12b46fbcaa0$var$workInProgressRoot && $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(action, fiber, lane), $081ef12b46fbcaa0$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $081ef12b46fbcaa0$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $081ef12b46fbcaa0$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $081ef12b46fbcaa0$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $081ef12b46fbcaa0$var$currentlyRenderingFiber || null !== alternate && alternate === $081ef12b46fbcaa0$var$currentlyRenderingFiber;
}
function $081ef12b46fbcaa0$var$enqueueRenderPhaseUpdate(queue, update) {
    $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdateDuringThisPass = $081ef12b46fbcaa0$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $081ef12b46fbcaa0$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $081ef12b46fbcaa0$var$markRootEntangled(root, lane);
    }
}
var $081ef12b46fbcaa0$var$ContextOnlyDispatcher = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useContext: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useEffect: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useImperativeHandle: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useLayoutEffect: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useInsertionEffect: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useMemo: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useReducer: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useRef: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useState: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useDebugValue: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useDeferredValue: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useTransition: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useSyncExternalStore: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useId: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useHostTransitionStatus: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useFormState: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useActionState: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useOptimistic: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useMemoCache: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useCacheRefresh: $081ef12b46fbcaa0$var$throwInvalidHookError,
    useEffectEvent: $081ef12b46fbcaa0$var$throwInvalidHookError
}, $081ef12b46fbcaa0$var$HooksDispatcherOnMount = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: function(callback, deps) {
        $081ef12b46fbcaa0$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $081ef12b46fbcaa0$var$readContext,
    useEffect: $081ef12b46fbcaa0$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $081ef12b46fbcaa0$var$mountEffectImpl(4194308, 4, $081ef12b46fbcaa0$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $081ef12b46fbcaa0$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $081ef12b46fbcaa0$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($081ef12b46fbcaa0$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $081ef12b46fbcaa0$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $081ef12b46fbcaa0$var$dispatchReducerAction.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $081ef12b46fbcaa0$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $081ef12b46fbcaa0$var$dispatchSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $081ef12b46fbcaa0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        return $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $081ef12b46fbcaa0$var$mountStateImpl(!1);
        stateHook = $081ef12b46fbcaa0$var$startTransition.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $081ef12b46fbcaa0$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $081ef12b46fbcaa0$var$currentlyRenderingFiber, hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        if ($081ef12b46fbcaa0$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $081ef12b46fbcaa0$var$workInProgressRoot) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(349));
            0 !== ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 127) || $081ef12b46fbcaa0$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $081ef12b46fbcaa0$var$mountEffect($081ef12b46fbcaa0$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $081ef12b46fbcaa0$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $081ef12b46fbcaa0$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook(), identifierPrefix = $081ef12b46fbcaa0$var$workInProgressRoot.identifierPrefix;
        if ($081ef12b46fbcaa0$var$isHydrating) {
            var JSCompiler_inline_result = $081ef12b46fbcaa0$var$treeContextOverflow;
            var idWithLeadingBit = $081ef12b46fbcaa0$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $081ef12b46fbcaa0$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $081ef12b46fbcaa0$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $081ef12b46fbcaa0$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $081ef12b46fbcaa0$var$useHostTransitionStatus,
    useFormState: $081ef12b46fbcaa0$var$mountActionState,
    useActionState: $081ef12b46fbcaa0$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $081ef12b46fbcaa0$var$dispatchOptimisticSetState.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $081ef12b46fbcaa0$var$useMemoCache,
    useCacheRefresh: function() {
        return $081ef12b46fbcaa0$var$mountWorkInProgressHook().memoizedState = $081ef12b46fbcaa0$var$refreshCache.bind(null, $081ef12b46fbcaa0$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $081ef12b46fbcaa0$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($081ef12b46fbcaa0$var$executionContext & 2)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $081ef12b46fbcaa0$var$HooksDispatcherOnUpdate = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: $081ef12b46fbcaa0$var$updateCallback,
    useContext: $081ef12b46fbcaa0$var$readContext,
    useEffect: $081ef12b46fbcaa0$var$updateEffect,
    useImperativeHandle: $081ef12b46fbcaa0$var$updateImperativeHandle,
    useInsertionEffect: $081ef12b46fbcaa0$var$updateInsertionEffect,
    useLayoutEffect: $081ef12b46fbcaa0$var$updateLayoutEffect,
    useMemo: $081ef12b46fbcaa0$var$updateMemo,
    useReducer: $081ef12b46fbcaa0$var$updateReducer,
    useRef: $081ef12b46fbcaa0$var$updateRef,
    useState: function() {
        return $081ef12b46fbcaa0$var$updateReducer($081ef12b46fbcaa0$var$basicStateReducer);
    },
    useDebugValue: $081ef12b46fbcaa0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        return $081ef12b46fbcaa0$var$updateDeferredValueImpl(hook, $081ef12b46fbcaa0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $081ef12b46fbcaa0$var$updateReducer($081ef12b46fbcaa0$var$basicStateReducer)[0], start = $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $081ef12b46fbcaa0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $081ef12b46fbcaa0$var$updateSyncExternalStore,
    useId: $081ef12b46fbcaa0$var$updateId,
    useHostTransitionStatus: $081ef12b46fbcaa0$var$useHostTransitionStatus,
    useFormState: $081ef12b46fbcaa0$var$updateActionState,
    useActionState: $081ef12b46fbcaa0$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        return $081ef12b46fbcaa0$var$updateOptimisticImpl(hook, $081ef12b46fbcaa0$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $081ef12b46fbcaa0$var$useMemoCache,
    useCacheRefresh: $081ef12b46fbcaa0$var$updateRefresh,
    useEffectEvent: $081ef12b46fbcaa0$var$updateEvent
}, $081ef12b46fbcaa0$var$HooksDispatcherOnRerender = {
    readContext: $081ef12b46fbcaa0$var$readContext,
    use: $081ef12b46fbcaa0$var$use,
    useCallback: $081ef12b46fbcaa0$var$updateCallback,
    useContext: $081ef12b46fbcaa0$var$readContext,
    useEffect: $081ef12b46fbcaa0$var$updateEffect,
    useImperativeHandle: $081ef12b46fbcaa0$var$updateImperativeHandle,
    useInsertionEffect: $081ef12b46fbcaa0$var$updateInsertionEffect,
    useLayoutEffect: $081ef12b46fbcaa0$var$updateLayoutEffect,
    useMemo: $081ef12b46fbcaa0$var$updateMemo,
    useReducer: $081ef12b46fbcaa0$var$rerenderReducer,
    useRef: $081ef12b46fbcaa0$var$updateRef,
    useState: function() {
        return $081ef12b46fbcaa0$var$rerenderReducer($081ef12b46fbcaa0$var$basicStateReducer);
    },
    useDebugValue: $081ef12b46fbcaa0$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        return null === $081ef12b46fbcaa0$var$currentHook ? $081ef12b46fbcaa0$var$mountDeferredValueImpl(hook, value, initialValue) : $081ef12b46fbcaa0$var$updateDeferredValueImpl(hook, $081ef12b46fbcaa0$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $081ef12b46fbcaa0$var$rerenderReducer($081ef12b46fbcaa0$var$basicStateReducer)[0], start = $081ef12b46fbcaa0$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $081ef12b46fbcaa0$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $081ef12b46fbcaa0$var$updateSyncExternalStore,
    useId: $081ef12b46fbcaa0$var$updateId,
    useHostTransitionStatus: $081ef12b46fbcaa0$var$useHostTransitionStatus,
    useFormState: $081ef12b46fbcaa0$var$rerenderActionState,
    useActionState: $081ef12b46fbcaa0$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $081ef12b46fbcaa0$var$updateWorkInProgressHook();
        if (null !== $081ef12b46fbcaa0$var$currentHook) return $081ef12b46fbcaa0$var$updateOptimisticImpl(hook, $081ef12b46fbcaa0$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $081ef12b46fbcaa0$var$useMemoCache,
    useCacheRefresh: $081ef12b46fbcaa0$var$updateRefresh,
    useEffectEvent: $081ef12b46fbcaa0$var$updateEvent
};
function $081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $081ef12b46fbcaa0$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $081ef12b46fbcaa0$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane(), update = $081ef12b46fbcaa0$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $081ef12b46fbcaa0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(payload, inst, lane), $081ef12b46fbcaa0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane(), update = $081ef12b46fbcaa0$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $081ef12b46fbcaa0$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(payload, inst, lane), $081ef12b46fbcaa0$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane(), update = $081ef12b46fbcaa0$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $081ef12b46fbcaa0$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(callback, inst, lane), $081ef12b46fbcaa0$var$entangleTransitions(callback, inst, lane));
    }
};
function $081ef12b46fbcaa0$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$081ef12b46fbcaa0$var$shallowEqual(oldProps, newProps) || !$081ef12b46fbcaa0$var$shallowEqual(oldState, newState) : !0;
}
function $081ef12b46fbcaa0$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $081ef12b46fbcaa0$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $081ef12b46fbcaa0$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $081ef12b46fbcaa0$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $081ef12b46fbcaa0$var$defaultOnUncaughtError(error) {
    $081ef12b46fbcaa0$var$reportGlobalError(error);
}
function $081ef12b46fbcaa0$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $081ef12b46fbcaa0$var$defaultOnRecoverableError(error) {
    $081ef12b46fbcaa0$var$reportGlobalError(error);
}
function $081ef12b46fbcaa0$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $081ef12b46fbcaa0$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $081ef12b46fbcaa0$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $081ef12b46fbcaa0$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $081ef12b46fbcaa0$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $081ef12b46fbcaa0$var$createClassErrorUpdate(lane) {
    lane = $081ef12b46fbcaa0$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $081ef12b46fbcaa0$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $081ef12b46fbcaa0$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $081ef12b46fbcaa0$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed ? $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $081ef12b46fbcaa0$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $081ef12b46fbcaa0$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $081ef12b46fbcaa0$var$shellBoundary ? $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $081ef12b46fbcaa0$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $081ef12b46fbcaa0$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $081ef12b46fbcaa0$var$attachPingListener(root, value, rootRenderLanes);
        $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($081ef12b46fbcaa0$var$isHydrating) return returnFiber = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $081ef12b46fbcaa0$var$HydrationMismatchException && (root = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(422), {
        cause: value
    }), $081ef12b46fbcaa0$var$queueHydrationError($081ef12b46fbcaa0$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $081ef12b46fbcaa0$var$HydrationMismatchException && (returnFiber = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(423), {
        cause: value
    }), $081ef12b46fbcaa0$var$queueHydrationError($081ef12b46fbcaa0$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $081ef12b46fbcaa0$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $081ef12b46fbcaa0$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors ? $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $081ef12b46fbcaa0$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $081ef12b46fbcaa0$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed || !$081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $081ef12b46fbcaa0$var$createClassErrorUpdate(rootRenderLanes), $081ef12b46fbcaa0$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $081ef12b46fbcaa0$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $081ef12b46fbcaa0$var$SelectiveHydrationException = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(461)), $081ef12b46fbcaa0$var$didReceiveUpdate = !1;
function $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $081ef12b46fbcaa0$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $081ef12b46fbcaa0$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    nextProps = $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $081ef12b46fbcaa0$var$checkDidRenderIdHook();
    if (null !== current && !$081ef12b46fbcaa0$var$didReceiveUpdate) return $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, renderLanes), $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $081ef12b46fbcaa0$var$isHydrating && key && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$081ef12b46fbcaa0$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $081ef12b46fbcaa0$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $081ef12b46fbcaa0$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $081ef12b46fbcaa0$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $081ef12b46fbcaa0$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $081ef12b46fbcaa0$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($081ef12b46fbcaa0$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($081ef12b46fbcaa0$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($081ef12b46fbcaa0$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $081ef12b46fbcaa0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $081ef12b46fbcaa0$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $081ef12b46fbcaa0$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $081ef12b46fbcaa0$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $081ef12b46fbcaa0$var$pushHiddenContext(workInProgress, prevState) : $081ef12b46fbcaa0$var$reuseHiddenContextOnStack(), $081ef12b46fbcaa0$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $081ef12b46fbcaa0$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($081ef12b46fbcaa0$var$pushTransition(workInProgress, prevState.cachePool), $081ef12b46fbcaa0$var$pushHiddenContext(workInProgress, prevState), $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $081ef12b46fbcaa0$var$pushTransition(workInProgress, null), $081ef12b46fbcaa0$var$reuseHiddenContextOnStack(), $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack());
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $081ef12b46fbcaa0$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $081ef12b46fbcaa0$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $081ef12b46fbcaa0$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $081ef12b46fbcaa0$var$pushTransition(workInProgress, null);
    $081ef12b46fbcaa0$var$reuseHiddenContextOnStack();
    $081ef12b46fbcaa0$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $081ef12b46fbcaa0$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $081ef12b46fbcaa0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $081ef12b46fbcaa0$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $081ef12b46fbcaa0$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($081ef12b46fbcaa0$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $081ef12b46fbcaa0$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $081ef12b46fbcaa0$var$bailoutOffscreenComponent(null, current);
            $081ef12b46fbcaa0$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $081ef12b46fbcaa0$var$nextHydratableInstance) ? (current = $081ef12b46fbcaa0$var$canHydrateHydrationBoundary(current, $081ef12b46fbcaa0$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $081ef12b46fbcaa0$var$treeContextProvider ? {
                    id: $081ef12b46fbcaa0$var$treeContextId,
                    overflow: $081ef12b46fbcaa0$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $081ef12b46fbcaa0$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $081ef12b46fbcaa0$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $081ef12b46fbcaa0$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $081ef12b46fbcaa0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(558));
        } else if ($081ef12b46fbcaa0$var$didReceiveUpdate || $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $081ef12b46fbcaa0$var$didReceiveUpdate || didSuspend) {
            if (null === $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current) {
                nextProps = $081ef12b46fbcaa0$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $081ef12b46fbcaa0$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(current, dehydrated), $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $081ef12b46fbcaa0$var$SelectiveHydrationException;
                $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $081ef12b46fbcaa0$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(dehydrated.nextSibling), $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$isHydrating = !0, $081ef12b46fbcaa0$var$hydrationErrors = null, $081ef12b46fbcaa0$var$rootOrSingletonContext = !1, null !== current && $081ef12b46fbcaa0$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $081ef12b46fbcaa0$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $081ef12b46fbcaa0$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $081ef12b46fbcaa0$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $081ef12b46fbcaa0$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    Component = $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $081ef12b46fbcaa0$var$checkDidRenderIdHook();
    if (null !== current && !$081ef12b46fbcaa0$var$didReceiveUpdate) return $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, renderLanes), $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $081ef12b46fbcaa0$var$isHydrating && nextProps && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $081ef12b46fbcaa0$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $081ef12b46fbcaa0$var$finishRenderingHooks(current);
    Component = $081ef12b46fbcaa0$var$checkDidRenderIdHook();
    if (null !== current && !$081ef12b46fbcaa0$var$didReceiveUpdate) return $081ef12b46fbcaa0$var$bailoutHooks(current, workInProgress, renderLanes), $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $081ef12b46fbcaa0$var$isHydrating && Component && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $081ef12b46fbcaa0$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $081ef12b46fbcaa0$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $081ef12b46fbcaa0$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $081ef12b46fbcaa0$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $081ef12b46fbcaa0$var$readContext(contextType) : $081ef12b46fbcaa0$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $081ef12b46fbcaa0$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $081ef12b46fbcaa0$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $081ef12b46fbcaa0$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $081ef12b46fbcaa0$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $081ef12b46fbcaa0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $081ef12b46fbcaa0$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $081ef12b46fbcaa0$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $081ef12b46fbcaa0$var$hasForceUpdate || $081ef12b46fbcaa0$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $081ef12b46fbcaa0$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $081ef12b46fbcaa0$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $081ef12b46fbcaa0$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $081ef12b46fbcaa0$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $081ef12b46fbcaa0$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $081ef12b46fbcaa0$var$hasForceUpdate || null !== current && null !== current.dependencies && $081ef12b46fbcaa0$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($081ef12b46fbcaa0$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $081ef12b46fbcaa0$var$hasForceUpdate || $081ef12b46fbcaa0$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $081ef12b46fbcaa0$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $081ef12b46fbcaa0$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $081ef12b46fbcaa0$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $081ef12b46fbcaa0$var$resetHydrationState();
    workInProgress.flags |= 256;
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $081ef12b46fbcaa0$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $081ef12b46fbcaa0$var$getSuspendedCache()
    };
}
function $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $081ef12b46fbcaa0$var$workInProgressDeferredLane);
    return current;
}
function $081ef12b46fbcaa0$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($081ef12b46fbcaa0$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($081ef12b46fbcaa0$var$isHydrating) {
            showFallback ? $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack();
            (current = $081ef12b46fbcaa0$var$nextHydratableInstance) ? (current = $081ef12b46fbcaa0$var$canHydrateHydrationBoundary(current, $081ef12b46fbcaa0$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $081ef12b46fbcaa0$var$treeContextProvider ? {
                    id: $081ef12b46fbcaa0$var$treeContextId,
                    overflow: $081ef12b46fbcaa0$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $081ef12b46fbcaa0$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $081ef12b46fbcaa0$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $081ef12b46fbcaa0$var$SUSPENDED_MARKER, $081ef12b46fbcaa0$var$bailoutOffscreenComponent(null, nextProps);
        $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $081ef12b46fbcaa0$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $081ef12b46fbcaa0$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $081ef12b46fbcaa0$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $081ef12b46fbcaa0$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $081ef12b46fbcaa0$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $081ef12b46fbcaa0$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $081ef12b46fbcaa0$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $081ef12b46fbcaa0$var$SUSPENDED_MARKER, $081ef12b46fbcaa0$var$bailoutOffscreenComponent(current.child, nextProps);
    $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $081ef12b46fbcaa0$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $081ef12b46fbcaa0$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $081ef12b46fbcaa0$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $081ef12b46fbcaa0$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $081ef12b46fbcaa0$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $081ef12b46fbcaa0$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $081ef12b46fbcaa0$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $081ef12b46fbcaa0$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $081ef12b46fbcaa0$var$SUSPENDED_MARKER;
        return $081ef12b46fbcaa0$var$bailoutOffscreenComponent(null, nextProps);
    }
    $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($081ef12b46fbcaa0$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($081ef12b46fbcaa0$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $081ef12b46fbcaa0$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $081ef12b46fbcaa0$var$didReceiveUpdate || $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($081ef12b46fbcaa0$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $081ef12b46fbcaa0$var$currentTreeHiddenStackCursor.current) return $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $081ef12b46fbcaa0$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $081ef12b46fbcaa0$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(current, nextProps), $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $081ef12b46fbcaa0$var$SelectiveHydrationException;
        $081ef12b46fbcaa0$var$isSuspenseInstancePending(suspenseInstance) || $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible();
        return $081ef12b46fbcaa0$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($081ef12b46fbcaa0$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(suspenseInstance.nextSibling);
    $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress;
    $081ef12b46fbcaa0$var$isHydrating = !0;
    $081ef12b46fbcaa0$var$hydrationErrors = null;
    $081ef12b46fbcaa0$var$rootOrSingletonContext = !1;
    null !== current && $081ef12b46fbcaa0$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $081ef12b46fbcaa0$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $081ef12b46fbcaa0$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $081ef12b46fbcaa0$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $081ef12b46fbcaa0$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $081ef12b46fbcaa0$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $081ef12b46fbcaa0$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $081ef12b46fbcaa0$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $081ef12b46fbcaa0$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $081ef12b46fbcaa0$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($081ef12b46fbcaa0$var$reverseChildren(current), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $081ef12b46fbcaa0$var$reverseChildren(current)) : $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $081ef12b46fbcaa0$var$isHydrating ? $081ef12b46fbcaa0$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $081ef12b46fbcaa0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $081ef12b46fbcaa0$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $081ef12b46fbcaa0$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $081ef12b46fbcaa0$var$reverseChildren(workInProgress));
            $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $081ef12b46fbcaa0$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $081ef12b46fbcaa0$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $081ef12b46fbcaa0$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $081ef12b46fbcaa0$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $081ef12b46fbcaa0$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $081ef12b46fbcaa0$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $081ef12b46fbcaa0$var$checkIfContextChanged(current) ? !0 : !1;
}
function $081ef12b46fbcaa0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, current.memoizedState.cache);
            $081ef12b46fbcaa0$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $081ef12b46fbcaa0$var$pushHostContext(workInProgress);
            break;
        case 4:
            $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $081ef12b46fbcaa0$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $081ef12b46fbcaa0$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $081ef12b46fbcaa0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $081ef12b46fbcaa0$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($081ef12b46fbcaa0$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $081ef12b46fbcaa0$var$pushSuspenseListContext(workInProgress, $081ef12b46fbcaa0$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $081ef12b46fbcaa0$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, current.memoizedState.cache);
    }
    return $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $081ef12b46fbcaa0$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $081ef12b46fbcaa0$var$didReceiveUpdate = !0;
        else {
            if (!$081ef12b46fbcaa0$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $081ef12b46fbcaa0$var$didReceiveUpdate = !1, $081ef12b46fbcaa0$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $081ef12b46fbcaa0$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $081ef12b46fbcaa0$var$didReceiveUpdate = !1, $081ef12b46fbcaa0$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $081ef12b46fbcaa0$var$pushTreeId(workInProgress, $081ef12b46fbcaa0$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $081ef12b46fbcaa0$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $081ef12b46fbcaa0$var$shouldConstruct(current) ? (props = $081ef12b46fbcaa0$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $081ef12b46fbcaa0$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $081ef12b46fbcaa0$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $081ef12b46fbcaa0$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $081ef12b46fbcaa0$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $081ef12b46fbcaa0$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $081ef12b46fbcaa0$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $081ef12b46fbcaa0$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $081ef12b46fbcaa0$var$getComponentNameFromType(current) || current;
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $081ef12b46fbcaa0$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $081ef12b46fbcaa0$var$resolveClassComponentProps(props, workInProgress.pendingProps), $081ef12b46fbcaa0$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress);
                $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, props);
                props !== prevState.cache && $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, [
                    $081ef12b46fbcaa0$var$CacheContext
                ], renderLanes, !0);
                $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $081ef12b46fbcaa0$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(Error($081ef12b46fbcaa0$var$formatProdErrorMessage(424)), workInProgress);
                        $081ef12b46fbcaa0$var$queueHydrationError($$typeof);
                        workInProgress = $081ef12b46fbcaa0$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(current.firstChild);
                        $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress;
                        $081ef12b46fbcaa0$var$isHydrating = !0;
                        $081ef12b46fbcaa0$var$hydrationErrors = null;
                        $081ef12b46fbcaa0$var$rootOrSingletonContext = !0;
                        renderLanes = $081ef12b46fbcaa0$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $081ef12b46fbcaa0$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $081ef12b46fbcaa0$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $081ef12b46fbcaa0$var$markRef(current, workInProgress), null === current ? (renderLanes = $081ef12b46fbcaa0$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $081ef12b46fbcaa0$var$isHydrating || (workInProgress.stateNode = $081ef12b46fbcaa0$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $081ef12b46fbcaa0$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $081ef12b46fbcaa0$var$pushHostContext(workInProgress), null === current && $081ef12b46fbcaa0$var$isHydrating && (props = workInProgress.stateNode = $081ef12b46fbcaa0$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootInstanceStackCursor.current), $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$rootOrSingletonContext = !0, $$typeof = $081ef12b46fbcaa0$var$nextHydratableInstance, $081ef12b46fbcaa0$var$isSingletonScope(workInProgress.type) ? ($081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(props.firstChild)) : $081ef12b46fbcaa0$var$nextHydratableInstance = $$typeof), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $081ef12b46fbcaa0$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $081ef12b46fbcaa0$var$isHydrating) {
                if ($$typeof = props = $081ef12b46fbcaa0$var$nextHydratableInstance) props = $081ef12b46fbcaa0$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = $081ef12b46fbcaa0$var$getNextHydratable(props.firstChild), $081ef12b46fbcaa0$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            }
            $081ef12b46fbcaa0$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $081ef12b46fbcaa0$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $081ef12b46fbcaa0$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $081ef12b46fbcaa0$var$renderWithHooks(current, workInProgress, $081ef12b46fbcaa0$var$TransitionAwareHostComponent, null, null, renderLanes), $081ef12b46fbcaa0$var$HostTransitionContext._currentValue = $$typeof);
            $081ef12b46fbcaa0$var$markRef(current, workInProgress);
            $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $081ef12b46fbcaa0$var$isHydrating) {
                if (current = renderLanes = $081ef12b46fbcaa0$var$nextHydratableInstance) renderLanes = $081ef12b46fbcaa0$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $081ef12b46fbcaa0$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $081ef12b46fbcaa0$var$hydrationParentFiber = workInProgress, $081ef12b46fbcaa0$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $081ef12b46fbcaa0$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $081ef12b46fbcaa0$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $081ef12b46fbcaa0$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $081ef12b46fbcaa0$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $081ef12b46fbcaa0$var$markRef(current, workInProgress), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $081ef12b46fbcaa0$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress), $$typeof = $081ef12b46fbcaa0$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $081ef12b46fbcaa0$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $081ef12b46fbcaa0$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $081ef12b46fbcaa0$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $081ef12b46fbcaa0$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $081ef12b46fbcaa0$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $081ef12b46fbcaa0$var$prepareToReadContext(workInProgress), props = $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$CacheContext), null === current ? ($$typeof = $081ef12b46fbcaa0$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $081ef12b46fbcaa0$var$workInProgressRoot, prevState = $081ef12b46fbcaa0$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $081ef12b46fbcaa0$var$initializeUpdateQueue(workInProgress), $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($081ef12b46fbcaa0$var$cloneUpdateQueue(current, workInProgress), $081ef12b46fbcaa0$var$processUpdateQueue(workInProgress, null, null, renderLanes), $081ef12b46fbcaa0$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, props)) : (props = prevState.cache, $081ef12b46fbcaa0$var$pushProvider(workInProgress, $081ef12b46fbcaa0$var$CacheContext, props), props !== $$typeof.cache && $081ef12b46fbcaa0$var$propagateContextChanges(workInProgress, [
                $081ef12b46fbcaa0$var$CacheContext
            ], renderLanes, !0))), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $081ef12b46fbcaa0$var$markRef(current, workInProgress), $081ef12b46fbcaa0$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $081ef12b46fbcaa0$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $081ef12b46fbcaa0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $081ef12b46fbcaa0$var$maySuspendCommit(type, newProps) : $081ef12b46fbcaa0$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($081ef12b46fbcaa0$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $081ef12b46fbcaa0$var$suspendedThenable = $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable, $081ef12b46fbcaa0$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $081ef12b46fbcaa0$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$081ef12b46fbcaa0$var$preloadResource(resource)) {
        if ($081ef12b46fbcaa0$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $081ef12b46fbcaa0$var$suspendedThenable = $081ef12b46fbcaa0$var$noopSuspenseyCommitThenable, $081ef12b46fbcaa0$var$SuspenseyCommitException;
    }
}
function $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $081ef12b46fbcaa0$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $081ef12b46fbcaa0$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$081ef12b46fbcaa0$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $081ef12b46fbcaa0$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $081ef12b46fbcaa0$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $081ef12b46fbcaa0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 1:
            return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext);
            $081ef12b46fbcaa0$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $081ef12b46fbcaa0$var$popHydrationState(workInProgress) ? $081ef12b46fbcaa0$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable());
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($081ef12b46fbcaa0$var$markUpdate(workInProgress), null !== nextResource ? ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), $081ef12b46fbcaa0$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), $081ef12b46fbcaa0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($081ef12b46fbcaa0$var$markUpdate(workInProgress), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), $081ef12b46fbcaa0$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), $081ef12b46fbcaa0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $081ef12b46fbcaa0$var$popHostContext(workInProgress);
            renderLanes = $081ef12b46fbcaa0$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(166));
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $081ef12b46fbcaa0$var$contextStackCursor.current;
                $081ef12b46fbcaa0$var$popHydrationState(workInProgress) ? $081ef12b46fbcaa0$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $081ef12b46fbcaa0$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $081ef12b46fbcaa0$var$markUpdate(workInProgress));
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $081ef12b46fbcaa0$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(166));
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $081ef12b46fbcaa0$var$contextStackCursor.current;
                if ($081ef12b46fbcaa0$var$popHydrationState(workInProgress)) $081ef12b46fbcaa0$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer($081ef12b46fbcaa0$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    nextResource[$081ef12b46fbcaa0$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($081ef12b46fbcaa0$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
                }
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $081ef12b46fbcaa0$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $081ef12b46fbcaa0$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(166));
                current = $081ef12b46fbcaa0$var$rootInstanceStackCursor.current;
                if ($081ef12b46fbcaa0$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $081ef12b46fbcaa0$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $081ef12b46fbcaa0$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $081ef12b46fbcaa0$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $081ef12b46fbcaa0$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(557));
                        current[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    } else $081ef12b46fbcaa0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(558));
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $081ef12b46fbcaa0$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(317));
                        type[$081ef12b46fbcaa0$var$internalInstanceKey] = workInProgress;
                    } else $081ef12b46fbcaa0$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $081ef12b46fbcaa0$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), workInProgress;
                    $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $081ef12b46fbcaa0$var$popHostContainer(), null === current && $081ef12b46fbcaa0$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 10:
            return $081ef12b46fbcaa0$var$popProvider(workInProgress.type), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 19:
            $081ef12b46fbcaa0$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $081ef12b46fbcaa0$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $081ef12b46fbcaa0$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $081ef12b46fbcaa0$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $081ef12b46fbcaa0$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$081ef12b46fbcaa0$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $081ef12b46fbcaa0$var$pushSuspenseListContext(workInProgress, $081ef12b46fbcaa0$var$suspenseStackCursor.current & 1 | 2);
                            $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $081ef12b46fbcaa0$var$now() > $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $081ef12b46fbcaa0$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $081ef12b46fbcaa0$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, current), $081ef12b46fbcaa0$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$081ef12b46fbcaa0$var$isHydrating) return $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
                    } else 2 * $081ef12b46fbcaa0$var$now() - newProps.renderingStartTime > $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $081ef12b46fbcaa0$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $081ef12b46fbcaa0$var$now();
                current.sibling = null;
                nextResource = $081ef12b46fbcaa0$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $081ef12b46fbcaa0$var$isHydrating ? $081ef12b46fbcaa0$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseHandlerStackCursor, workInProgress), $081ef12b46fbcaa0$var$push($081ef12b46fbcaa0$var$suspenseStackCursor, renderLanes), null === $081ef12b46fbcaa0$var$shellBoundary && ($081ef12b46fbcaa0$var$shellBoundary = workInProgress));
                $081ef12b46fbcaa0$var$isHydrating && $081ef12b46fbcaa0$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $081ef12b46fbcaa0$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), $081ef12b46fbcaa0$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($081ef12b46fbcaa0$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $081ef12b46fbcaa0$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext), $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $081ef12b46fbcaa0$var$bubbleProperties(workInProgress), null;
    }
    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $081ef12b46fbcaa0$var$unwindWork(current, workInProgress) {
    $081ef12b46fbcaa0$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext), $081ef12b46fbcaa0$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $081ef12b46fbcaa0$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(340));
                $081ef12b46fbcaa0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(340));
                $081ef12b46fbcaa0$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $081ef12b46fbcaa0$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $081ef12b46fbcaa0$var$popHostContainer(), null;
        case 10:
            return $081ef12b46fbcaa0$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $081ef12b46fbcaa0$var$popSuspenseHandler(workInProgress), $081ef12b46fbcaa0$var$popHiddenContext(), null !== current && $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $081ef12b46fbcaa0$var$unwindInterruptedWork(current, interruptedWork) {
    $081ef12b46fbcaa0$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext);
            $081ef12b46fbcaa0$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $081ef12b46fbcaa0$var$popHostContext(interruptedWork);
            break;
        case 4:
            $081ef12b46fbcaa0$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $081ef12b46fbcaa0$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $081ef12b46fbcaa0$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $081ef12b46fbcaa0$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $081ef12b46fbcaa0$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $081ef12b46fbcaa0$var$popSuspenseHandler(interruptedWork);
            $081ef12b46fbcaa0$var$popHiddenContext();
            null !== current && $081ef12b46fbcaa0$var$pop($081ef12b46fbcaa0$var$resumedCache);
            break;
        case 24:
            $081ef12b46fbcaa0$var$popProvider($081ef12b46fbcaa0$var$CacheContext);
    }
}
function $081ef12b46fbcaa0$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $081ef12b46fbcaa0$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $081ef12b46fbcaa0$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $081ef12b46fbcaa0$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $081ef12b46fbcaa0$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $081ef12b46fbcaa0$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $081ef12b46fbcaa0$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $081ef12b46fbcaa0$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $081ef12b46fbcaa0$var$FragmentInstance(current);
                        $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $081ef12b46fbcaa0$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $081ef12b46fbcaa0$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $081ef12b46fbcaa0$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$081ef12b46fbcaa0$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $081ef12b46fbcaa0$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $081ef12b46fbcaa0$var$isFragmentInstanceParent(parent) && $081ef12b46fbcaa0$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($081ef12b46fbcaa0$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $081ef12b46fbcaa0$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $081ef12b46fbcaa0$var$isFragmentInstanceParent(parent) && $081ef12b46fbcaa0$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($081ef12b46fbcaa0$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $081ef12b46fbcaa0$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $081ef12b46fbcaa0$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $081ef12b46fbcaa0$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $081ef12b46fbcaa0$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$081ef12b46fbcaa0$var$internalPropsKey] = newProps;
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $081ef12b46fbcaa0$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $081ef12b46fbcaa0$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $081ef12b46fbcaa0$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $081ef12b46fbcaa0$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $081ef12b46fbcaa0$var$noop$1)), $081ef12b46fbcaa0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($081ef12b46fbcaa0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $081ef12b46fbcaa0$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $081ef12b46fbcaa0$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $081ef12b46fbcaa0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($081ef12b46fbcaa0$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $081ef12b46fbcaa0$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($081ef12b46fbcaa0$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$081ef12b46fbcaa0$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $081ef12b46fbcaa0$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $081ef12b46fbcaa0$var$setInitialProperties(singleton, type, props);
        singleton[$081ef12b46fbcaa0$var$internalInstanceKey] = finishedWork;
        singleton[$081ef12b46fbcaa0$var$internalPropsKey] = props;
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $081ef12b46fbcaa0$var$shouldStartViewTransition = !1, $081ef12b46fbcaa0$var$appearingViewTransitions = null;
function $081ef12b46fbcaa0$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $081ef12b46fbcaa0$var$shouldStartViewTransition = !0;
}
var $081ef12b46fbcaa0$var$viewTransitionCancelableChildren = null;
function $081ef12b46fbcaa0$var$pushViewTransitionCancelableScope() {
    var prevChildren = $081ef12b46fbcaa0$var$viewTransitionCancelableChildren;
    $081ef12b46fbcaa0$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx = 0;
function $081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx = 0;
    return $081ef12b46fbcaa0$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $081ef12b46fbcaa0$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $081ef12b46fbcaa0$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $081ef12b46fbcaa0$var$measureInstance(instance).view && (inViewport = !0);
            $081ef12b46fbcaa0$var$shouldStartViewTransition = !0;
            $081ef12b46fbcaa0$var$applyViewTransitionName(instance, 0 === $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx ? name : name + "_" + $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx, className);
            $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $081ef12b46fbcaa0$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $081ef12b46fbcaa0$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $081ef12b46fbcaa0$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($081ef12b46fbcaa0$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $081ef12b46fbcaa0$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $081ef12b46fbcaa0$var$getViewTransitionName(props, state), className = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($081ef12b46fbcaa0$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $081ef12b46fbcaa0$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $081ef12b46fbcaa0$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$081ef12b46fbcaa0$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $081ef12b46fbcaa0$var$commitAppearingPairViewTransitions(placement);
}
function $081ef12b46fbcaa0$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $081ef12b46fbcaa0$var$appearingViewTransitions && 0 !== $081ef12b46fbcaa0$var$appearingViewTransitions.size) {
        var pairs = $081ef12b46fbcaa0$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $081ef12b46fbcaa0$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $081ef12b46fbcaa0$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $081ef12b46fbcaa0$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $081ef12b46fbcaa0$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $081ef12b46fbcaa0$var$appearingViewTransitions ? $081ef12b46fbcaa0$var$appearingViewTransitions.get(name) : void 0, className = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $081ef12b46fbcaa0$var$appearingViewTransitions.delete(name), $081ef12b46fbcaa0$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $081ef12b46fbcaa0$var$scheduleViewTransitionEvent(deletion, props.onExit) : $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $081ef12b46fbcaa0$var$appearingViewTransitions && $081ef12b46fbcaa0$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$081ef12b46fbcaa0$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $081ef12b46fbcaa0$var$appearingViewTransitions && $081ef12b46fbcaa0$var$commitDeletedPairViewTransitions(deletion);
}
function $081ef12b46fbcaa0$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $081ef12b46fbcaa0$var$getViewTransitionName(props, changedParent.stateNode);
            props = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $081ef12b46fbcaa0$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $081ef12b46fbcaa0$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $081ef12b46fbcaa0$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $081ef12b46fbcaa0$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $081ef12b46fbcaa0$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$081ef12b46fbcaa0$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $081ef12b46fbcaa0$var$restorePairedViewTransitions(fiber);
}
function $081ef12b46fbcaa0$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $081ef12b46fbcaa0$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $081ef12b46fbcaa0$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx], nextMeasurement = $081ef12b46fbcaa0$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $081ef12b46fbcaa0$var$applyViewTransitionName(instance, 0 === $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $081ef12b46fbcaa0$var$viewTransitionCancelableChildren && ($081ef12b46fbcaa0$var$viewTransitionCancelableChildren = []), $081ef12b46fbcaa0$var$viewTransitionCancelableChildren.push(instance, 0 === $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $081ef12b46fbcaa0$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $081ef12b46fbcaa0$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $081ef12b46fbcaa0$var$getViewTransitionName(props, state), className = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($081ef12b46fbcaa0$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx = 0;
            name = $081ef12b46fbcaa0$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $081ef12b46fbcaa0$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $081ef12b46fbcaa0$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = !1, $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = !1, $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = !1, $081ef12b46fbcaa0$var$needsFormReset = !1, $081ef12b46fbcaa0$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $081ef12b46fbcaa0$var$nextEffect = null, $081ef12b46fbcaa0$var$viewTransitionContextChanged = !1, $081ef12b46fbcaa0$var$inUpdateViewTransition = !1, $081ef12b46fbcaa0$var$rootViewTransitionAffected = !1, $081ef12b46fbcaa0$var$rootViewTransitionNameCanceled = !1;
function $081ef12b46fbcaa0$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $081ef12b46fbcaa0$var$eventsEnabled = $081ef12b46fbcaa0$var$_enabled;
    root = $081ef12b46fbcaa0$var$getActiveElementDeep(root);
    if ($081ef12b46fbcaa0$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $081ef12b46fbcaa0$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $081ef12b46fbcaa0$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $081ef12b46fbcaa0$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $081ef12b46fbcaa0$var$nextEffect;){
        root = $081ef12b46fbcaa0$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $081ef12b46fbcaa0$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $081ef12b46fbcaa0$var$trackEnterViewTransitions(root), $081ef12b46fbcaa0$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $081ef12b46fbcaa0$var$commitExitViewTransitions(JSCompiler_temp);
                    $081ef12b46fbcaa0$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $081ef12b46fbcaa0$var$trackEnterViewTransitions(root);
                    $081ef12b46fbcaa0$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $081ef12b46fbcaa0$var$nextEffect = JSCompiler_temp) : (committedLanes && $081ef12b46fbcaa0$var$commitNestedViewTransitions(root), $081ef12b46fbcaa0$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $081ef12b46fbcaa0$var$appearingViewTransitions = null;
}
function $081ef12b46fbcaa0$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $081ef12b46fbcaa0$var$nextEffect;){
        var fiber = $081ef12b46fbcaa0$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $081ef12b46fbcaa0$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $081ef12b46fbcaa0$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $081ef12b46fbcaa0$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $081ef12b46fbcaa0$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $081ef12b46fbcaa0$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $081ef12b46fbcaa0$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $081ef12b46fbcaa0$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $081ef12b46fbcaa0$var$nextEffect = current;
            break;
        }
        $081ef12b46fbcaa0$var$nextEffect = fiber.return;
    }
}
function $081ef12b46fbcaa0$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $081ef12b46fbcaa0$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $081ef12b46fbcaa0$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $081ef12b46fbcaa0$var$commitClassCallbacks(finishedWork);
            flags & 512 && $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $081ef12b46fbcaa0$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostMount(finishedWork);
            flags & 512 && $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $081ef12b46fbcaa0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $081ef12b46fbcaa0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $081ef12b46fbcaa0$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $081ef12b46fbcaa0$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden;
                current = $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden;
                prevProps = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden;
                $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = flags;
                ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = current;
                $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $081ef12b46fbcaa0$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $081ef12b46fbcaa0$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $081ef12b46fbcaa0$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $081ef12b46fbcaa0$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $081ef12b46fbcaa0$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $081ef12b46fbcaa0$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $081ef12b46fbcaa0$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $081ef12b46fbcaa0$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $081ef12b46fbcaa0$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $081ef12b46fbcaa0$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $081ef12b46fbcaa0$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $081ef12b46fbcaa0$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $081ef12b46fbcaa0$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $081ef12b46fbcaa0$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $081ef12b46fbcaa0$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $081ef12b46fbcaa0$var$hostParent = null, $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
function $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$081ef12b46fbcaa0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $081ef12b46fbcaa0$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.onCommitFiberUnmount) try {
        $081ef12b46fbcaa0$var$injectedHook.onCommitFiberUnmount($081ef12b46fbcaa0$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$081ef12b46fbcaa0$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $081ef12b46fbcaa0$var$hostParent, prevHostParentIsContainer = $081ef12b46fbcaa0$var$hostParentIsContainer;
            $081ef12b46fbcaa0$var$isSingletonScope(deletedFiber.type) && ($081ef12b46fbcaa0$var$hostParent = deletedFiber.stateNode, $081ef12b46fbcaa0$var$hostParentIsContainer = !1);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $081ef12b46fbcaa0$var$hostParent = prevHostParent;
            $081ef12b46fbcaa0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $081ef12b46fbcaa0$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $081ef12b46fbcaa0$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $081ef12b46fbcaa0$var$hostParent;
            prevHostParentIsContainer = $081ef12b46fbcaa0$var$hostParentIsContainer;
            $081ef12b46fbcaa0$var$hostParent = null;
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$hostParent = prevHostParent;
            $081ef12b46fbcaa0$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $081ef12b46fbcaa0$var$hostParent) {
                if ($081ef12b46fbcaa0$var$hostParentIsContainer) try {
                    (9 === $081ef12b46fbcaa0$var$hostParent.nodeType ? $081ef12b46fbcaa0$var$hostParent.body : "HTML" === $081ef12b46fbcaa0$var$hostParent.nodeName ? $081ef12b46fbcaa0$var$hostParent.ownerDocument.body : $081ef12b46fbcaa0$var$hostParent).removeChild(deletedFiber.stateNode), $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $081ef12b46fbcaa0$var$hostParent.removeChild(deletedFiber.stateNode), $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $081ef12b46fbcaa0$var$hostParent && ($081ef12b46fbcaa0$var$hostParentIsContainer ? (finishedRoot = $081ef12b46fbcaa0$var$hostParent, $081ef12b46fbcaa0$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $081ef12b46fbcaa0$var$retryIfBlockedOn(finishedRoot)) : $081ef12b46fbcaa0$var$clearHydrationBoundary($081ef12b46fbcaa0$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $081ef12b46fbcaa0$var$hostParent;
            prevHostParentIsContainer = $081ef12b46fbcaa0$var$hostParentIsContainer;
            $081ef12b46fbcaa0$var$hostParent = deletedFiber.stateNode.containerInfo;
            $081ef12b46fbcaa0$var$hostParentIsContainer = !0;
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$hostParent = prevHostParent;
            $081ef12b46fbcaa0$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $081ef12b46fbcaa0$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || ($081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $081ef12b46fbcaa0$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = (prevHostParent = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || $081ef12b46fbcaa0$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $081ef12b46fbcaa0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $081ef12b46fbcaa0$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $081ef12b46fbcaa0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $081ef12b46fbcaa0$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $081ef12b46fbcaa0$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $081ef12b46fbcaa0$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $081ef12b46fbcaa0$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $081ef12b46fbcaa0$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $081ef12b46fbcaa0$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($081ef12b46fbcaa0$var$isSingletonScope(parent.type)) {
                        $081ef12b46fbcaa0$var$hostParent = parent.stateNode;
                        $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $081ef12b46fbcaa0$var$hostParent = parent.stateNode;
                    $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $081ef12b46fbcaa0$var$hostParent = parent.stateNode.containerInfo;
                    $081ef12b46fbcaa0$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $081ef12b46fbcaa0$var$hostParent) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(160));
        $081ef12b46fbcaa0$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $081ef12b46fbcaa0$var$hostParent = null;
        $081ef12b46fbcaa0$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $081ef12b46fbcaa0$var$currentHoistableRoot = null;
function $081ef12b46fbcaa0$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($081ef12b46fbcaa0$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $081ef12b46fbcaa0$var$commitHookEffectListMount(3, finishedWork), $081ef12b46fbcaa0$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            flags & 64 && $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($081ef12b46fbcaa0$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $081ef12b46fbcaa0$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$081ef12b46fbcaa0$var$internalHoistableMarker] || current[$081ef12b46fbcaa0$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $081ef12b46fbcaa0$var$setInitialProperties(current, root, lanes);
                                            current[$081ef12b46fbcaa0$var$internalInstanceKey] = finishedWork;
                                            $081ef12b46fbcaa0$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $081ef12b46fbcaa0$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $081ef12b46fbcaa0$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $081ef12b46fbcaa0$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $081ef12b46fbcaa0$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$081ef12b46fbcaa0$var$internalInstanceKey] = finishedWork;
                                    $081ef12b46fbcaa0$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden || $081ef12b46fbcaa0$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $081ef12b46fbcaa0$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden || $081ef12b46fbcaa0$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $081ef12b46fbcaa0$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden;
            $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = !1;
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = ii;
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $081ef12b46fbcaa0$var$setTextContent(root, ""), $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $081ef12b46fbcaa0$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($081ef12b46fbcaa0$var$needsFormReset = !0);
            break;
        case 6:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $081ef12b46fbcaa0$var$viewTransitionMutationContext = !1;
            $081ef12b46fbcaa0$var$tagCaches = null;
            ii = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$currentHoistableRoot = $081ef12b46fbcaa0$var$getHoistableRoot(root.containerInfo);
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$currentHoistableRoot = ii;
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $081ef12b46fbcaa0$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $081ef12b46fbcaa0$var$needsFormReset && ($081ef12b46fbcaa0$var$needsFormReset = !1, $081ef12b46fbcaa0$var$recursivelyResetForms(finishedWork));
            $081ef12b46fbcaa0$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden;
            $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden;
            current = $081ef12b46fbcaa0$var$pushMutationContext();
            ii = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$currentHoistableRoot = $081ef12b46fbcaa0$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            $081ef12b46fbcaa0$var$currentHoistableRoot = ii;
            $081ef12b46fbcaa0$var$viewTransitionMutationContext && $081ef12b46fbcaa0$var$inUpdateViewTransition && ($081ef12b46fbcaa0$var$rootViewTransitionAffected = !0);
            $081ef12b46fbcaa0$var$viewTransitionMutationContext = current;
            $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($081ef12b46fbcaa0$var$globalMostRecentFallbackTime = $081ef12b46fbcaa0$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden;
            $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden, lanes = $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden, current = $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden, $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = ii || $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden, $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = root, $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden = lanes, $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden = current), !ii && $081ef12b46fbcaa0$var$offscreenDirectParentIsHidden || $081ef12b46fbcaa0$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $081ef12b46fbcaa0$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return));
            flags = $081ef12b46fbcaa0$var$pushMutationContext();
            ii = $081ef12b46fbcaa0$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $081ef12b46fbcaa0$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $081ef12b46fbcaa0$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $081ef12b46fbcaa0$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $081ef12b46fbcaa0$var$inUpdateViewTransition = ii;
            $081ef12b46fbcaa0$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || null === current || $081ef12b46fbcaa0$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork);
    }
}
function $081ef12b46fbcaa0$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($081ef12b46fbcaa0$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($081ef12b46fbcaa0$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($081ef12b46fbcaa0$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $081ef12b46fbcaa0$var$getHostSibling(finishedWork);
                    $081ef12b46fbcaa0$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($081ef12b46fbcaa0$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $081ef12b46fbcaa0$var$getHostSibling(finishedWork);
                    $081ef12b46fbcaa0$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $081ef12b46fbcaa0$var$getHostSibling(finishedWork);
                    $081ef12b46fbcaa0$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $081ef12b46fbcaa0$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $081ef12b46fbcaa0$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $081ef12b46fbcaa0$var$_enabled = !0, fiber.reset(), $081ef12b46fbcaa0$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $081ef12b46fbcaa0$var$measureNestedViewTransitions(parentFiber, !1);
}
function $081ef12b46fbcaa0$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $081ef12b46fbcaa0$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $081ef12b46fbcaa0$var$rootViewTransitionNameCanceled = $081ef12b46fbcaa0$var$viewTransitionContextChanged = !1;
            $081ef12b46fbcaa0$var$pushViewTransitionCancelableScope();
            $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$081ef12b46fbcaa0$var$viewTransitionContextChanged && !$081ef12b46fbcaa0$var$rootViewTransitionAffected) {
                finishedWork = $081ef12b46fbcaa0$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $081ef12b46fbcaa0$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $081ef12b46fbcaa0$var$rootViewTransitionNameCanceled = !0;
            }
            $081ef12b46fbcaa0$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $081ef12b46fbcaa0$var$viewTransitionContextChanged;
            $081ef12b46fbcaa0$var$viewTransitionContextChanged = !1;
            $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$viewTransitionContextChanged && ($081ef12b46fbcaa0$var$rootViewTransitionAffected = !0);
            $081ef12b46fbcaa0$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $081ef12b46fbcaa0$var$commitEnterViewTransitions(finishedWork, !1) : $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $081ef12b46fbcaa0$var$viewTransitionContextChanged;
            oldName = $081ef12b46fbcaa0$var$pushViewTransitionCancelableScope();
            $081ef12b46fbcaa0$var$viewTransitionContextChanged = !1;
            $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $081ef12b46fbcaa0$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $081ef12b46fbcaa0$var$getViewTransitionName(props, state);
            state = $081ef12b46fbcaa0$var$getViewTransitionName(current.memoizedProps, state);
            var className = $081ef12b46fbcaa0$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx = 0, root = $081ef12b46fbcaa0$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $081ef12b46fbcaa0$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($081ef12b46fbcaa0$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $081ef12b46fbcaa0$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $081ef12b46fbcaa0$var$viewTransitionCancelableChildren), $081ef12b46fbcaa0$var$viewTransitionCancelableChildren = oldName);
            $081ef12b46fbcaa0$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $081ef12b46fbcaa0$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $081ef12b46fbcaa0$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $081ef12b46fbcaa0$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $081ef12b46fbcaa0$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $081ef12b46fbcaa0$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $081ef12b46fbcaa0$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $081ef12b46fbcaa0$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $081ef12b46fbcaa0$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$081ef12b46fbcaa0$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $081ef12b46fbcaa0$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $081ef12b46fbcaa0$var$commitClassCallbacks(finishedWork);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $081ef12b46fbcaa0$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $081ef12b46fbcaa0$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostMount(finishedWork);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $081ef12b46fbcaa0$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $081ef12b46fbcaa0$var$offscreenSubtreeIsHidden || $081ef12b46fbcaa0$var$mountHoistable($081ef12b46fbcaa0$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $081ef12b46fbcaa0$var$commitHostMount(finishedWork);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $081ef12b46fbcaa0$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $081ef12b46fbcaa0$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $081ef12b46fbcaa0$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $081ef12b46fbcaa0$var$releaseCache(previousCache));
}
function $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $081ef12b46fbcaa0$var$releaseCache(current));
}
function $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $081ef12b46fbcaa0$var$restoreNestedViewTransitions(parentFiber);
}
function $081ef12b46fbcaa0$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $081ef12b46fbcaa0$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $081ef12b46fbcaa0$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $081ef12b46fbcaa0$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $081ef12b46fbcaa0$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $081ef12b46fbcaa0$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $081ef12b46fbcaa0$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $081ef12b46fbcaa0$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(flags.child, !0), $081ef12b46fbcaa0$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $081ef12b46fbcaa0$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $081ef12b46fbcaa0$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $081ef12b46fbcaa0$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $081ef12b46fbcaa0$var$suspenseyCommitFlag = 8192;
function $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $081ef12b46fbcaa0$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $081ef12b46fbcaa0$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $081ef12b46fbcaa0$var$suspendResource(suspendedState, $081ef12b46fbcaa0$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $081ef12b46fbcaa0$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $081ef12b46fbcaa0$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $081ef12b46fbcaa0$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $081ef12b46fbcaa0$var$currentHoistableRoot;
            $081ef12b46fbcaa0$var$currentHoistableRoot = $081ef12b46fbcaa0$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $081ef12b46fbcaa0$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $081ef12b46fbcaa0$var$suspenseyCommitFlag, $081ef12b46fbcaa0$var$suspenseyCommitFlag = 16777216, $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $081ef12b46fbcaa0$var$suspenseyCommitFlag = previousHoistableRoot) : $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $081ef12b46fbcaa0$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $081ef12b46fbcaa0$var$appearingViewTransitions && ($081ef12b46fbcaa0$var$appearingViewTransitions = new Map());
                $081ef12b46fbcaa0$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $081ef12b46fbcaa0$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $081ef12b46fbcaa0$var$nextEffect = childToDelete;
            $081ef12b46fbcaa0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $081ef12b46fbcaa0$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$081ef12b46fbcaa0$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $081ef12b46fbcaa0$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $081ef12b46fbcaa0$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $081ef12b46fbcaa0$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $081ef12b46fbcaa0$var$nextEffect = childToDelete;
            $081ef12b46fbcaa0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $081ef12b46fbcaa0$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $081ef12b46fbcaa0$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $081ef12b46fbcaa0$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $081ef12b46fbcaa0$var$nextEffect;){
        var fiber = $081ef12b46fbcaa0$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $081ef12b46fbcaa0$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $081ef12b46fbcaa0$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $081ef12b46fbcaa0$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $081ef12b46fbcaa0$var$nextEffect;){
            cache = $081ef12b46fbcaa0$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $081ef12b46fbcaa0$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $081ef12b46fbcaa0$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $081ef12b46fbcaa0$var$nextEffect = sibling;
                break a;
            }
            $081ef12b46fbcaa0$var$nextEffect = returnFiber;
        }
    }
}
var $081ef12b46fbcaa0$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $081ef12b46fbcaa0$var$readContext($081ef12b46fbcaa0$var$CacheContext).controller.signal;
    }
}, $081ef12b46fbcaa0$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $081ef12b46fbcaa0$var$executionContext = 0, $081ef12b46fbcaa0$var$workInProgressRoot = null, $081ef12b46fbcaa0$var$workInProgress = null, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0, $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings = !1, $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = !1, $081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener = !1, $081ef12b46fbcaa0$var$entangledRenderLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 0, $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootPingedLanes = 0, $081ef12b46fbcaa0$var$workInProgressDeferredLane = 0, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes = 0, $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors = null, $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = null, $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $081ef12b46fbcaa0$var$globalMostRecentFallbackTime = 0, $081ef12b46fbcaa0$var$globalMostRecentTransitionTime = 0, $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime = Infinity, $081ef12b46fbcaa0$var$workInProgressTransitions = null, $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed = null, $081ef12b46fbcaa0$var$pendingEffectsStatus = 0, $081ef12b46fbcaa0$var$pendingEffectsRoot = null, $081ef12b46fbcaa0$var$pendingFinishedWork = null, $081ef12b46fbcaa0$var$pendingEffectsLanes = 0, $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes = 0, $081ef12b46fbcaa0$var$pendingPassiveTransitions = null, $081ef12b46fbcaa0$var$pendingRecoverableErrors = null, $081ef12b46fbcaa0$var$pendingViewTransition = null, $081ef12b46fbcaa0$var$pendingViewTransitionEvents = null, $081ef12b46fbcaa0$var$pendingTransitionTypes = null, $081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = null;
function $081ef12b46fbcaa0$var$requestUpdateLane() {
    return 0 !== ($081ef12b46fbcaa0$var$executionContext & 2) && 0 !== $081ef12b46fbcaa0$var$workInProgressRootRenderLanes ? $081ef12b46fbcaa0$var$workInProgressRootRenderLanes & -$081ef12b46fbcaa0$var$workInProgressRootRenderLanes : null !== $081ef12b46fbcaa0$var$ReactSharedInternals.T ? $081ef12b46fbcaa0$var$requestTransitionLane() : $081ef12b46fbcaa0$var$resolveUpdatePriority();
}
function $081ef12b46fbcaa0$var$requestDeferredLane() {
    if (0 === $081ef12b46fbcaa0$var$workInProgressDeferredLane) {
        if (0 === ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 536870912) || $081ef12b46fbcaa0$var$isHydrating) {
            var lane = $081ef12b46fbcaa0$var$nextTransitionDeferredLane;
            $081ef12b46fbcaa0$var$nextTransitionDeferredLane <<= 1;
            0 === ($081ef12b46fbcaa0$var$nextTransitionDeferredLane & 3932160) && ($081ef12b46fbcaa0$var$nextTransitionDeferredLane = 262144);
            $081ef12b46fbcaa0$var$workInProgressDeferredLane = lane;
        } else $081ef12b46fbcaa0$var$workInProgressDeferredLane = 536870912;
    }
    lane = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $081ef12b46fbcaa0$var$workInProgressDeferredLane;
}
function $081ef12b46fbcaa0$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $081ef12b46fbcaa0$var$createViewTransitionInstance($081ef12b46fbcaa0$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $081ef12b46fbcaa0$var$pendingViewTransitionEvents && ($081ef12b46fbcaa0$var$pendingViewTransitionEvents = []);
        $081ef12b46fbcaa0$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $081ef12b46fbcaa0$var$workInProgressRoot && (2 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason || 9 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $081ef12b46fbcaa0$var$prepareFreshStack(root, 0), $081ef12b46fbcaa0$var$markRootSuspended(root, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !1);
    $081ef12b46fbcaa0$var$markRootUpdated$1(root, lane);
    if (0 === ($081ef12b46fbcaa0$var$executionContext & 2) || root !== $081ef12b46fbcaa0$var$workInProgressRoot) root === $081ef12b46fbcaa0$var$workInProgressRoot && (0 === ($081ef12b46fbcaa0$var$executionContext & 2) && ($081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && $081ef12b46fbcaa0$var$markRootSuspended(root, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !1)), $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
}
function $081ef12b46fbcaa0$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 6)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $081ef12b46fbcaa0$var$renderRootConcurrent(root$jscomp$0, lanes) : $081ef12b46fbcaa0$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $081ef12b46fbcaa0$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$081ef12b46fbcaa0$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $081ef12b46fbcaa0$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($081ef12b46fbcaa0$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $081ef12b46fbcaa0$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors;
                            $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors ? $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors.push.apply($081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $081ef12b46fbcaa0$var$prepareFreshStack(root$jscomp$0, 0);
                $081ef12b46fbcaa0$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $081ef12b46fbcaa0$var$markRootSuspended(shouldTimeSlice, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !$081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $081ef12b46fbcaa0$var$globalMostRecentFallbackTime + 300 - $081ef12b46fbcaa0$var$now(), 10 < exitStatus)) {
                    $081ef12b46fbcaa0$var$markRootSuspended(shouldTimeSlice, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !$081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $081ef12b46fbcaa0$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $081ef12b46fbcaa0$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $081ef12b46fbcaa0$var$scheduleTimeout($081ef12b46fbcaa0$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, $081ef12b46fbcaa0$var$workInProgressTransitions, $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $081ef12b46fbcaa0$var$completeRootWhenReady(shouldTimeSlice, forceSync, $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors, $081ef12b46fbcaa0$var$workInProgressTransitions, $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $081ef12b46fbcaa0$var$ensureRootIsScheduled(root$jscomp$0);
}
function $081ef12b46fbcaa0$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $081ef12b46fbcaa0$var$noop$1
        }, $081ef12b46fbcaa0$var$appearingViewTransitions = null, $081ef12b46fbcaa0$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $081ef12b46fbcaa0$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $081ef12b46fbcaa0$var$globalMostRecentFallbackTime - $081ef12b46fbcaa0$var$now() : (lanes & 4194048) === lanes ? $081ef12b46fbcaa0$var$globalMostRecentTransitionTime - $081ef12b46fbcaa0$var$now() : 0, subtreeFlags = $081ef12b46fbcaa0$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $081ef12b46fbcaa0$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($081ef12b46fbcaa0$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $081ef12b46fbcaa0$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $081ef12b46fbcaa0$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $081ef12b46fbcaa0$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$081ef12b46fbcaa0$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $081ef12b46fbcaa0$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $081ef12b46fbcaa0$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$081ef12b46fbcaa0$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $081ef12b46fbcaa0$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $081ef12b46fbcaa0$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $081ef12b46fbcaa0$var$flushSyncWork$1() {
    return 0 === ($081ef12b46fbcaa0$var$executionContext & 6) ? ($081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $081ef12b46fbcaa0$var$resetWorkInProgressStack() {
    if (null !== $081ef12b46fbcaa0$var$workInProgress) {
        if (0 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason) var interruptedWork = $081ef12b46fbcaa0$var$workInProgress.return;
        else interruptedWork = $081ef12b46fbcaa0$var$workInProgress, $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null, $081ef12b46fbcaa0$var$resetHooksOnUnwind(interruptedWork), $081ef12b46fbcaa0$var$thenableState$1 = null, $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0, interruptedWork = $081ef12b46fbcaa0$var$workInProgress;
        for(; null !== interruptedWork;)$081ef12b46fbcaa0$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $081ef12b46fbcaa0$var$workInProgress = null;
    }
}
function $081ef12b46fbcaa0$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $081ef12b46fbcaa0$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $081ef12b46fbcaa0$var$pendingEffectsLanes = 0;
    $081ef12b46fbcaa0$var$resetWorkInProgressStack();
    $081ef12b46fbcaa0$var$workInProgressRoot = root;
    $081ef12b46fbcaa0$var$workInProgress = timeoutHandle = $081ef12b46fbcaa0$var$createWorkInProgress(root.current, null);
    $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = lanes;
    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
    $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, lanes);
    $081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener = !1;
    $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes = $081ef12b46fbcaa0$var$workInProgressDeferredLane = $081ef12b46fbcaa0$var$workInProgressRootPingedLanes = $081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes = $081ef12b46fbcaa0$var$workInProgressRootSkippedLanes = $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 0;
    $081ef12b46fbcaa0$var$workInProgressRootRecoverableErrors = $081ef12b46fbcaa0$var$workInProgressRootConcurrentErrors = null;
    $081ef12b46fbcaa0$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $081ef12b46fbcaa0$var$entangledRenderLanes = $081ef12b46fbcaa0$var$getEntangledLanes(root, lanes);
    $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $081ef12b46fbcaa0$var$handleThrow(root, thrownValue) {
    $081ef12b46fbcaa0$var$currentlyRenderingFiber = null;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$ContextOnlyDispatcher;
    thrownValue === $081ef12b46fbcaa0$var$SuspenseException || thrownValue === $081ef12b46fbcaa0$var$SuspenseActionException ? (thrownValue = $081ef12b46fbcaa0$var$getSuspendedThenable(), $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 3) : thrownValue === $081ef12b46fbcaa0$var$SuspenseyCommitException ? (thrownValue = $081ef12b46fbcaa0$var$getSuspendedThenable(), $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 4) : $081ef12b46fbcaa0$var$workInProgressSuspendedReason = thrownValue === $081ef12b46fbcaa0$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $081ef12b46fbcaa0$var$workInProgressThrownValue = thrownValue;
    null === $081ef12b46fbcaa0$var$workInProgress && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 1, $081ef12b46fbcaa0$var$logUncaughtError(root, $081ef12b46fbcaa0$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $081ef12b46fbcaa0$var$shouldRemainOnPreviousScreen() {
    var handler = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 4194048) === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes ? null === $081ef12b46fbcaa0$var$shellBoundary ? !0 : !1 : ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 62914560) === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes || 0 !== ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 536870912) ? handler === $081ef12b46fbcaa0$var$shellBoundary : !1;
}
function $081ef12b46fbcaa0$var$pushDispatcher() {
    var prevDispatcher = $081ef12b46fbcaa0$var$ReactSharedInternals.H;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = $081ef12b46fbcaa0$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $081ef12b46fbcaa0$var$ContextOnlyDispatcher : prevDispatcher;
}
function $081ef12b46fbcaa0$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $081ef12b46fbcaa0$var$ReactSharedInternals.A;
    $081ef12b46fbcaa0$var$ReactSharedInternals.A = $081ef12b46fbcaa0$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $081ef12b46fbcaa0$var$renderDidSuspendDelayIfPossible() {
    $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 4;
    $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings || ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 4194048) !== $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && null !== $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current || ($081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = !0);
    0 === ($081ef12b46fbcaa0$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($081ef12b46fbcaa0$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $081ef12b46fbcaa0$var$workInProgressRoot || $081ef12b46fbcaa0$var$markRootSuspended($081ef12b46fbcaa0$var$workInProgressRoot, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, $081ef12b46fbcaa0$var$workInProgressDeferredLane, !1);
}
function $081ef12b46fbcaa0$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
    $081ef12b46fbcaa0$var$executionContext |= 2;
    var prevDispatcher = $081ef12b46fbcaa0$var$pushDispatcher(), prevAsyncDispatcher = $081ef12b46fbcaa0$var$pushAsyncDispatcher();
    if ($081ef12b46fbcaa0$var$workInProgressRoot !== root || $081ef12b46fbcaa0$var$workInProgressRootRenderLanes !== lanes) $081ef12b46fbcaa0$var$workInProgressTransitions = null, $081ef12b46fbcaa0$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $081ef12b46fbcaa0$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason && null !== $081ef12b46fbcaa0$var$workInProgress) {
            var unitOfWork = $081ef12b46fbcaa0$var$workInProgress, thrownValue = $081ef12b46fbcaa0$var$workInProgressThrownValue;
            switch($081ef12b46fbcaa0$var$workInProgressSuspendedReason){
                case 8:
                    $081ef12b46fbcaa0$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $081ef12b46fbcaa0$var$workInProgressSuspendedReason;
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $081ef12b46fbcaa0$var$workInProgressSuspendedReason, $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $081ef12b46fbcaa0$var$workLoopSync();
        exitStatus = $081ef12b46fbcaa0$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $081ef12b46fbcaa0$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null;
    $081ef12b46fbcaa0$var$executionContext = prevExecutionContext;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = prevDispatcher;
    $081ef12b46fbcaa0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $081ef12b46fbcaa0$var$workInProgress && ($081ef12b46fbcaa0$var$workInProgressRoot = null, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0, $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $081ef12b46fbcaa0$var$workLoopSync() {
    for(; null !== $081ef12b46fbcaa0$var$workInProgress;)$081ef12b46fbcaa0$var$performUnitOfWork($081ef12b46fbcaa0$var$workInProgress);
}
function $081ef12b46fbcaa0$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
    $081ef12b46fbcaa0$var$executionContext |= 2;
    var prevDispatcher = $081ef12b46fbcaa0$var$pushDispatcher(), prevAsyncDispatcher = $081ef12b46fbcaa0$var$pushAsyncDispatcher();
    $081ef12b46fbcaa0$var$workInProgressRoot !== root || $081ef12b46fbcaa0$var$workInProgressRootRenderLanes !== lanes ? ($081ef12b46fbcaa0$var$workInProgressTransitions = null, $081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime = $081ef12b46fbcaa0$var$now() + 500, $081ef12b46fbcaa0$var$prepareFreshStack(root, lanes)) : $081ef12b46fbcaa0$var$workInProgressRootIsPrerendering = $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason && null !== $081ef12b46fbcaa0$var$workInProgress) {
            lanes = $081ef12b46fbcaa0$var$workInProgress;
            var thrownValue = $081ef12b46fbcaa0$var$workInProgressThrownValue;
            b: switch($081ef12b46fbcaa0$var$workInProgressSuspendedReason){
                case 1:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($081ef12b46fbcaa0$var$isThenableResolved(thrownValue)) {
                        $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                        $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                        $081ef12b46fbcaa0$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason && 9 !== $081ef12b46fbcaa0$var$workInProgressSuspendedReason || $081ef12b46fbcaa0$var$workInProgressRoot !== root || ($081ef12b46fbcaa0$var$workInProgressSuspendedReason = 7);
                        $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $081ef12b46fbcaa0$var$isThenableResolved(thrownValue) ? ($081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$replaySuspendedUnitOfWork(lanes)) : ($081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0, $081ef12b46fbcaa0$var$workInProgressThrownValue = null, $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($081ef12b46fbcaa0$var$workInProgress.tag){
                        case 26:
                            resource = $081ef12b46fbcaa0$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $081ef12b46fbcaa0$var$workInProgress;
                            if (resource ? $081ef12b46fbcaa0$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                                $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $081ef12b46fbcaa0$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($081ef12b46fbcaa0$var$workInProgress = returnFiber, $081ef12b46fbcaa0$var$completeUnitOfWork(returnFiber)) : $081ef12b46fbcaa0$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $081ef12b46fbcaa0$var$workInProgressSuspendedReason = 0;
                    $081ef12b46fbcaa0$var$workInProgressThrownValue = null;
                    $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $081ef12b46fbcaa0$var$resetWorkInProgressStack();
                    $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(462));
            }
        }
        $081ef12b46fbcaa0$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $081ef12b46fbcaa0$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null;
    $081ef12b46fbcaa0$var$ReactSharedInternals.H = prevDispatcher;
    $081ef12b46fbcaa0$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $081ef12b46fbcaa0$var$executionContext = prevExecutionContext;
    if (null !== $081ef12b46fbcaa0$var$workInProgress) return 0;
    $081ef12b46fbcaa0$var$workInProgressRoot = null;
    $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0;
    $081ef12b46fbcaa0$var$finishQueueingConcurrentUpdates();
    return $081ef12b46fbcaa0$var$workInProgressRootExitStatus;
}
function $081ef12b46fbcaa0$var$workLoopConcurrentByScheduler() {
    for(; null !== $081ef12b46fbcaa0$var$workInProgress && !$081ef12b46fbcaa0$var$shouldYield();)$081ef12b46fbcaa0$var$performUnitOfWork($081ef12b46fbcaa0$var$workInProgress);
}
function $081ef12b46fbcaa0$var$performUnitOfWork(unitOfWork) {
    var next = $081ef12b46fbcaa0$var$beginWork(unitOfWork.alternate, unitOfWork, $081ef12b46fbcaa0$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork) : $081ef12b46fbcaa0$var$workInProgress = next;
}
function $081ef12b46fbcaa0$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $081ef12b46fbcaa0$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $081ef12b46fbcaa0$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $081ef12b46fbcaa0$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $081ef12b46fbcaa0$var$hydrationParentFiber && ($081ef12b46fbcaa0$var$isHydrating ? ($081ef12b46fbcaa0$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($081ef12b46fbcaa0$var$nextHydratableInstance = fiber.stateNode)) : ($081ef12b46fbcaa0$var$popToNextHostParent(fiber), $081ef12b46fbcaa0$var$isHydrating = !0));
        default:
            $081ef12b46fbcaa0$var$unwindInterruptedWork(current, next), next = $081ef12b46fbcaa0$var$workInProgress = $081ef12b46fbcaa0$var$resetWorkInProgress(next, $081ef12b46fbcaa0$var$entangledRenderLanes), next = $081ef12b46fbcaa0$var$beginWork(current, next, $081ef12b46fbcaa0$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork) : $081ef12b46fbcaa0$var$workInProgress = next;
}
function $081ef12b46fbcaa0$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $081ef12b46fbcaa0$var$lastContextDependency = $081ef12b46fbcaa0$var$currentlyRenderingFiber$1 = null;
    $081ef12b46fbcaa0$var$resetHooksOnUnwind(unitOfWork);
    $081ef12b46fbcaa0$var$thenableState$1 = null;
    $081ef12b46fbcaa0$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($081ef12b46fbcaa0$var$throwException(root, returnFiber, unitOfWork, thrownValue, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes)) {
            $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 1;
            $081ef12b46fbcaa0$var$logUncaughtError(root, $081ef12b46fbcaa0$var$createCapturedValueAtFiber(thrownValue, root.current));
            $081ef12b46fbcaa0$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $081ef12b46fbcaa0$var$workInProgress = returnFiber, error;
        $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 1;
        $081ef12b46fbcaa0$var$logUncaughtError(root, $081ef12b46fbcaa0$var$createCapturedValueAtFiber(thrownValue, root.current));
        $081ef12b46fbcaa0$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($081ef12b46fbcaa0$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($081ef12b46fbcaa0$var$workInProgressRootIsPrerendering || 0 !== ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $081ef12b46fbcaa0$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $081ef12b46fbcaa0$var$unwindUnitOfWork(unitOfWork, root);
    } else $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork);
}
function $081ef12b46fbcaa0$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $081ef12b46fbcaa0$var$unwindUnitOfWork(completedWork, $081ef12b46fbcaa0$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $081ef12b46fbcaa0$var$completeWork(completedWork.alternate, completedWork, $081ef12b46fbcaa0$var$entangledRenderLanes);
        if (null !== next) {
            $081ef12b46fbcaa0$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $081ef12b46fbcaa0$var$workInProgress = completedWork;
            return;
        }
        $081ef12b46fbcaa0$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootExitStatus = 5);
}
function $081ef12b46fbcaa0$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $081ef12b46fbcaa0$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $081ef12b46fbcaa0$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $081ef12b46fbcaa0$var$workInProgress = unitOfWork;
            return;
        }
        $081ef12b46fbcaa0$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $081ef12b46fbcaa0$var$workInProgressRootExitStatus = 6;
    $081ef12b46fbcaa0$var$workInProgress = null;
}
function $081ef12b46fbcaa0$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $081ef12b46fbcaa0$var$flushPendingEffects();
    while (0 !== $081ef12b46fbcaa0$var$pendingEffectsStatus);
    if (0 !== ($081ef12b46fbcaa0$var$executionContext & 6)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(177));
        root === $081ef12b46fbcaa0$var$workInProgressRoot && ($081ef12b46fbcaa0$var$workInProgress = $081ef12b46fbcaa0$var$workInProgressRoot = null, $081ef12b46fbcaa0$var$workInProgressRootRenderLanes = 0);
        $081ef12b46fbcaa0$var$pendingFinishedWork = finishedWork;
        $081ef12b46fbcaa0$var$pendingEffectsRoot = root;
        $081ef12b46fbcaa0$var$pendingEffectsLanes = lanes;
        $081ef12b46fbcaa0$var$pendingPassiveTransitions = transitions;
        $081ef12b46fbcaa0$var$pendingRecoverableErrors = recoverableErrors;
        $081ef12b46fbcaa0$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $081ef12b46fbcaa0$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $081ef12b46fbcaa0$var$concurrentlyUpdatedLanes;
    $081ef12b46fbcaa0$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $081ef12b46fbcaa0$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($081ef12b46fbcaa0$var$pendingTransitionTypes = $081ef12b46fbcaa0$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($081ef12b46fbcaa0$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $081ef12b46fbcaa0$var$scheduleCallback$1($081ef12b46fbcaa0$var$NormalPriority$1, function() {
        $081ef12b46fbcaa0$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $081ef12b46fbcaa0$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
        $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
        updatedLanes = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $081ef12b46fbcaa0$var$executionContext;
        $081ef12b46fbcaa0$var$executionContext |= 4;
        try {
            $081ef12b46fbcaa0$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $081ef12b46fbcaa0$var$executionContext = suspendedRetryLanes, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = updatedLanes, $081ef12b46fbcaa0$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $081ef12b46fbcaa0$var$pendingEffectsStatus = 1;
    $081ef12b46fbcaa0$var$shouldStartViewTransition ? $081ef12b46fbcaa0$var$pendingViewTransition = $081ef12b46fbcaa0$var$startViewTransition(suspendedState, root.containerInfo, $081ef12b46fbcaa0$var$pendingTransitionTypes, $081ef12b46fbcaa0$var$flushMutationEffects, $081ef12b46fbcaa0$var$flushLayoutEffects, $081ef12b46fbcaa0$var$flushAfterMutationEffects, $081ef12b46fbcaa0$var$flushSpawnedWork, $081ef12b46fbcaa0$var$flushPassiveEffects, $081ef12b46fbcaa0$var$reportViewTransitionError, null, null) : ($081ef12b46fbcaa0$var$flushMutationEffects(), $081ef12b46fbcaa0$var$flushLayoutEffects(), $081ef12b46fbcaa0$var$flushSpawnedWork());
}
function $081ef12b46fbcaa0$var$reportViewTransitionError(error) {
    if (0 !== $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        var onRecoverableError = $081ef12b46fbcaa0$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $081ef12b46fbcaa0$var$flushAfterMutationEffects() {
    3 === $081ef12b46fbcaa0$var$pendingEffectsStatus && ($081ef12b46fbcaa0$var$pendingEffectsStatus = 0, $081ef12b46fbcaa0$var$commitAfterMutationEffectsOnFiber($081ef12b46fbcaa0$var$pendingFinishedWork, $081ef12b46fbcaa0$var$pendingEffectsRoot), $081ef12b46fbcaa0$var$pendingEffectsStatus = 4);
}
function $081ef12b46fbcaa0$var$flushMutationEffects() {
    if (1 === $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, finishedWork = $081ef12b46fbcaa0$var$pendingFinishedWork, lanes = $081ef12b46fbcaa0$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
            $081ef12b46fbcaa0$var$executionContext |= 4;
            try {
                $081ef12b46fbcaa0$var$inUpdateViewTransition = $081ef12b46fbcaa0$var$rootViewTransitionAffected = !1;
                $081ef12b46fbcaa0$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $081ef12b46fbcaa0$var$selectionInformation;
                var curFocusedElem = $081ef12b46fbcaa0$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $081ef12b46fbcaa0$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $081ef12b46fbcaa0$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $081ef12b46fbcaa0$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $081ef12b46fbcaa0$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $081ef12b46fbcaa0$var$_enabled = !!$081ef12b46fbcaa0$var$eventsEnabled;
                $081ef12b46fbcaa0$var$selectionInformation = $081ef12b46fbcaa0$var$eventsEnabled = null;
            } finally{
                $081ef12b46fbcaa0$var$executionContext = prevExecutionContext, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 2;
    }
}
function $081ef12b46fbcaa0$var$flushLayoutEffects() {
    if (2 === $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, finishedWork = $081ef12b46fbcaa0$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
            $081ef12b46fbcaa0$var$executionContext |= 4;
            try {
                $081ef12b46fbcaa0$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $081ef12b46fbcaa0$var$executionContext = prevExecutionContext, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 3;
    }
}
function $081ef12b46fbcaa0$var$flushSpawnedWork() {
    if (4 === $081ef12b46fbcaa0$var$pendingEffectsStatus || 3 === $081ef12b46fbcaa0$var$pendingEffectsStatus) {
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        var committedViewTransition = $081ef12b46fbcaa0$var$pendingViewTransition;
        $081ef12b46fbcaa0$var$pendingViewTransition = null;
        $081ef12b46fbcaa0$var$requestPaint();
        var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, finishedWork = $081ef12b46fbcaa0$var$pendingFinishedWork, lanes = $081ef12b46fbcaa0$var$pendingEffectsLanes, recoverableErrors = $081ef12b46fbcaa0$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $081ef12b46fbcaa0$var$pendingEffectsStatus = 5 : ($081ef12b46fbcaa0$var$pendingEffectsStatus = 0, $081ef12b46fbcaa0$var$pendingFinishedWork = $081ef12b46fbcaa0$var$pendingEffectsRoot = null, $081ef12b46fbcaa0$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $081ef12b46fbcaa0$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.onCommitFiberRoot) try {
            $081ef12b46fbcaa0$var$injectedHook.onCommitFiberRoot($081ef12b46fbcaa0$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
            passiveSubtreeMask = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
            $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2;
            $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $081ef12b46fbcaa0$var$ReactSharedInternals.T = finishedWork, $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $081ef12b46fbcaa0$var$pendingViewTransitionEvents;
        onRecoverableError = $081ef12b46fbcaa0$var$pendingTransitionTypes;
        $081ef12b46fbcaa0$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($081ef12b46fbcaa0$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($081ef12b46fbcaa0$var$pendingEffectsLanes & 3) && $081ef12b46fbcaa0$var$flushPendingEffects();
        $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $081ef12b46fbcaa0$var$rootWithNestedUpdates ? $081ef12b46fbcaa0$var$nestedUpdateCount++ : ($081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = root) : ($081ef12b46fbcaa0$var$nestedUpdateCount = 0, $081ef12b46fbcaa0$var$rootWithNestedUpdates = null);
        $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $081ef12b46fbcaa0$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $081ef12b46fbcaa0$var$releaseCache(remainingLanes)));
}
function $081ef12b46fbcaa0$var$flushPendingEffects() {
    null !== $081ef12b46fbcaa0$var$pendingViewTransition && ($081ef12b46fbcaa0$var$pendingViewTransition.skipTransition(), $081ef12b46fbcaa0$var$pendingViewTransition = null);
    $081ef12b46fbcaa0$var$flushMutationEffects();
    $081ef12b46fbcaa0$var$flushLayoutEffects();
    $081ef12b46fbcaa0$var$flushSpawnedWork();
    return $081ef12b46fbcaa0$var$flushPassiveEffects();
}
function $081ef12b46fbcaa0$var$flushPassiveEffects() {
    if (5 !== $081ef12b46fbcaa0$var$pendingEffectsStatus) return !1;
    var root = $081ef12b46fbcaa0$var$pendingEffectsRoot, remainingLanes = $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes;
    $081ef12b46fbcaa0$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $081ef12b46fbcaa0$var$lanesToEventPriority($081ef12b46fbcaa0$var$pendingEffectsLanes), prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T, previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
        renderPriority = $081ef12b46fbcaa0$var$pendingPassiveTransitions;
        $081ef12b46fbcaa0$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $081ef12b46fbcaa0$var$pendingEffectsRoot, lanes = $081ef12b46fbcaa0$var$pendingEffectsLanes;
        $081ef12b46fbcaa0$var$pendingEffectsStatus = 0;
        $081ef12b46fbcaa0$var$pendingFinishedWork = $081ef12b46fbcaa0$var$pendingEffectsRoot = null;
        $081ef12b46fbcaa0$var$pendingEffectsLanes = 0;
        if (0 !== ($081ef12b46fbcaa0$var$executionContext & 6)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(331));
        var prevExecutionContext = $081ef12b46fbcaa0$var$executionContext;
        $081ef12b46fbcaa0$var$executionContext |= 4;
        $081ef12b46fbcaa0$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $081ef12b46fbcaa0$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $081ef12b46fbcaa0$var$executionContext = prevExecutionContext;
        $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($081ef12b46fbcaa0$var$injectedHook && "function" === typeof $081ef12b46fbcaa0$var$injectedHook.onPostCommitFiberRoot) try {
            $081ef12b46fbcaa0$var$injectedHook.onPostCommitFiberRoot($081ef12b46fbcaa0$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition, $081ef12b46fbcaa0$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $081ef12b46fbcaa0$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $081ef12b46fbcaa0$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $081ef12b46fbcaa0$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($081ef12b46fbcaa0$var$markRootUpdated$1(rootFiber, 2), $081ef12b46fbcaa0$var$ensureRootIsScheduled(rootFiber));
}
function $081ef12b46fbcaa0$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $081ef12b46fbcaa0$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $081ef12b46fbcaa0$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed || !$081ef12b46fbcaa0$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $081ef12b46fbcaa0$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $081ef12b46fbcaa0$var$createClassErrorUpdate(2);
                instance = $081ef12b46fbcaa0$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($081ef12b46fbcaa0$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $081ef12b46fbcaa0$var$markRootUpdated$1(instance, 2), $081ef12b46fbcaa0$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $081ef12b46fbcaa0$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $081ef12b46fbcaa0$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($081ef12b46fbcaa0$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $081ef12b46fbcaa0$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $081ef12b46fbcaa0$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $081ef12b46fbcaa0$var$workInProgressRoot === root && ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus || 3 === $081ef12b46fbcaa0$var$workInProgressRootExitStatus && ($081ef12b46fbcaa0$var$workInProgressRootRenderLanes & 62914560) === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && 300 > $081ef12b46fbcaa0$var$now() - $081ef12b46fbcaa0$var$globalMostRecentFallbackTime ? 0 === ($081ef12b46fbcaa0$var$executionContext & 2) ? $081ef12b46fbcaa0$var$prepareFreshStack(root, 0) : $081ef12b46fbcaa0$var$workInProgressRootPingedLanes |= pingedLanes : $081ef12b46fbcaa0$var$workInProgressRootPingedLanes |= pingedLanes, $081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes === $081ef12b46fbcaa0$var$workInProgressRootRenderLanes && ($081ef12b46fbcaa0$var$workInProgressSuspendedRetryLanes = 0));
    $081ef12b46fbcaa0$var$ensureRootIsScheduled(root);
}
function $081ef12b46fbcaa0$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $081ef12b46fbcaa0$var$claimNextRetryLane());
    boundaryFiber = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($081ef12b46fbcaa0$var$markRootUpdated$1(boundaryFiber, retryLane), $081ef12b46fbcaa0$var$ensureRootIsScheduled(boundaryFiber));
}
function $081ef12b46fbcaa0$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $081ef12b46fbcaa0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $081ef12b46fbcaa0$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $081ef12b46fbcaa0$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $081ef12b46fbcaa0$var$scheduleCallback$1(priorityLevel, callback) {
    return $081ef12b46fbcaa0$var$scheduleCallback$3(priorityLevel, callback);
}
var $081ef12b46fbcaa0$var$firstScheduledRoot = null, $081ef12b46fbcaa0$var$lastScheduledRoot = null, $081ef12b46fbcaa0$var$didScheduleMicrotask = !1, $081ef12b46fbcaa0$var$mightHavePendingSyncWork = !1, $081ef12b46fbcaa0$var$isFlushingWork = !1, $081ef12b46fbcaa0$var$currentEventTransitionLane = 0;
function $081ef12b46fbcaa0$var$ensureRootIsScheduled(root) {
    root !== $081ef12b46fbcaa0$var$lastScheduledRoot && null === root.next && (null === $081ef12b46fbcaa0$var$lastScheduledRoot ? $081ef12b46fbcaa0$var$firstScheduledRoot = $081ef12b46fbcaa0$var$lastScheduledRoot = root : $081ef12b46fbcaa0$var$lastScheduledRoot = $081ef12b46fbcaa0$var$lastScheduledRoot.next = root);
    $081ef12b46fbcaa0$var$mightHavePendingSyncWork = !0;
    $081ef12b46fbcaa0$var$didScheduleMicrotask || ($081ef12b46fbcaa0$var$didScheduleMicrotask = !0, $081ef12b46fbcaa0$var$scheduleImmediateRootScheduleTask());
}
function $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$081ef12b46fbcaa0$var$isFlushingWork && $081ef12b46fbcaa0$var$mightHavePendingSyncWork) {
        $081ef12b46fbcaa0$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $081ef12b46fbcaa0$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $081ef12b46fbcaa0$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $081ef12b46fbcaa0$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $081ef12b46fbcaa0$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $081ef12b46fbcaa0$var$getNextLanes(root$190, root$190 === $081ef12b46fbcaa0$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $081ef12b46fbcaa0$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $081ef12b46fbcaa0$var$isFlushingWork = !1;
    }
}
function $081ef12b46fbcaa0$var$processRootScheduleInImmediateTask() {
    $081ef12b46fbcaa0$var$processRootScheduleInMicrotask();
}
function $081ef12b46fbcaa0$var$processRootScheduleInMicrotask() {
    $081ef12b46fbcaa0$var$mightHavePendingSyncWork = $081ef12b46fbcaa0$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $081ef12b46fbcaa0$var$currentEventTransitionLane && $081ef12b46fbcaa0$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $081ef12b46fbcaa0$var$currentEventTransitionLane);
    for(var currentTime = $081ef12b46fbcaa0$var$now(), prev = null, root = $081ef12b46fbcaa0$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $081ef12b46fbcaa0$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $081ef12b46fbcaa0$var$firstScheduledRoot = next : prev.next = next, null === next && ($081ef12b46fbcaa0$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $081ef12b46fbcaa0$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $081ef12b46fbcaa0$var$pendingEffectsStatus && 5 !== $081ef12b46fbcaa0$var$pendingEffectsStatus || $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $081ef12b46fbcaa0$var$currentEventTransitionLane && ($081ef12b46fbcaa0$var$currentEventTransitionLane = 0);
}
function $081ef12b46fbcaa0$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $081ef12b46fbcaa0$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $081ef12b46fbcaa0$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $081ef12b46fbcaa0$var$workInProgressRoot;
    suspendedLanes = $081ef12b46fbcaa0$var$workInProgressRootRenderLanes;
    suspendedLanes = $081ef12b46fbcaa0$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason || 9 === $081ef12b46fbcaa0$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $081ef12b46fbcaa0$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $081ef12b46fbcaa0$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $081ef12b46fbcaa0$var$cancelCallback$1(pingedLanes);
        switch($081ef12b46fbcaa0$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $081ef12b46fbcaa0$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $081ef12b46fbcaa0$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $081ef12b46fbcaa0$var$IdlePriority;
                break;
            default:
                suspendedLanes = $081ef12b46fbcaa0$var$NormalPriority$1;
        }
        pingedLanes = $081ef12b46fbcaa0$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $081ef12b46fbcaa0$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $081ef12b46fbcaa0$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $081ef12b46fbcaa0$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $081ef12b46fbcaa0$var$pendingEffectsStatus && 5 !== $081ef12b46fbcaa0$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($081ef12b46fbcaa0$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $081ef12b46fbcaa0$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $081ef12b46fbcaa0$var$getNextLanes(root, root === $081ef12b46fbcaa0$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $081ef12b46fbcaa0$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $081ef12b46fbcaa0$var$scheduleTaskForRootDuringMicrotask(root, $081ef12b46fbcaa0$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $081ef12b46fbcaa0$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $081ef12b46fbcaa0$var$performSyncWorkOnRoot(root, lanes) {
    if ($081ef12b46fbcaa0$var$flushPendingEffects()) return null;
    $081ef12b46fbcaa0$var$performWorkOnRoot(root, lanes, !0);
}
function $081ef12b46fbcaa0$var$scheduleImmediateRootScheduleTask() {
    $081ef12b46fbcaa0$var$scheduleMicrotask(function() {
        0 !== ($081ef12b46fbcaa0$var$executionContext & 6) ? $081ef12b46fbcaa0$var$scheduleCallback$3($081ef12b46fbcaa0$var$ImmediatePriority, $081ef12b46fbcaa0$var$processRootScheduleInImmediateTask) : $081ef12b46fbcaa0$var$processRootScheduleInMicrotask();
    });
}
function $081ef12b46fbcaa0$var$requestTransitionLane() {
    if (0 === $081ef12b46fbcaa0$var$currentEventTransitionLane) {
        var actionScopeLane = $081ef12b46fbcaa0$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $081ef12b46fbcaa0$var$nextTransitionUpdateLane, $081ef12b46fbcaa0$var$nextTransitionUpdateLane <<= 1, 0 === ($081ef12b46fbcaa0$var$nextTransitionUpdateLane & 261888) && ($081ef12b46fbcaa0$var$nextTransitionUpdateLane = 256));
        $081ef12b46fbcaa0$var$currentEventTransitionLane = actionScopeLane;
    }
    return $081ef12b46fbcaa0$var$currentEventTransitionLane;
}
function $081ef12b46fbcaa0$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $081ef12b46fbcaa0$var$sanitizeURL(actionProp);
}
function $081ef12b46fbcaa0$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $081ef12b46fbcaa0$var$coerceFormActionProp((nativeEventTarget[$081ef12b46fbcaa0$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$081ef12b46fbcaa0$var$internalPropsKey] || null) ? $081ef12b46fbcaa0$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $081ef12b46fbcaa0$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $081ef12b46fbcaa0$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $081ef12b46fbcaa0$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $081ef12b46fbcaa0$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $081ef12b46fbcaa0$var$i$jscomp$inline_1667 = 0; $081ef12b46fbcaa0$var$i$jscomp$inline_1667 < $081ef12b46fbcaa0$var$simpleEventPluginEvents.length; $081ef12b46fbcaa0$var$i$jscomp$inline_1667++){
    var $081ef12b46fbcaa0$var$eventName$jscomp$inline_1668 = $081ef12b46fbcaa0$var$simpleEventPluginEvents[$081ef12b46fbcaa0$var$i$jscomp$inline_1667], $081ef12b46fbcaa0$var$domEventName$jscomp$inline_1669 = $081ef12b46fbcaa0$var$eventName$jscomp$inline_1668.toLowerCase(), $081ef12b46fbcaa0$var$capitalizedEvent$jscomp$inline_1670 = $081ef12b46fbcaa0$var$eventName$jscomp$inline_1668[0].toUpperCase() + $081ef12b46fbcaa0$var$eventName$jscomp$inline_1668.slice(1);
    $081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$domEventName$jscomp$inline_1669, "on" + $081ef12b46fbcaa0$var$capitalizedEvent$jscomp$inline_1670);
}
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$ANIMATION_END, "onAnimationEnd");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$ANIMATION_ITERATION, "onAnimationIteration");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$ANIMATION_START, "onAnimationStart");
$081ef12b46fbcaa0$var$registerSimpleEvent("dblclick", "onDoubleClick");
$081ef12b46fbcaa0$var$registerSimpleEvent("focusin", "onFocus");
$081ef12b46fbcaa0$var$registerSimpleEvent("focusout", "onBlur");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_RUN, "onTransitionRun");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_START, "onTransitionStart");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_CANCEL, "onTransitionCancel");
$081ef12b46fbcaa0$var$registerSimpleEvent($081ef12b46fbcaa0$var$TRANSITION_END, "onTransitionEnd");
$081ef12b46fbcaa0$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$081ef12b46fbcaa0$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$081ef12b46fbcaa0$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$081ef12b46fbcaa0$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$081ef12b46fbcaa0$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $081ef12b46fbcaa0$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $081ef12b46fbcaa0$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($081ef12b46fbcaa0$var$mediaEventTypes));
function $081ef12b46fbcaa0$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $081ef12b46fbcaa0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $081ef12b46fbcaa0$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $081ef12b46fbcaa0$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$081ef12b46fbcaa0$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$081ef12b46fbcaa0$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($081ef12b46fbcaa0$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $081ef12b46fbcaa0$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $081ef12b46fbcaa0$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $081ef12b46fbcaa0$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $081ef12b46fbcaa0$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$081ef12b46fbcaa0$var$listeningMarker]) {
        rootContainerElement[$081ef12b46fbcaa0$var$listeningMarker] = !0;
        $081ef12b46fbcaa0$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($081ef12b46fbcaa0$var$nonDelegatedEvents.has(domEventName) || $081ef12b46fbcaa0$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $081ef12b46fbcaa0$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$081ef12b46fbcaa0$var$listeningMarker] || (ownerDocument[$081ef12b46fbcaa0$var$listeningMarker] = !0, $081ef12b46fbcaa0$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $081ef12b46fbcaa0$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($081ef12b46fbcaa0$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $081ef12b46fbcaa0$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $081ef12b46fbcaa0$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $081ef12b46fbcaa0$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$081ef12b46fbcaa0$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $081ef12b46fbcaa0$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $081ef12b46fbcaa0$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $081ef12b46fbcaa0$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $081ef12b46fbcaa0$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticTouchEvent;
                        break;
                    case $081ef12b46fbcaa0$var$ANIMATION_END:
                    case $081ef12b46fbcaa0$var$ANIMATION_ITERATION:
                    case $081ef12b46fbcaa0$var$ANIMATION_START:
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticAnimationEvent;
                        break;
                    case $081ef12b46fbcaa0$var$TRANSITION_END:
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $081ef12b46fbcaa0$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $081ef12b46fbcaa0$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($081ef12b46fbcaa0$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $081ef12b46fbcaa0$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($081ef12b46fbcaa0$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$081ef12b46fbcaa0$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $081ef12b46fbcaa0$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $081ef12b46fbcaa0$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $081ef12b46fbcaa0$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $081ef12b46fbcaa0$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $081ef12b46fbcaa0$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $081ef12b46fbcaa0$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $081ef12b46fbcaa0$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $081ef12b46fbcaa0$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $081ef12b46fbcaa0$var$getParent) : null;
                        null !== reactName && $081ef12b46fbcaa0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $081ef12b46fbcaa0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $081ef12b46fbcaa0$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForChangeEvent;
                else if ($081ef12b46fbcaa0$var$isTextInputElement(reactName)) {
                    if ($081ef12b46fbcaa0$var$isInputEventSupported) getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $081ef12b46fbcaa0$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $081ef12b46fbcaa0$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForChangeEvent) : getTargetInstFunc = $081ef12b46fbcaa0$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $081ef12b46fbcaa0$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $081ef12b46fbcaa0$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($081ef12b46fbcaa0$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $081ef12b46fbcaa0$var$activeElement = handleEventFunc, $081ef12b46fbcaa0$var$activeElementInst = targetInst, $081ef12b46fbcaa0$var$lastSelection = null;
                    break;
                case "focusout":
                    $081ef12b46fbcaa0$var$lastSelection = $081ef12b46fbcaa0$var$activeElementInst = $081ef12b46fbcaa0$var$activeElement = null;
                    break;
                case "mousedown":
                    $081ef12b46fbcaa0$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $081ef12b46fbcaa0$var$mouseDown = !1;
                    $081ef12b46fbcaa0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($081ef12b46fbcaa0$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $081ef12b46fbcaa0$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($081ef12b46fbcaa0$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $081ef12b46fbcaa0$var$isComposing ? $081ef12b46fbcaa0$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($081ef12b46fbcaa0$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($081ef12b46fbcaa0$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $081ef12b46fbcaa0$var$isComposing && (fallbackData = $081ef12b46fbcaa0$var$getData()) : ($081ef12b46fbcaa0$var$root = nativeEventTarget, $081ef12b46fbcaa0$var$startText = "value" in $081ef12b46fbcaa0$var$root ? $081ef12b46fbcaa0$var$root.value : $081ef12b46fbcaa0$var$root.textContent, $081ef12b46fbcaa0$var$isComposing = !0)), handleEventFunc = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $081ef12b46fbcaa0$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $081ef12b46fbcaa0$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $081ef12b46fbcaa0$var$canUseTextInputEvent ? $081ef12b46fbcaa0$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $081ef12b46fbcaa0$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $081ef12b46fbcaa0$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $081ef12b46fbcaa0$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $081ef12b46fbcaa0$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $081ef12b46fbcaa0$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $081ef12b46fbcaa0$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $081ef12b46fbcaa0$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($081ef12b46fbcaa0$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $081ef12b46fbcaa0$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($081ef12b46fbcaa0$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $081ef12b46fbcaa0$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $081ef12b46fbcaa0$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $081ef12b46fbcaa0$var$getListener(target, registrationName), null != stateNode && listeners.unshift($081ef12b46fbcaa0$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $081ef12b46fbcaa0$var$getListener(target, registrationName), null != stateNode && listeners.push($081ef12b46fbcaa0$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $081ef12b46fbcaa0$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $081ef12b46fbcaa0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $081ef12b46fbcaa0$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($081ef12b46fbcaa0$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($081ef12b46fbcaa0$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $081ef12b46fbcaa0$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $081ef12b46fbcaa0$var$normalizeMarkupForTextOrAttribute(clientText);
    return $081ef12b46fbcaa0$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $081ef12b46fbcaa0$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $081ef12b46fbcaa0$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $081ef12b46fbcaa0$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $081ef12b46fbcaa0$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $081ef12b46fbcaa0$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $081ef12b46fbcaa0$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $081ef12b46fbcaa0$var$setProp(domElement, tag, "name", props.name, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($081ef12b46fbcaa0$var$setProp(domElement, tag, "encType", props.encType, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "method", props.method, props, null), $081ef12b46fbcaa0$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $081ef12b46fbcaa0$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $081ef12b46fbcaa0$var$noop$1);
            return;
        case "onScroll":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $081ef12b46fbcaa0$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", domElement);
            $081ef12b46fbcaa0$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $081ef12b46fbcaa0$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $081ef12b46fbcaa0$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $081ef12b46fbcaa0$var$aliases.get(key) || key, $081ef12b46fbcaa0$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
}
function $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $081ef12b46fbcaa0$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $081ef12b46fbcaa0$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $081ef12b46fbcaa0$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $081ef12b46fbcaa0$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$081ef12b46fbcaa0$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$081ef12b46fbcaa0$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $081ef12b46fbcaa0$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $081ef12b46fbcaa0$var$viewTransitionMutationContext = !0;
}
function $081ef12b46fbcaa0$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                    default:
                        $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $081ef12b46fbcaa0$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $081ef12b46fbcaa0$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $081ef12b46fbcaa0$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $081ef12b46fbcaa0$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $081ef12b46fbcaa0$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $081ef12b46fbcaa0$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(91));
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $081ef12b46fbcaa0$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("cancel", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $081ef12b46fbcaa0$var$mediaEventTypes.length; hasSrc++)$081ef12b46fbcaa0$var$listenToNonDelegatedEvent($081ef12b46fbcaa0$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", domElement);
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("error", domElement), $081ef12b46fbcaa0$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($081ef12b46fbcaa0$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $081ef12b46fbcaa0$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $081ef12b46fbcaa0$var$emptyProps = {};
function $081ef12b46fbcaa0$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $081ef12b46fbcaa0$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $081ef12b46fbcaa0$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $081ef12b46fbcaa0$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $081ef12b46fbcaa0$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $081ef12b46fbcaa0$var$updateOptions(domElement, !!lastProps, tag, !0) : $081ef12b46fbcaa0$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $081ef12b46fbcaa0$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $081ef12b46fbcaa0$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($081ef12b46fbcaa0$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $081ef12b46fbcaa0$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($081ef12b46fbcaa0$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $081ef12b46fbcaa0$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $081ef12b46fbcaa0$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $081ef12b46fbcaa0$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $081ef12b46fbcaa0$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $081ef12b46fbcaa0$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $081ef12b46fbcaa0$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $081ef12b46fbcaa0$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $081ef12b46fbcaa0$var$eventsEnabled = null, $081ef12b46fbcaa0$var$selectionInformation = null;
function $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $081ef12b46fbcaa0$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $081ef12b46fbcaa0$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $081ef12b46fbcaa0$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$081ef12b46fbcaa0$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$081ef12b46fbcaa0$var$internalPropsKey] = props;
    $081ef12b46fbcaa0$var$setInitialProperties(rootContainerInstance, type, props);
    $081ef12b46fbcaa0$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $081ef12b46fbcaa0$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $081ef12b46fbcaa0$var$currentPopstateTransitionEvent = null;
function $081ef12b46fbcaa0$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $081ef12b46fbcaa0$var$currentPopstateTransitionEvent) return !1;
        $081ef12b46fbcaa0$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $081ef12b46fbcaa0$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $081ef12b46fbcaa0$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $081ef12b46fbcaa0$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $081ef12b46fbcaa0$var$localPromise = "function" === typeof Promise ? Promise : void 0, $081ef12b46fbcaa0$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $081ef12b46fbcaa0$var$scheduleTimeout, $081ef12b46fbcaa0$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $081ef12b46fbcaa0$var$localPromise ? function(callback) {
    return $081ef12b46fbcaa0$var$localPromise.resolve(null).then(callback).catch($081ef12b46fbcaa0$var$handleErrorInNextTick);
} : $081ef12b46fbcaa0$var$scheduleTimeout;
function $081ef12b46fbcaa0$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $081ef12b46fbcaa0$var$isSingletonScope(type) {
    return "head" === type;
}
function $081ef12b46fbcaa0$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $081ef12b46fbcaa0$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $081ef12b46fbcaa0$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $081ef12b46fbcaa0$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$081ef12b46fbcaa0$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $081ef12b46fbcaa0$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $081ef12b46fbcaa0$var$retryIfBlockedOn(hydrationInstance);
}
function $081ef12b46fbcaa0$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $081ef12b46fbcaa0$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $081ef12b46fbcaa0$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $081ef12b46fbcaa0$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $081ef12b46fbcaa0$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $081ef12b46fbcaa0$var$createMeasurement(rect, computedStyle, instance);
}
function $081ef12b46fbcaa0$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $081ef12b46fbcaa0$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $081ef12b46fbcaa0$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $081ef12b46fbcaa0$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $081ef12b46fbcaa0$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($081ef12b46fbcaa0$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $081ef12b46fbcaa0$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $081ef12b46fbcaa0$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($081ef12b46fbcaa0$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $081ef12b46fbcaa0$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$081ef12b46fbcaa0$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $081ef12b46fbcaa0$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$081ef12b46fbcaa0$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$081ef12b46fbcaa0$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $081ef12b46fbcaa0$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $081ef12b46fbcaa0$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $081ef12b46fbcaa0$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $081ef12b46fbcaa0$var$ViewTransitionPseudoElement("old", name),
        new: new $081ef12b46fbcaa0$var$ViewTransitionPseudoElement("new", name)
    };
}
function $081ef12b46fbcaa0$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $081ef12b46fbcaa0$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $081ef12b46fbcaa0$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $081ef12b46fbcaa0$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $081ef12b46fbcaa0$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $081ef12b46fbcaa0$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $081ef12b46fbcaa0$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $081ef12b46fbcaa0$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $081ef12b46fbcaa0$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $081ef12b46fbcaa0$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $081ef12b46fbcaa0$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $081ef12b46fbcaa0$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $081ef12b46fbcaa0$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $081ef12b46fbcaa0$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$081ef12b46fbcaa0$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $081ef12b46fbcaa0$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $081ef12b46fbcaa0$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(fiber);
    return $081ef12b46fbcaa0$var$setFocusIfFocusable(fiber, focusOptions);
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $081ef12b46fbcaa0$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$081ef12b46fbcaa0$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $081ef12b46fbcaa0$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $081ef12b46fbcaa0$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$observeChild, observer, void 0, void 0);
};
function $081ef12b46fbcaa0$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $081ef12b46fbcaa0$var$pendingIntersectionUnobserves.length; i++){
            var pending = $081ef12b46fbcaa0$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $081ef12b46fbcaa0$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $081ef12b46fbcaa0$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $081ef12b46fbcaa0$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $081ef12b46fbcaa0$var$pendingIntersectionUnobserves = [], $081ef12b46fbcaa0$var$intersectionUnobserveScheduled = !1;
function $081ef12b46fbcaa0$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $081ef12b46fbcaa0$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $081ef12b46fbcaa0$var$intersectionUnobserveScheduled || ($081ef12b46fbcaa0$var$intersectionUnobserveScheduled = !0, $081ef12b46fbcaa0$var$requestPostPaintCallback(function() {
        $081ef12b46fbcaa0$var$intersectionUnobserveScheduled = !1;
        var pending = $081ef12b46fbcaa0$var$pendingIntersectionUnobserves;
        $081ef12b46fbcaa0$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $081ef12b46fbcaa0$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $081ef12b46fbcaa0$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$081ef12b46fbcaa0$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($081ef12b46fbcaa0$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $081ef12b46fbcaa0$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(children[0]);
    result = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $081ef12b46fbcaa0$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $081ef12b46fbcaa0$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $081ef12b46fbcaa0$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $081ef12b46fbcaa0$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $081ef12b46fbcaa0$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $081ef12b46fbcaa0$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $081ef12b46fbcaa0$var$searchTarget, $081ef12b46fbcaa0$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $081ef12b46fbcaa0$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $081ef12b46fbcaa0$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $081ef12b46fbcaa0$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $081ef12b46fbcaa0$var$searchTarget, $081ef12b46fbcaa0$var$searchBoundary = $081ef12b46fbcaa0$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $081ef12b46fbcaa0$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$081ef12b46fbcaa0$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(566));
    var children = [];
    $081ef12b46fbcaa0$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $081ef12b46fbcaa0$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $081ef12b46fbcaa0$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $081ef12b46fbcaa0$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(hostSiblings);
            $081ef12b46fbcaa0$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child), $081ef12b46fbcaa0$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $081ef12b46fbcaa0$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $081ef12b46fbcaa0$var$getInstanceFromHostFiber(child);
    $081ef12b46fbcaa0$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $081ef12b46fbcaa0$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $081ef12b46fbcaa0$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $081ef12b46fbcaa0$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $081ef12b46fbcaa0$var$pendingIntersectionUnobserves.length; i++){
            var pending = $081ef12b46fbcaa0$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $081ef12b46fbcaa0$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $081ef12b46fbcaa0$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $081ef12b46fbcaa0$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $081ef12b46fbcaa0$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $081ef12b46fbcaa0$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $081ef12b46fbcaa0$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $081ef12b46fbcaa0$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $081ef12b46fbcaa0$var$clearContainerSparingly(node);
                $081ef12b46fbcaa0$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $081ef12b46fbcaa0$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$081ef12b46fbcaa0$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $081ef12b46fbcaa0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $081ef12b46fbcaa0$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $081ef12b46fbcaa0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $081ef12b46fbcaa0$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $081ef12b46fbcaa0$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $081ef12b46fbcaa0$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $081ef12b46fbcaa0$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $081ef12b46fbcaa0$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $081ef12b46fbcaa0$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $081ef12b46fbcaa0$var$previousHydratableOnEnteringScopedSingleton = null;
function $081ef12b46fbcaa0$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $081ef12b46fbcaa0$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $081ef12b46fbcaa0$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $081ef12b46fbcaa0$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $081ef12b46fbcaa0$var$requestPostPaintCallback(callback) {
    $081ef12b46fbcaa0$var$localRequestAnimationFrame(function() {
        $081ef12b46fbcaa0$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $081ef12b46fbcaa0$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $081ef12b46fbcaa0$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(451));
    }
}
function $081ef12b46fbcaa0$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $081ef12b46fbcaa0$var$setProp(instance, type, propKey, null, $081ef12b46fbcaa0$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $081ef12b46fbcaa0$var$noop$1 && (instance.onclick = null);
    $081ef12b46fbcaa0$var$detachDeletedInstance(instance);
}
function $081ef12b46fbcaa0$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $081ef12b46fbcaa0$var$detachDeletedInstance(instance);
}
var $081ef12b46fbcaa0$var$preloadPropsMap = new Map(), $081ef12b46fbcaa0$var$preconnectsSet = new Set();
function $081ef12b46fbcaa0$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $081ef12b46fbcaa0$var$previousDispatcher = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.d;
$081ef12b46fbcaa0$var$ReactDOMSharedInternals.d = {
    f: $081ef12b46fbcaa0$var$flushSyncWork,
    r: $081ef12b46fbcaa0$var$requestFormReset,
    D: $081ef12b46fbcaa0$var$prefetchDNS,
    C: $081ef12b46fbcaa0$var$preconnect,
    L: $081ef12b46fbcaa0$var$preload,
    m: $081ef12b46fbcaa0$var$preloadModule,
    X: $081ef12b46fbcaa0$var$preinitScript,
    S: $081ef12b46fbcaa0$var$preinitStyle,
    M: $081ef12b46fbcaa0$var$preinitModuleScript
};
function $081ef12b46fbcaa0$var$flushSyncWork() {
    var previousWasRendering = $081ef12b46fbcaa0$var$previousDispatcher.f(), wasRendering = $081ef12b46fbcaa0$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $081ef12b46fbcaa0$var$requestFormReset(form) {
    var formInst = $081ef12b46fbcaa0$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $081ef12b46fbcaa0$var$requestFormReset$1(formInst) : $081ef12b46fbcaa0$var$previousDispatcher.r(form);
}
var $081ef12b46fbcaa0$var$globalDocument = "undefined" === typeof document ? null : document;
function $081ef12b46fbcaa0$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $081ef12b46fbcaa0$var$preconnectsSet.has(limitedEscapedHref) || ($081ef12b46fbcaa0$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $081ef12b46fbcaa0$var$setInitialProperties(href, "link", rel), $081ef12b46fbcaa0$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $081ef12b46fbcaa0$var$prefetchDNS(href) {
    $081ef12b46fbcaa0$var$previousDispatcher.D(href);
    $081ef12b46fbcaa0$var$preconnectAs("dns-prefetch", href, null);
}
function $081ef12b46fbcaa0$var$preconnect(href, crossOrigin) {
    $081ef12b46fbcaa0$var$previousDispatcher.C(href, crossOrigin);
    $081ef12b46fbcaa0$var$preconnectAs("preconnect", href, crossOrigin);
}
function $081ef12b46fbcaa0$var$preload(href, as, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $081ef12b46fbcaa0$var$getStyleKey(href);
                break;
            case "script":
                key = $081ef12b46fbcaa0$var$getScriptKey(href);
        }
        if (!($081ef12b46fbcaa0$var$preloadPropsMap.has(key) || (href = $081ef12b46fbcaa0$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $081ef12b46fbcaa0$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $081ef12b46fbcaa0$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$081ef12b46fbcaa0$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $081ef12b46fbcaa0$var$clearPendingLoadOnNode(instance);
            });
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $081ef12b46fbcaa0$var$preloadModule(href, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.m(href, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $081ef12b46fbcaa0$var$getScriptKey(href);
        }
        if (!$081ef12b46fbcaa0$var$preloadPropsMap.has(key) && (href = $081ef12b46fbcaa0$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $081ef12b46fbcaa0$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $081ef12b46fbcaa0$var$setInitialProperties(as, "link", href);
            $081ef12b46fbcaa0$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $081ef12b46fbcaa0$var$preinitStyle(href, precedence, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $081ef12b46fbcaa0$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $081ef12b46fbcaa0$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $081ef12b46fbcaa0$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $081ef12b46fbcaa0$var$markNodeAsHoistable(link);
                $081ef12b46fbcaa0$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $081ef12b46fbcaa0$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $081ef12b46fbcaa0$var$preinitScript(src, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.X(src, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $081ef12b46fbcaa0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $081ef12b46fbcaa0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key)), resource || (src = $081ef12b46fbcaa0$var$assign({
            src: src,
            async: !0
        }, options), (options = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $081ef12b46fbcaa0$var$markNodeAsHoistable(resource), $081ef12b46fbcaa0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $081ef12b46fbcaa0$var$preinitModuleScript(src, options) {
    $081ef12b46fbcaa0$var$previousDispatcher.M(src, options);
    var ownerDocument = $081ef12b46fbcaa0$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $081ef12b46fbcaa0$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $081ef12b46fbcaa0$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(key)), resource || (src = $081ef12b46fbcaa0$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $081ef12b46fbcaa0$var$markNodeAsHoistable(resource), $081ef12b46fbcaa0$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $081ef12b46fbcaa0$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $081ef12b46fbcaa0$var$rootInstanceStackCursor.current) ? $081ef12b46fbcaa0$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $081ef12b46fbcaa0$var$getStyleKey(pendingProps.href), currentProps = $081ef12b46fbcaa0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $081ef12b46fbcaa0$var$getStyleKey(pendingProps.href);
                var styles$268 = $081ef12b46fbcaa0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $081ef12b46fbcaa0$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $081ef12b46fbcaa0$var$preloadPropsMap.set(type, styles$268)), $081ef12b46fbcaa0$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $081ef12b46fbcaa0$var$getScriptKey(pendingProps), currentProps = $081ef12b46fbcaa0$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(444, type));
    }
}
function $081ef12b46fbcaa0$var$getStyleKey(href) {
    return 'href="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $081ef12b46fbcaa0$var$stylesheetPropsFromRawProps(rawProps) {
    return $081ef12b46fbcaa0$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $081ef12b46fbcaa0$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$081ef12b46fbcaa0$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$081ef12b46fbcaa0$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $081ef12b46fbcaa0$var$clearPendingLoadOnNode.bind(null, key), $081ef12b46fbcaa0$var$setInitialProperties(key, "link", preloadProps), $081ef12b46fbcaa0$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $081ef12b46fbcaa0$var$getScriptKey(src) {
    return '[src="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $081ef12b46fbcaa0$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $081ef12b46fbcaa0$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $081ef12b46fbcaa0$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $081ef12b46fbcaa0$var$markNodeAsHoistable(instance), instance;
            var styleProps = $081ef12b46fbcaa0$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
            $081ef12b46fbcaa0$var$setInitialProperties(instance, "style", styleProps);
            $081ef12b46fbcaa0$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $081ef12b46fbcaa0$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $081ef12b46fbcaa0$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $081ef12b46fbcaa0$var$stylesheetPropsFromRawProps(props);
            (styleProps = $081ef12b46fbcaa0$var$preloadPropsMap.get(styleProps)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $081ef12b46fbcaa0$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $081ef12b46fbcaa0$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $081ef12b46fbcaa0$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($081ef12b46fbcaa0$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $081ef12b46fbcaa0$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $081ef12b46fbcaa0$var$preloadPropsMap.get(instance$274)) instance = $081ef12b46fbcaa0$var$assign({}, props), $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(styleProps);
            $081ef12b46fbcaa0$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $081ef12b46fbcaa0$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $081ef12b46fbcaa0$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $081ef12b46fbcaa0$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $081ef12b46fbcaa0$var$tagCaches = null;
function $081ef12b46fbcaa0$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $081ef12b46fbcaa0$var$tagCaches) {
        var cache = new Map();
        var caches = $081ef12b46fbcaa0$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $081ef12b46fbcaa0$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$081ef12b46fbcaa0$var$internalHoistableMarker] || node[$081ef12b46fbcaa0$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $081ef12b46fbcaa0$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $081ef12b46fbcaa0$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $081ef12b46fbcaa0$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $081ef12b46fbcaa0$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $081ef12b46fbcaa0$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $081ef12b46fbcaa0$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $081ef12b46fbcaa0$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $081ef12b46fbcaa0$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $081ef12b46fbcaa0$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($081ef12b46fbcaa0$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $081ef12b46fbcaa0$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $081ef12b46fbcaa0$var$stylesheetPropsFromRawProps(props);
            (key = $081ef12b46fbcaa0$var$preloadPropsMap.get(key)) && $081ef12b46fbcaa0$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $081ef12b46fbcaa0$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $081ef12b46fbcaa0$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $081ef12b46fbcaa0$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $081ef12b46fbcaa0$var$estimatedBytesWithinLimit = 0;
function $081ef12b46fbcaa0$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $081ef12b46fbcaa0$var$estimatedBytesWithinLimit && ($081ef12b46fbcaa0$var$estimatedBytesWithinLimit = 62500 * $081ef12b46fbcaa0$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $081ef12b46fbcaa0$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $081ef12b46fbcaa0$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $081ef12b46fbcaa0$var$onUnsuspend() {
    this.count--;
    $081ef12b46fbcaa0$var$checkIfFullyUnsuspended(this);
}
function $081ef12b46fbcaa0$var$onUnsuspendImg() {
    this.imgCount--;
    $081ef12b46fbcaa0$var$checkIfFullyUnsuspended(this);
}
var $081ef12b46fbcaa0$var$precedencesByRoot = null;
function $081ef12b46fbcaa0$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $081ef12b46fbcaa0$var$precedencesByRoot = new Map(), resources.forEach($081ef12b46fbcaa0$var$insertStylesheetIntoRoot, state), $081ef12b46fbcaa0$var$precedencesByRoot = null, $081ef12b46fbcaa0$var$onUnsuspend.call(state));
}
function $081ef12b46fbcaa0$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $081ef12b46fbcaa0$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $081ef12b46fbcaa0$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $081ef12b46fbcaa0$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $081ef12b46fbcaa0$var$HostTransitionContext = {
    $$typeof: $081ef12b46fbcaa0$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $081ef12b46fbcaa0$var$sharedNotPendingObject,
    _currentValue2: $081ef12b46fbcaa0$var$sharedNotPendingObject,
    _threadCount: 0
};
function $081ef12b46fbcaa0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $081ef12b46fbcaa0$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $081ef12b46fbcaa0$var$createLaneMap(0);
    this.hiddenUpdates = $081ef12b46fbcaa0$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $081ef12b46fbcaa0$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $081ef12b46fbcaa0$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $081ef12b46fbcaa0$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $081ef12b46fbcaa0$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $081ef12b46fbcaa0$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $081ef12b46fbcaa0$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $081ef12b46fbcaa0$var$emptyContextObject;
    parentComponent = $081ef12b46fbcaa0$var$emptyContextObject;
    return parentComponent;
}
function $081ef12b46fbcaa0$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $081ef12b46fbcaa0$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $081ef12b46fbcaa0$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $081ef12b46fbcaa0$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($081ef12b46fbcaa0$var$scheduleUpdateOnFiber(element, rootFiber, lane), $081ef12b46fbcaa0$var$entangleTransitions(element, rootFiber, lane));
}
function $081ef12b46fbcaa0$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $081ef12b46fbcaa0$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $081ef12b46fbcaa0$var$markRetryLaneImpl(fiber, retryLane);
}
function $081ef12b46fbcaa0$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $081ef12b46fbcaa0$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $081ef12b46fbcaa0$var$requestUpdateLane();
        lane = $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(lane);
        var root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, lane);
        $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $081ef12b46fbcaa0$var$_enabled = !0;
function $081ef12b46fbcaa0$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
    $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 2, $081ef12b46fbcaa0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $081ef12b46fbcaa0$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $081ef12b46fbcaa0$var$ReactSharedInternals.T;
    $081ef12b46fbcaa0$var$ReactSharedInternals.T = null;
    var previousPriority = $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p;
    try {
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = 8, $081ef12b46fbcaa0$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $081ef12b46fbcaa0$var$ReactDOMSharedInternals.p = previousPriority, $081ef12b46fbcaa0$var$ReactSharedInternals.T = prevTransition;
    }
}
function $081ef12b46fbcaa0$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($081ef12b46fbcaa0$var$_enabled) {
        var blockedOn = $081ef12b46fbcaa0$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $081ef12b46fbcaa0$var$return_targetInst, targetContainer), $081ef12b46fbcaa0$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($081ef12b46fbcaa0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($081ef12b46fbcaa0$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $081ef12b46fbcaa0$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $081ef12b46fbcaa0$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $081ef12b46fbcaa0$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $081ef12b46fbcaa0$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $081ef12b46fbcaa0$var$ensureRootIsScheduled(fiber);
                                0 === ($081ef12b46fbcaa0$var$executionContext & 6) && ($081ef12b46fbcaa0$var$workInProgressRootRenderTargetTime = $081ef12b46fbcaa0$var$now() + 500, $081ef12b46fbcaa0$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $081ef12b46fbcaa0$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $081ef12b46fbcaa0$var$scheduleUpdateOnFiber(root, fiber, 2), $081ef12b46fbcaa0$var$flushSyncWork$1(), $081ef12b46fbcaa0$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $081ef12b46fbcaa0$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $081ef12b46fbcaa0$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $081ef12b46fbcaa0$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $081ef12b46fbcaa0$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $081ef12b46fbcaa0$var$getEventTarget(nativeEvent);
    return $081ef12b46fbcaa0$var$findInstanceBlockingTarget(nativeEvent);
}
var $081ef12b46fbcaa0$var$return_targetInst = null;
function $081ef12b46fbcaa0$var$findInstanceBlockingTarget(targetNode) {
    $081ef12b46fbcaa0$var$return_targetInst = null;
    targetNode = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $081ef12b46fbcaa0$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $081ef12b46fbcaa0$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $081ef12b46fbcaa0$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $081ef12b46fbcaa0$var$return_targetInst = targetNode;
    return null;
}
function $081ef12b46fbcaa0$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($081ef12b46fbcaa0$var$getCurrentPriorityLevel()){
                case $081ef12b46fbcaa0$var$ImmediatePriority:
                    return 2;
                case $081ef12b46fbcaa0$var$UserBlockingPriority:
                    return 8;
                case $081ef12b46fbcaa0$var$NormalPriority$1:
                case $081ef12b46fbcaa0$var$LowPriority:
                    return 32;
                case $081ef12b46fbcaa0$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $081ef12b46fbcaa0$var$hasScheduledReplayAttempt = !1, $081ef12b46fbcaa0$var$queuedFocus = null, $081ef12b46fbcaa0$var$queuedDrag = null, $081ef12b46fbcaa0$var$queuedMouse = null, $081ef12b46fbcaa0$var$queuedPointers = new Map(), $081ef12b46fbcaa0$var$queuedPointerCaptures = new Map(), $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets = [], $081ef12b46fbcaa0$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $081ef12b46fbcaa0$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $081ef12b46fbcaa0$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $081ef12b46fbcaa0$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $081ef12b46fbcaa0$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $081ef12b46fbcaa0$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $081ef12b46fbcaa0$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $081ef12b46fbcaa0$var$getInstanceFromNode(blockedOn), null !== blockedOn && $081ef12b46fbcaa0$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $081ef12b46fbcaa0$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $081ef12b46fbcaa0$var$queuedFocus = $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $081ef12b46fbcaa0$var$queuedDrag = $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $081ef12b46fbcaa0$var$queuedMouse = $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $081ef12b46fbcaa0$var$queuedPointers.set(pointerId, $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $081ef12b46fbcaa0$var$queuedPointerCaptures.set(pointerId, $081ef12b46fbcaa0$var$accumulateOrCreateContinuousQueuedReplayableEvent($081ef12b46fbcaa0$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $081ef12b46fbcaa0$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $081ef12b46fbcaa0$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $081ef12b46fbcaa0$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $081ef12b46fbcaa0$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $081ef12b46fbcaa0$var$runWithPriority(queuedTarget.priority, function() {
                        $081ef12b46fbcaa0$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $081ef12b46fbcaa0$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $081ef12b46fbcaa0$var$runWithPriority(queuedTarget.priority, function() {
                        $081ef12b46fbcaa0$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $081ef12b46fbcaa0$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $081ef12b46fbcaa0$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $081ef12b46fbcaa0$var$currentReplayingEvent = null;
        } else return targetContainers = $081ef12b46fbcaa0$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $081ef12b46fbcaa0$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $081ef12b46fbcaa0$var$replayUnblockedEvents() {
    $081ef12b46fbcaa0$var$hasScheduledReplayAttempt = !1;
    null !== $081ef12b46fbcaa0$var$queuedFocus && $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent($081ef12b46fbcaa0$var$queuedFocus) && ($081ef12b46fbcaa0$var$queuedFocus = null);
    null !== $081ef12b46fbcaa0$var$queuedDrag && $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent($081ef12b46fbcaa0$var$queuedDrag) && ($081ef12b46fbcaa0$var$queuedDrag = null);
    null !== $081ef12b46fbcaa0$var$queuedMouse && $081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEvent($081ef12b46fbcaa0$var$queuedMouse) && ($081ef12b46fbcaa0$var$queuedMouse = null);
    $081ef12b46fbcaa0$var$queuedPointers.forEach($081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEventInMap);
    $081ef12b46fbcaa0$var$queuedPointerCaptures.forEach($081ef12b46fbcaa0$var$attemptReplayContinuousQueuedEventInMap);
}
function $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $081ef12b46fbcaa0$var$hasScheduledReplayAttempt || ($081ef12b46fbcaa0$var$hasScheduledReplayAttempt = !0, $fndEB.unstable_scheduleCallback($fndEB.unstable_NormalPriority, $081ef12b46fbcaa0$var$replayUnblockedEvents)));
}
var $081ef12b46fbcaa0$var$lastScheduledReplayQueue = null;
function $081ef12b46fbcaa0$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $081ef12b46fbcaa0$var$lastScheduledReplayQueue !== formReplayingQueue && ($081ef12b46fbcaa0$var$lastScheduledReplayQueue = formReplayingQueue, $fndEB.unstable_scheduleCallback($fndEB.unstable_NormalPriority, function() {
        $081ef12b46fbcaa0$var$lastScheduledReplayQueue === formReplayingQueue && ($081ef12b46fbcaa0$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $081ef12b46fbcaa0$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $081ef12b46fbcaa0$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $081ef12b46fbcaa0$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $081ef12b46fbcaa0$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $081ef12b46fbcaa0$var$queuedFocus && $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked($081ef12b46fbcaa0$var$queuedFocus, unblocked);
    null !== $081ef12b46fbcaa0$var$queuedDrag && $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked($081ef12b46fbcaa0$var$queuedDrag, unblocked);
    null !== $081ef12b46fbcaa0$var$queuedMouse && $081ef12b46fbcaa0$var$scheduleCallbackIfUnblocked($081ef12b46fbcaa0$var$queuedMouse, unblocked);
    $081ef12b46fbcaa0$var$queuedPointers.forEach(unblock);
    $081ef12b46fbcaa0$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.length && (i = $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$081ef12b46fbcaa0$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$081ef12b46fbcaa0$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $081ef12b46fbcaa0$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$081ef12b46fbcaa0$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $081ef12b46fbcaa0$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $081ef12b46fbcaa0$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $081ef12b46fbcaa0$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $081ef12b46fbcaa0$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$081ef12b46fbcaa0$var$ReactDOMHydrationRoot.prototype.render = $081ef12b46fbcaa0$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(409));
    var current = root.current, lane = $081ef12b46fbcaa0$var$requestUpdateLane();
    $081ef12b46fbcaa0$var$updateContainerImpl(current, lane, children, root, null, null);
};
$081ef12b46fbcaa0$var$ReactDOMHydrationRoot.prototype.unmount = $081ef12b46fbcaa0$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $081ef12b46fbcaa0$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $081ef12b46fbcaa0$var$flushSyncWork$1();
        container[$081ef12b46fbcaa0$var$internalContainerInstanceKey] = null;
    }
};
function $081ef12b46fbcaa0$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$081ef12b46fbcaa0$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $081ef12b46fbcaa0$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets[i].priority; i++);
        $081ef12b46fbcaa0$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $081ef12b46fbcaa0$var$attemptExplicitHydrationTarget(target);
    }
};
var $081ef12b46fbcaa0$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $jGswQ.version;
if ("19.3.1" !== $081ef12b46fbcaa0$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(527, $081ef12b46fbcaa0$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$081ef12b46fbcaa0$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $081ef12b46fbcaa0$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $081ef12b46fbcaa0$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $081ef12b46fbcaa0$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $081ef12b46fbcaa0$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $081ef12b46fbcaa0$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$081ef12b46fbcaa0$var$hook$jscomp$inline_2587.isDisabled && $081ef12b46fbcaa0$var$hook$jscomp$inline_2587.supportsFiber) try {
        $081ef12b46fbcaa0$var$rendererID = $081ef12b46fbcaa0$var$hook$jscomp$inline_2587.inject($081ef12b46fbcaa0$var$internals$jscomp$inline_2586), $081ef12b46fbcaa0$var$injectedHook = $081ef12b46fbcaa0$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$081ef12b46fbcaa0$export$882461b6382ed46c = function(container, options) {
    if (!$081ef12b46fbcaa0$var$isValidContainer(container)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $081ef12b46fbcaa0$var$defaultOnUncaughtError, onCaughtError = $081ef12b46fbcaa0$var$defaultOnCaughtError, onRecoverableError = $081ef12b46fbcaa0$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $081ef12b46fbcaa0$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $081ef12b46fbcaa0$var$defaultOnDefaultTransitionIndicator);
    container[$081ef12b46fbcaa0$var$internalContainerInstanceKey] = options.current;
    $081ef12b46fbcaa0$var$listenToAllSupportedEvents(container);
    return new $081ef12b46fbcaa0$var$ReactDOMRoot(options);
};
$081ef12b46fbcaa0$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$081ef12b46fbcaa0$var$isValidContainer(container)) throw Error($081ef12b46fbcaa0$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $081ef12b46fbcaa0$var$defaultOnUncaughtError, onCaughtError = $081ef12b46fbcaa0$var$defaultOnCaughtError, onRecoverableError = $081ef12b46fbcaa0$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $081ef12b46fbcaa0$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $081ef12b46fbcaa0$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $081ef12b46fbcaa0$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $081ef12b46fbcaa0$var$requestUpdateLane();
    isStrictMode = $081ef12b46fbcaa0$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $081ef12b46fbcaa0$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $081ef12b46fbcaa0$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $081ef12b46fbcaa0$var$markRootUpdated$1(initialChildren, options);
    $081ef12b46fbcaa0$var$ensureRootIsScheduled(initialChildren);
    container[$081ef12b46fbcaa0$var$internalContainerInstanceKey] = initialChildren.current;
    $081ef12b46fbcaa0$var$listenToAllSupportedEvents(container);
    return new $081ef12b46fbcaa0$var$ReactDOMHydrationRoot(initialChildren);
};
$081ef12b46fbcaa0$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fndEB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ahkwg"));

});
parcelRegister("ahkwg", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $77bb68a4b10b9c90$export$c4744153514ff05d; }, function (v) { return $77bb68a4b10b9c90$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $77bb68a4b10b9c90$export$3e506c1ccc9cc1a7; }, function (v) { return $77bb68a4b10b9c90$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $77bb68a4b10b9c90$export$e26fe2ed2fa76875; }, function (v) { return $77bb68a4b10b9c90$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $77bb68a4b10b9c90$export$502329bbf4b505b1; }, function (v) { return $77bb68a4b10b9c90$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $77bb68a4b10b9c90$export$6e3807111c4874c4; }, function (v) { return $77bb68a4b10b9c90$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $77bb68a4b10b9c90$export$c27134553091fb3a; }, function (v) { return $77bb68a4b10b9c90$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $77bb68a4b10b9c90$export$33ee1acdc04fd2a2; }, function (v) { return $77bb68a4b10b9c90$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $77bb68a4b10b9c90$export$b00a404bbd5edef2; }, function (v) { return $77bb68a4b10b9c90$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $77bb68a4b10b9c90$export$d66a1c1c77bd778b; }, function (v) { return $77bb68a4b10b9c90$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $77bb68a4b10b9c90$export$d3dfb8e4810cb555; }, function (v) { return $77bb68a4b10b9c90$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $77bb68a4b10b9c90$export$72fdf0e06517287b; }, function (v) { return $77bb68a4b10b9c90$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $77bb68a4b10b9c90$export$816d2913ae6b83b1; }, function (v) { return $77bb68a4b10b9c90$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $77bb68a4b10b9c90$export$61bcfe829111a1d0; }, function (v) { return $77bb68a4b10b9c90$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $77bb68a4b10b9c90$export$7ee8c9beb337bc3f; }, function (v) { return $77bb68a4b10b9c90$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $77bb68a4b10b9c90$export$b5836b71941fa3ed; }, function (v) { return $77bb68a4b10b9c90$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $77bb68a4b10b9c90$export$cf845f2c119da08a; }, function (v) { return $77bb68a4b10b9c90$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $77bb68a4b10b9c90$export$c4744153514ff05d;
var $77bb68a4b10b9c90$export$3e506c1ccc9cc1a7;
var $77bb68a4b10b9c90$export$e26fe2ed2fa76875;
var $77bb68a4b10b9c90$export$502329bbf4b505b1;
var $77bb68a4b10b9c90$export$6e3807111c4874c4;
var $77bb68a4b10b9c90$export$c27134553091fb3a;
var $77bb68a4b10b9c90$export$33ee1acdc04fd2a2;
var $77bb68a4b10b9c90$export$b00a404bbd5edef2;
var $77bb68a4b10b9c90$export$d66a1c1c77bd778b;
var $77bb68a4b10b9c90$export$d3dfb8e4810cb555;
var $77bb68a4b10b9c90$export$72fdf0e06517287b;
var $77bb68a4b10b9c90$export$816d2913ae6b83b1;
var $77bb68a4b10b9c90$export$61bcfe829111a1d0;
var $77bb68a4b10b9c90$export$7ee8c9beb337bc3f;
var $77bb68a4b10b9c90$export$b5836b71941fa3ed;
var $77bb68a4b10b9c90$export$cf845f2c119da08a;
"use strict";
function $77bb68a4b10b9c90$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $77bb68a4b10b9c90$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $77bb68a4b10b9c90$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $77bb68a4b10b9c90$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $77bb68a4b10b9c90$var$compare(left, last)) rightIndex < length && 0 > $77bb68a4b10b9c90$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $77bb68a4b10b9c90$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $77bb68a4b10b9c90$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$77bb68a4b10b9c90$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $77bb68a4b10b9c90$var$localPerformance = performance;
    $77bb68a4b10b9c90$export$c4744153514ff05d = function() {
        return $77bb68a4b10b9c90$var$localPerformance.now();
    };
} else {
    var $77bb68a4b10b9c90$var$localDate = Date, $77bb68a4b10b9c90$var$initialTime = $77bb68a4b10b9c90$var$localDate.now();
    $77bb68a4b10b9c90$export$c4744153514ff05d = function() {
        return $77bb68a4b10b9c90$var$localDate.now() - $77bb68a4b10b9c90$var$initialTime;
    };
}
var $77bb68a4b10b9c90$var$taskQueue = [], $77bb68a4b10b9c90$var$timerQueue = [], $77bb68a4b10b9c90$var$taskIdCounter = 1, $77bb68a4b10b9c90$var$currentTask = null, $77bb68a4b10b9c90$var$currentPriorityLevel = 3, $77bb68a4b10b9c90$var$isPerformingWork = !1, $77bb68a4b10b9c90$var$isHostCallbackScheduled = !1, $77bb68a4b10b9c90$var$isHostTimeoutScheduled = !1, $77bb68a4b10b9c90$var$needsPaint = !1, $77bb68a4b10b9c90$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $77bb68a4b10b9c90$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $77bb68a4b10b9c90$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $77bb68a4b10b9c90$var$advanceTimers(currentTime) {
    for(var timer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue); null !== timer;){
        if (null === timer.callback) $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$timerQueue);
        else if (timer.startTime <= currentTime) $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$timerQueue), timer.sortIndex = timer.expirationTime, $77bb68a4b10b9c90$var$push($77bb68a4b10b9c90$var$taskQueue, timer);
        else break;
        timer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue);
    }
}
function $77bb68a4b10b9c90$var$handleTimeout(currentTime) {
    $77bb68a4b10b9c90$var$isHostTimeoutScheduled = !1;
    $77bb68a4b10b9c90$var$advanceTimers(currentTime);
    if (!$77bb68a4b10b9c90$var$isHostCallbackScheduled) {
        if (null !== $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue)) $77bb68a4b10b9c90$var$isHostCallbackScheduled = !0, $77bb68a4b10b9c90$var$isMessageLoopRunning || ($77bb68a4b10b9c90$var$isMessageLoopRunning = !0, $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue);
            null !== firstTimer && $77bb68a4b10b9c90$var$requestHostTimeout($77bb68a4b10b9c90$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $77bb68a4b10b9c90$var$isMessageLoopRunning = !1, $77bb68a4b10b9c90$var$taskTimeoutID = -1, $77bb68a4b10b9c90$var$frameInterval = 5, $77bb68a4b10b9c90$var$startTime = -1;
function $77bb68a4b10b9c90$var$shouldYieldToHost() {
    return $77bb68a4b10b9c90$var$needsPaint ? !0 : $77bb68a4b10b9c90$export$c4744153514ff05d() - $77bb68a4b10b9c90$var$startTime < $77bb68a4b10b9c90$var$frameInterval ? !1 : !0;
}
function $77bb68a4b10b9c90$var$performWorkUntilDeadline() {
    $77bb68a4b10b9c90$var$needsPaint = !1;
    if ($77bb68a4b10b9c90$var$isMessageLoopRunning) {
        var currentTime = $77bb68a4b10b9c90$export$c4744153514ff05d();
        $77bb68a4b10b9c90$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $77bb68a4b10b9c90$var$isHostCallbackScheduled = !1;
                $77bb68a4b10b9c90$var$isHostTimeoutScheduled && ($77bb68a4b10b9c90$var$isHostTimeoutScheduled = !1, $77bb68a4b10b9c90$var$localClearTimeout($77bb68a4b10b9c90$var$taskTimeoutID), $77bb68a4b10b9c90$var$taskTimeoutID = -1);
                $77bb68a4b10b9c90$var$isPerformingWork = !0;
                var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
                try {
                    b: {
                        $77bb68a4b10b9c90$var$advanceTimers(currentTime);
                        for($77bb68a4b10b9c90$var$currentTask = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue); null !== $77bb68a4b10b9c90$var$currentTask && !($77bb68a4b10b9c90$var$currentTask.expirationTime > currentTime && $77bb68a4b10b9c90$var$shouldYieldToHost());){
                            var callback = $77bb68a4b10b9c90$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $77bb68a4b10b9c90$var$currentTask.callback = null;
                                $77bb68a4b10b9c90$var$currentPriorityLevel = $77bb68a4b10b9c90$var$currentTask.priorityLevel;
                                var continuationCallback = callback($77bb68a4b10b9c90$var$currentTask.expirationTime <= currentTime);
                                currentTime = $77bb68a4b10b9c90$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $77bb68a4b10b9c90$var$currentTask.callback = continuationCallback;
                                    $77bb68a4b10b9c90$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $77bb68a4b10b9c90$var$currentTask === $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue) && $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$taskQueue);
                                $77bb68a4b10b9c90$var$advanceTimers(currentTime);
                            } else $77bb68a4b10b9c90$var$pop($77bb68a4b10b9c90$var$taskQueue);
                            $77bb68a4b10b9c90$var$currentTask = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue);
                        }
                        if (null !== $77bb68a4b10b9c90$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue);
                            null !== firstTimer && $77bb68a4b10b9c90$var$requestHostTimeout($77bb68a4b10b9c90$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $77bb68a4b10b9c90$var$currentTask = null, $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel, $77bb68a4b10b9c90$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline() : $77bb68a4b10b9c90$var$isMessageLoopRunning = !1;
        }
    }
}
var $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $77bb68a4b10b9c90$var$localSetImmediate) $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline = function() {
    $77bb68a4b10b9c90$var$localSetImmediate($77bb68a4b10b9c90$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $77bb68a4b10b9c90$var$channel = new MessageChannel(), $77bb68a4b10b9c90$var$port = $77bb68a4b10b9c90$var$channel.port2;
    $77bb68a4b10b9c90$var$channel.port1.onmessage = $77bb68a4b10b9c90$var$performWorkUntilDeadline;
    $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline = function() {
        $77bb68a4b10b9c90$var$port.postMessage(null);
    };
} else $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline = function() {
    $77bb68a4b10b9c90$var$localSetTimeout($77bb68a4b10b9c90$var$performWorkUntilDeadline, 0);
};
function $77bb68a4b10b9c90$var$requestHostTimeout(callback, ms) {
    $77bb68a4b10b9c90$var$taskTimeoutID = $77bb68a4b10b9c90$var$localSetTimeout(function() {
        callback($77bb68a4b10b9c90$export$c4744153514ff05d());
    }, ms);
}
$77bb68a4b10b9c90$export$3e506c1ccc9cc1a7 = 5;
$77bb68a4b10b9c90$export$e26fe2ed2fa76875 = 1;
$77bb68a4b10b9c90$export$502329bbf4b505b1 = 4;
$77bb68a4b10b9c90$export$6e3807111c4874c4 = 3;
$77bb68a4b10b9c90$export$c27134553091fb3a = null;
$77bb68a4b10b9c90$export$33ee1acdc04fd2a2 = 2;
$77bb68a4b10b9c90$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$77bb68a4b10b9c90$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $77bb68a4b10b9c90$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$77bb68a4b10b9c90$export$d3dfb8e4810cb555 = function() {
    return $77bb68a4b10b9c90$var$currentPriorityLevel;
};
$77bb68a4b10b9c90$export$72fdf0e06517287b = function(eventHandler) {
    switch($77bb68a4b10b9c90$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    $77bb68a4b10b9c90$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$77bb68a4b10b9c90$export$816d2913ae6b83b1 = function() {
    $77bb68a4b10b9c90$var$needsPaint = !0;
};
$77bb68a4b10b9c90$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    $77bb68a4b10b9c90$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$77bb68a4b10b9c90$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $77bb68a4b10b9c90$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $77bb68a4b10b9c90$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $77bb68a4b10b9c90$var$push($77bb68a4b10b9c90$var$timerQueue, priorityLevel), null === $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$taskQueue) && priorityLevel === $77bb68a4b10b9c90$var$peek($77bb68a4b10b9c90$var$timerQueue) && ($77bb68a4b10b9c90$var$isHostTimeoutScheduled ? ($77bb68a4b10b9c90$var$localClearTimeout($77bb68a4b10b9c90$var$taskTimeoutID), $77bb68a4b10b9c90$var$taskTimeoutID = -1) : $77bb68a4b10b9c90$var$isHostTimeoutScheduled = !0, $77bb68a4b10b9c90$var$requestHostTimeout($77bb68a4b10b9c90$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $77bb68a4b10b9c90$var$push($77bb68a4b10b9c90$var$taskQueue, priorityLevel), $77bb68a4b10b9c90$var$isHostCallbackScheduled || $77bb68a4b10b9c90$var$isPerformingWork || ($77bb68a4b10b9c90$var$isHostCallbackScheduled = !0, $77bb68a4b10b9c90$var$isMessageLoopRunning || ($77bb68a4b10b9c90$var$isMessageLoopRunning = !0, $77bb68a4b10b9c90$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$77bb68a4b10b9c90$export$b5836b71941fa3ed = $77bb68a4b10b9c90$var$shouldYieldToHost;
$77bb68a4b10b9c90$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $77bb68a4b10b9c90$var$currentPriorityLevel;
        $77bb68a4b10b9c90$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $77bb68a4b10b9c90$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("jGswQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("761wi"));

});
parcelRegister("761wi", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $52aa45c6494dbedf$export$9c16c1426311996d; }, function (v) { return $52aa45c6494dbedf$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $52aa45c6494dbedf$export$dca3b0875bd9a954; }, function (v) { return $52aa45c6494dbedf$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $52aa45c6494dbedf$export$16fa2f45be04daa8; }, function (v) { return $52aa45c6494dbedf$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $52aa45c6494dbedf$export$ffb0004e005737fa; }, function (v) { return $52aa45c6494dbedf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $52aa45c6494dbedf$export$e2c29f18771995cb; }, function (v) { return $52aa45c6494dbedf$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $52aa45c6494dbedf$export$221d75b3f55bb0bd; }, function (v) { return $52aa45c6494dbedf$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $52aa45c6494dbedf$export$5f8d39834fd61797; }, function (v) { return $52aa45c6494dbedf$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $52aa45c6494dbedf$export$74bf444e3cd11ea5; }, function (v) { return $52aa45c6494dbedf$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "ViewTransition", function () { return $52aa45c6494dbedf$export$8cdaa4703948c5e9; }, function (v) { return $52aa45c6494dbedf$export$8cdaa4703948c5e9 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $52aa45c6494dbedf$export$1ced07cd6b1985ce; }, function (v) { return $52aa45c6494dbedf$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $52aa45c6494dbedf$export$abd8e32b826d7ea7; }, function (v) { return $52aa45c6494dbedf$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "addTransitionType", function () { return $52aa45c6494dbedf$export$87c99536b1b8cdd8; }, function (v) { return $52aa45c6494dbedf$export$87c99536b1b8cdd8 = v; });
$parcel$export(module.exports, "cache", function () { return $52aa45c6494dbedf$export$69a3209f1a06c04d; }, function (v) { return $52aa45c6494dbedf$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $52aa45c6494dbedf$export$8c538325882c7eec; }, function (v) { return $52aa45c6494dbedf$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $52aa45c6494dbedf$export$e530037191fcd5d7; }, function (v) { return $52aa45c6494dbedf$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $52aa45c6494dbedf$export$fd42f52fd3ae1109; }, function (v) { return $52aa45c6494dbedf$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $52aa45c6494dbedf$export$c8a8987d4410bf2d; }, function (v) { return $52aa45c6494dbedf$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $52aa45c6494dbedf$export$7d1e3a5e95ceca43; }, function (v) { return $52aa45c6494dbedf$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $52aa45c6494dbedf$export$257a8862b851cb5b; }, function (v) { return $52aa45c6494dbedf$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $52aa45c6494dbedf$export$a8257692ac88316c; }, function (v) { return $52aa45c6494dbedf$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $52aa45c6494dbedf$export$488013bae63b21da; }, function (v) { return $52aa45c6494dbedf$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $52aa45c6494dbedf$export$7c73462e0d25e514; }, function (v) { return $52aa45c6494dbedf$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $52aa45c6494dbedf$export$7568632d0d33d16d; }, function (v) { return $52aa45c6494dbedf$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $52aa45c6494dbedf$export$f93f40ac0ca7e3a8; }, function (v) { return $52aa45c6494dbedf$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $52aa45c6494dbedf$export$1f96ae73734a86cc; }, function (v) { return $52aa45c6494dbedf$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $52aa45c6494dbedf$export$9a47ced3238df325; }, function (v) { return $52aa45c6494dbedf$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $52aa45c6494dbedf$export$35808ee640e87ca7; }, function (v) { return $52aa45c6494dbedf$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $52aa45c6494dbedf$export$fae74005e78b1a27; }, function (v) { return $52aa45c6494dbedf$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $52aa45c6494dbedf$export$dc8fbce3eb94dc1e; }, function (v) { return $52aa45c6494dbedf$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $52aa45c6494dbedf$export$6a7bc4e911dc01cf; }, function (v) { return $52aa45c6494dbedf$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $52aa45c6494dbedf$export$6d9c69b0de29b591; }, function (v) { return $52aa45c6494dbedf$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $52aa45c6494dbedf$export$7f54fc3180508a52; }, function (v) { return $52aa45c6494dbedf$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $52aa45c6494dbedf$export$f680877a34711e37; }, function (v) { return $52aa45c6494dbedf$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $52aa45c6494dbedf$export$d5a552a76deda3c2; }, function (v) { return $52aa45c6494dbedf$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $52aa45c6494dbedf$export$aaabe4eda9ed9969; }, function (v) { return $52aa45c6494dbedf$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $52aa45c6494dbedf$export$e5c5a5f917a5871c; }, function (v) { return $52aa45c6494dbedf$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $52aa45c6494dbedf$export$1538c33de8887b59; }, function (v) { return $52aa45c6494dbedf$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $52aa45c6494dbedf$export$fca7f784ae7a249a; }, function (v) { return $52aa45c6494dbedf$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $52aa45c6494dbedf$export$13e3392192263954; }, function (v) { return $52aa45c6494dbedf$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $52aa45c6494dbedf$export$b8f5890fc79d6aca; }, function (v) { return $52aa45c6494dbedf$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $52aa45c6494dbedf$export$60241385465d0a34; }, function (v) { return $52aa45c6494dbedf$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $52aa45c6494dbedf$export$306c0aa65ff9ec16; }, function (v) { return $52aa45c6494dbedf$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $52aa45c6494dbedf$export$7b286972b8d8ccbf; }, function (v) { return $52aa45c6494dbedf$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $52aa45c6494dbedf$export$83d89fbfd8236492; }, function (v) { return $52aa45c6494dbedf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $52aa45c6494dbedf$export$9c16c1426311996d;
var $52aa45c6494dbedf$export$dca3b0875bd9a954;
var $52aa45c6494dbedf$export$16fa2f45be04daa8;
var $52aa45c6494dbedf$export$ffb0004e005737fa;
var $52aa45c6494dbedf$export$e2c29f18771995cb;
var $52aa45c6494dbedf$export$221d75b3f55bb0bd;
var $52aa45c6494dbedf$export$5f8d39834fd61797;
var $52aa45c6494dbedf$export$74bf444e3cd11ea5;
var $52aa45c6494dbedf$export$8cdaa4703948c5e9;
var $52aa45c6494dbedf$export$1ced07cd6b1985ce;
var $52aa45c6494dbedf$export$abd8e32b826d7ea7;
var $52aa45c6494dbedf$export$87c99536b1b8cdd8;
var $52aa45c6494dbedf$export$69a3209f1a06c04d;
var $52aa45c6494dbedf$export$8c538325882c7eec;
var $52aa45c6494dbedf$export$e530037191fcd5d7;
var $52aa45c6494dbedf$export$fd42f52fd3ae1109;
var $52aa45c6494dbedf$export$c8a8987d4410bf2d;
var $52aa45c6494dbedf$export$7d1e3a5e95ceca43;
var $52aa45c6494dbedf$export$257a8862b851cb5b;
var $52aa45c6494dbedf$export$a8257692ac88316c;
var $52aa45c6494dbedf$export$488013bae63b21da;
var $52aa45c6494dbedf$export$7c73462e0d25e514;
var $52aa45c6494dbedf$export$7568632d0d33d16d;
var $52aa45c6494dbedf$export$f93f40ac0ca7e3a8;
var $52aa45c6494dbedf$export$1f96ae73734a86cc;
var $52aa45c6494dbedf$export$9a47ced3238df325;
var $52aa45c6494dbedf$export$35808ee640e87ca7;
var $52aa45c6494dbedf$export$fae74005e78b1a27;
var $52aa45c6494dbedf$export$dc8fbce3eb94dc1e;
var $52aa45c6494dbedf$export$6a7bc4e911dc01cf;
var $52aa45c6494dbedf$export$6d9c69b0de29b591;
var $52aa45c6494dbedf$export$7f54fc3180508a52;
var $52aa45c6494dbedf$export$f680877a34711e37;
var $52aa45c6494dbedf$export$d5a552a76deda3c2;
var $52aa45c6494dbedf$export$aaabe4eda9ed9969;
var $52aa45c6494dbedf$export$e5c5a5f917a5871c;
var $52aa45c6494dbedf$export$1538c33de8887b59;
var $52aa45c6494dbedf$export$fca7f784ae7a249a;
var $52aa45c6494dbedf$export$13e3392192263954;
var $52aa45c6494dbedf$export$b8f5890fc79d6aca;
var $52aa45c6494dbedf$export$60241385465d0a34;
var $52aa45c6494dbedf$export$306c0aa65ff9ec16;
var $52aa45c6494dbedf$export$7b286972b8d8ccbf;
var $52aa45c6494dbedf$export$83d89fbfd8236492;
"use strict";
var $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $52aa45c6494dbedf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $52aa45c6494dbedf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $52aa45c6494dbedf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $52aa45c6494dbedf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $52aa45c6494dbedf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $52aa45c6494dbedf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $52aa45c6494dbedf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $52aa45c6494dbedf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $52aa45c6494dbedf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $52aa45c6494dbedf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $52aa45c6494dbedf$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $52aa45c6494dbedf$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $52aa45c6494dbedf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $52aa45c6494dbedf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $52aa45c6494dbedf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$52aa45c6494dbedf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $52aa45c6494dbedf$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $52aa45c6494dbedf$var$assign = Object.assign, $52aa45c6494dbedf$var$emptyObject = {};
function $52aa45c6494dbedf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $52aa45c6494dbedf$var$emptyObject;
    this.updater = updater || $52aa45c6494dbedf$var$ReactNoopUpdateQueue;
}
$52aa45c6494dbedf$var$Component.prototype.isReactComponent = {};
$52aa45c6494dbedf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$52aa45c6494dbedf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $52aa45c6494dbedf$var$ComponentDummy() {}
$52aa45c6494dbedf$var$ComponentDummy.prototype = $52aa45c6494dbedf$var$Component.prototype;
function $52aa45c6494dbedf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $52aa45c6494dbedf$var$emptyObject;
    this.updater = updater || $52aa45c6494dbedf$var$ReactNoopUpdateQueue;
}
var $52aa45c6494dbedf$var$pureComponentPrototype = $52aa45c6494dbedf$var$PureComponent.prototype = new $52aa45c6494dbedf$var$ComponentDummy();
$52aa45c6494dbedf$var$pureComponentPrototype.constructor = $52aa45c6494dbedf$var$PureComponent;
$52aa45c6494dbedf$var$assign($52aa45c6494dbedf$var$pureComponentPrototype, $52aa45c6494dbedf$var$Component.prototype);
$52aa45c6494dbedf$var$pureComponentPrototype.isPureReactComponent = !0;
var $52aa45c6494dbedf$var$isArrayImpl = Array.isArray;
function $52aa45c6494dbedf$var$noop() {}
var $52aa45c6494dbedf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $52aa45c6494dbedf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $52aa45c6494dbedf$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $52aa45c6494dbedf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $52aa45c6494dbedf$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $52aa45c6494dbedf$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE;
}
function $52aa45c6494dbedf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $52aa45c6494dbedf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $52aa45c6494dbedf$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $52aa45c6494dbedf$var$escape("" + element.key) : index.toString(36);
}
function $52aa45c6494dbedf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($52aa45c6494dbedf$var$noop, $52aa45c6494dbedf$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $52aa45c6494dbedf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $52aa45c6494dbedf$var$REACT_ELEMENT_TYPE:
                case $52aa45c6494dbedf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $52aa45c6494dbedf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $52aa45c6494dbedf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $52aa45c6494dbedf$var$getElementKey(children, 0) : nameSoFar, $52aa45c6494dbedf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($52aa45c6494dbedf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $52aa45c6494dbedf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($52aa45c6494dbedf$var$isValidElement(callback) && (callback = $52aa45c6494dbedf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($52aa45c6494dbedf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($52aa45c6494dbedf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $52aa45c6494dbedf$var$getElementKey(nameSoFar, i), invokeCallback += $52aa45c6494dbedf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $52aa45c6494dbedf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $52aa45c6494dbedf$var$getElementKey(nameSoFar, i++), invokeCallback += $52aa45c6494dbedf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $52aa45c6494dbedf$var$mapIntoArray($52aa45c6494dbedf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $52aa45c6494dbedf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $52aa45c6494dbedf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $52aa45c6494dbedf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $52aa45c6494dbedf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $52aa45c6494dbedf$var$startTransition(scope) {
    var prevTransition = $52aa45c6494dbedf$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $52aa45c6494dbedf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $52aa45c6494dbedf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($52aa45c6494dbedf$var$noop, $52aa45c6494dbedf$var$reportGlobalError);
    } catch (error) {
        $52aa45c6494dbedf$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $52aa45c6494dbedf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $52aa45c6494dbedf$var$addTransitionType(type) {
    var transition = $52aa45c6494dbedf$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $52aa45c6494dbedf$var$startTransition($52aa45c6494dbedf$var$addTransitionType.bind(null, type));
}
var $52aa45c6494dbedf$var$Children = {
    map: $52aa45c6494dbedf$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $52aa45c6494dbedf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $52aa45c6494dbedf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $52aa45c6494dbedf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$52aa45c6494dbedf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$52aa45c6494dbedf$export$9c16c1426311996d = $52aa45c6494dbedf$var$REACT_ACTIVITY_TYPE;
$52aa45c6494dbedf$export$dca3b0875bd9a954 = $52aa45c6494dbedf$var$Children;
$52aa45c6494dbedf$export$16fa2f45be04daa8 = $52aa45c6494dbedf$var$Component;
$52aa45c6494dbedf$export$ffb0004e005737fa = $52aa45c6494dbedf$var$REACT_FRAGMENT_TYPE;
$52aa45c6494dbedf$export$e2c29f18771995cb = $52aa45c6494dbedf$var$REACT_PROFILER_TYPE;
$52aa45c6494dbedf$export$221d75b3f55bb0bd = $52aa45c6494dbedf$var$PureComponent;
$52aa45c6494dbedf$export$5f8d39834fd61797 = $52aa45c6494dbedf$var$REACT_STRICT_MODE_TYPE;
$52aa45c6494dbedf$export$74bf444e3cd11ea5 = $52aa45c6494dbedf$var$REACT_SUSPENSE_TYPE;
$52aa45c6494dbedf$export$8cdaa4703948c5e9 = $52aa45c6494dbedf$var$REACT_VIEW_TRANSITION_TYPE;
$52aa45c6494dbedf$export$1ced07cd6b1985ce = $52aa45c6494dbedf$var$ReactSharedInternals;
$52aa45c6494dbedf$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $52aa45c6494dbedf$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$52aa45c6494dbedf$export$87c99536b1b8cdd8 = $52aa45c6494dbedf$var$addTransitionType;
$52aa45c6494dbedf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$52aa45c6494dbedf$export$8c538325882c7eec = function() {
    return null;
};
$52aa45c6494dbedf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $52aa45c6494dbedf$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$52aa45c6494dbedf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $52aa45c6494dbedf$var$ReactElement(element.type, key, props);
};
$52aa45c6494dbedf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $52aa45c6494dbedf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $52aa45c6494dbedf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$52aa45c6494dbedf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$52aa45c6494dbedf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $52aa45c6494dbedf$var$ReactElement(type, key, props);
};
$52aa45c6494dbedf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$52aa45c6494dbedf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$52aa45c6494dbedf$export$a8257692ac88316c = $52aa45c6494dbedf$var$isValidElement;
$52aa45c6494dbedf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $52aa45c6494dbedf$var$lazyInitializer
    };
};
$52aa45c6494dbedf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $52aa45c6494dbedf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$52aa45c6494dbedf$export$7568632d0d33d16d = $52aa45c6494dbedf$var$startTransition;
$52aa45c6494dbedf$export$f93f40ac0ca7e3a8 = function() {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useCacheRefresh();
};
$52aa45c6494dbedf$export$1f96ae73734a86cc = function(usable) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.use(usable);
};
$52aa45c6494dbedf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$52aa45c6494dbedf$export$35808ee640e87ca7 = function(callback, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$52aa45c6494dbedf$export$fae74005e78b1a27 = function(Context) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useContext(Context);
};
$52aa45c6494dbedf$export$dc8fbce3eb94dc1e = function() {};
$52aa45c6494dbedf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$52aa45c6494dbedf$export$6d9c69b0de29b591 = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useEffect(create, deps);
};
$52aa45c6494dbedf$export$7f54fc3180508a52 = function(callback) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$52aa45c6494dbedf$export$f680877a34711e37 = function() {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useId();
};
$52aa45c6494dbedf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$52aa45c6494dbedf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$52aa45c6494dbedf$export$e5c5a5f917a5871c = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$52aa45c6494dbedf$export$1538c33de8887b59 = function(create, deps) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$52aa45c6494dbedf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$52aa45c6494dbedf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$52aa45c6494dbedf$export$b8f5890fc79d6aca = function(initialValue) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useRef(initialValue);
};
$52aa45c6494dbedf$export$60241385465d0a34 = function(initialState) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useState(initialState);
};
$52aa45c6494dbedf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$52aa45c6494dbedf$export$7b286972b8d8ccbf = function() {
    return $52aa45c6494dbedf$var$ReactSharedInternals.H.useTransition();
};
$52aa45c6494dbedf$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("5hICV", function(module, exports) {
'use strict';
function $3d91283959fa027f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3d91283959fa027f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3d91283959fa027f$var$checkDCE();

module.exports = (parcelRequire("7NLsj"));

});
parcelRegister("7NLsj", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0; }, function (v) { return $5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $5ae1ebb1e77c87b4$export$3f2684e5d7cb1006; }, function (v) { return $5ae1ebb1e77c87b4$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $5ae1ebb1e77c87b4$export$d39a5bbd09211389; }, function (v) { return $5ae1ebb1e77c87b4$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4; }, function (v) { return $5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $5ae1ebb1e77c87b4$export$a0816fa17a9e79be; }, function (v) { return $5ae1ebb1e77c87b4$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $5ae1ebb1e77c87b4$export$7292efcadded39f3; }, function (v) { return $5ae1ebb1e77c87b4$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $5ae1ebb1e77c87b4$export$da407abadb9b8f86; }, function (v) { return $5ae1ebb1e77c87b4$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $5ae1ebb1e77c87b4$export$314cfea32580671c; }, function (v) { return $5ae1ebb1e77c87b4$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $5ae1ebb1e77c87b4$export$513ccb98c53b8039; }, function (v) { return $5ae1ebb1e77c87b4$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $5ae1ebb1e77c87b4$export$dbca993bc2d264a; }, function (v) { return $5ae1ebb1e77c87b4$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $5ae1ebb1e77c87b4$export$4797a8006f0655d0; }, function (v) { return $5ae1ebb1e77c87b4$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5ae1ebb1e77c87b4$export$c78a37762a8d58e1; }, function (v) { return $5ae1ebb1e77c87b4$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $5ae1ebb1e77c87b4$export$606f11b2eb45ecc6; }, function (v) { return $5ae1ebb1e77c87b4$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e; }, function (v) { return $5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $5ae1ebb1e77c87b4$export$83d89fbfd8236492; }, function (v) { return $5ae1ebb1e77c87b4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0;
var $5ae1ebb1e77c87b4$export$3f2684e5d7cb1006;
var $5ae1ebb1e77c87b4$export$d39a5bbd09211389;
var $5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4;
var $5ae1ebb1e77c87b4$export$a0816fa17a9e79be;
var $5ae1ebb1e77c87b4$export$7292efcadded39f3;
var $5ae1ebb1e77c87b4$export$da407abadb9b8f86;
var $5ae1ebb1e77c87b4$export$314cfea32580671c;
var $5ae1ebb1e77c87b4$export$513ccb98c53b8039;
var $5ae1ebb1e77c87b4$export$dbca993bc2d264a;
var $5ae1ebb1e77c87b4$export$4797a8006f0655d0;
var $5ae1ebb1e77c87b4$export$c78a37762a8d58e1;
var $5ae1ebb1e77c87b4$export$606f11b2eb45ecc6;
var $5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e;
var $5ae1ebb1e77c87b4$export$83d89fbfd8236492;
"use strict";

var $jGswQ = parcelRequire("jGswQ");
function $5ae1ebb1e77c87b4$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5ae1ebb1e77c87b4$var$noop() {}
var $5ae1ebb1e77c87b4$var$Internals = {
    d: {
        f: $5ae1ebb1e77c87b4$var$noop,
        r: function() {
            throw Error($5ae1ebb1e77c87b4$var$formatProdErrorMessage(522));
        },
        D: $5ae1ebb1e77c87b4$var$noop,
        C: $5ae1ebb1e77c87b4$var$noop,
        L: $5ae1ebb1e77c87b4$var$noop,
        m: $5ae1ebb1e77c87b4$var$noop,
        X: $5ae1ebb1e77c87b4$var$noop,
        S: $5ae1ebb1e77c87b4$var$noop,
        M: $5ae1ebb1e77c87b4$var$noop
    },
    p: 0,
    findDOMNode: null
}, $5ae1ebb1e77c87b4$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5ae1ebb1e77c87b4$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $5ae1ebb1e77c87b4$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $5ae1ebb1e77c87b4$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5ae1ebb1e77c87b4$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $5ae1ebb1e77c87b4$var$REACT_OPTIMISTIC_KEY ? $5ae1ebb1e77c87b4$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $5ae1ebb1e77c87b4$var$ReactSharedInternals = $jGswQ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$5ae1ebb1e77c87b4$export$69ce8ef3fe5cead0 = $5ae1ebb1e77c87b4$var$Internals;
$5ae1ebb1e77c87b4$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $5ae1ebb1e77c87b4$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$5ae1ebb1e77c87b4$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($5ae1ebb1e77c87b4$var$formatProdErrorMessage(299));
    return $5ae1ebb1e77c87b4$var$createPortal$1(children, container, null, key);
};
$5ae1ebb1e77c87b4$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $5ae1ebb1e77c87b4$var$ReactSharedInternals.T, previousUpdatePriority = $5ae1ebb1e77c87b4$var$Internals.p;
    try {
        if ($5ae1ebb1e77c87b4$var$ReactSharedInternals.T = null, $5ae1ebb1e77c87b4$var$Internals.p = 2, fn) return fn();
    } finally{
        $5ae1ebb1e77c87b4$var$ReactSharedInternals.T = previousTransition, $5ae1ebb1e77c87b4$var$Internals.p = previousUpdatePriority, $5ae1ebb1e77c87b4$var$Internals.d.f();
    }
};
$5ae1ebb1e77c87b4$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $5ae1ebb1e77c87b4$var$Internals.d.C(href, options));
};
$5ae1ebb1e77c87b4$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $5ae1ebb1e77c87b4$var$Internals.d.D(href);
};
$5ae1ebb1e77c87b4$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $5ae1ebb1e77c87b4$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $5ae1ebb1e77c87b4$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$5ae1ebb1e77c87b4$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $5ae1ebb1e77c87b4$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $5ae1ebb1e77c87b4$var$Internals.d.M(href);
    }
};
$5ae1ebb1e77c87b4$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(as, options.crossOrigin);
        $5ae1ebb1e77c87b4$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$5ae1ebb1e77c87b4$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $5ae1ebb1e77c87b4$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $5ae1ebb1e77c87b4$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $5ae1ebb1e77c87b4$var$Internals.d.m(href);
    }
};
$5ae1ebb1e77c87b4$export$4797a8006f0655d0 = function(form) {
    $5ae1ebb1e77c87b4$var$Internals.d.r(form);
};
$5ae1ebb1e77c87b4$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$5ae1ebb1e77c87b4$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $5ae1ebb1e77c87b4$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$5ae1ebb1e77c87b4$export$f7e8a0bf92324b1e = function() {
    return $5ae1ebb1e77c87b4$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$5ae1ebb1e77c87b4$export$83d89fbfd8236492 = "19.3.1";

});



var $40d3ecb62ca60c31$exports = {};
'use strict';

$40d3ecb62ca60c31$exports = (parcelRequire("jYqtV"));


var $9c391b1d92b7475a$exports = {};
'use strict';
function $9c391b1d92b7475a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9c391b1d92b7475a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9c391b1d92b7475a$var$checkDCE();

$9c391b1d92b7475a$exports = (parcelRequire("He5iZ"));


var $80be266eed4217c0$export$711302eb3e721627;
$80be266eed4217c0$export$711302eb3e721627 = `WnT_GG_containerHome`;




var $jGswQ = parcelRequire("jGswQ");


var $jGswQ = parcelRequire("jGswQ");
var $49ec84144abdf02d$export$34e0f9847d4c02dd;
var $49ec84144abdf02d$export$ca787a737bfba0a9;
var $49ec84144abdf02d$export$2e6c959c16ff56b8;
$49ec84144abdf02d$export$34e0f9847d4c02dd = `QiLpzW_container`;
$49ec84144abdf02d$export$ca787a737bfba0a9 = `QiLpzW_inFlow`;
$49ec84144abdf02d$export$2e6c959c16ff56b8 = `QiLpzW_select`;


const $26e1941f4b3bed1e$export$baf819189b0ccc9b = {
    mida_home: '978px',
    mida_noticia_lg: '1160px',
    mida_noticia_md: '600px',
    mida_noticia_sm: '320px',
    mida_noticia_xsm: '280px'
};


const $94aeed367a707789$var$VERSIONS = [
    {
        value: 'home',
        label: 'HOME'
    },
    {
        value: 'noticia_lg',
        label: "NOT\xcdCIA LG"
    },
    {
        value: 'noticia_md',
        label: "NOT\xcdCIA MD"
    },
    {
        value: 'noticia_sm',
        label: "NOT\xcdCIA SM"
    },
    {
        value: 'noticia_xsm',
        label: "NOT\xcdCIA XSM"
    }
];
const $94aeed367a707789$var$HeaderEmbed = ({ allowHomeEmbed: allowHomeEmbed = false, inFlow: inFlow = false, targetSelector: targetSelector = '[id^="app-"]' })=>{
    const [text, setText] = (0, $jGswQ.useState)(null);
    const [versioActiva, setVersioActiva] = (0, $jGswQ.useState)('noticia_md');
    const handleClick = (target)=>{
        const perHome = target === 'perHome';
        const targetLabel = target === 'perHome' ? 'HOME' : target === 'perNoticia1' ? "NOT\xcdCIA (1r embed)" : "NOT\xcdCIA (2n embed i posteriors)";
        const url = window.location.origin;
        const path = window.location.pathname;
        const projecte = path.split('/')[1];
        const query = new URLSearchParams(window.location.search);
        query.delete('preview');
        query.delete('embed-home');
        let datasets = '';
        query.forEach((value, key)=>{
            datasets += ` data-${key}="${value}"`;
        });
        const slug = query.get('slug');
        if (projecte === 'hemicicles' || projecte === 'widgets-eleccions') {
            const esHemicicles = projecte === 'hemicicles';
            const slugProj = esHemicicles ? `graficsweb/hemicicles/${slug}` : slug;
            const urlBase = query.get('url-base') || 'https://eleccions.ara.cat';
            const id = esHemicicles ? `hemicicle_${slug}` : slugProj?.replaceAll('/', '_');
            const embed = `<iframe id="${id}" src="${urlBase}/${slugProj}" height="58px" loading="lazy"></iframe>
			${perHome ? `<style>#${id}{width: 1px;min-width: 100%;margin-bottom: 20px;border: none;overflow: hidden;}
			@media only screen and (min-width: 768px) {#${id}{margin-bottom: 56px;}}</style>` : `<style>#${id}{width: 1px;min-width: 100%;border: none;overflow: hidden;}</style>`}
			<script type="text/javascript" src="${urlBase}/scripts/iframeResizer.min.js"></script>
			<script>document.addEventListener("DOMContentLoaded", function() { 
				document.getElementById("${id}").onload= function() { 
					iFrameResize({ log: false }, "#${id}");
				};
			});</script>`;
            navigator.clipboard.writeText(embed);
            setText(`Embed copiat per ${targetLabel} al porta-retalls`);
            setTimeout(()=>setText(null), 5000);
        } else {
            let embed = '';
            if (target === 'perNoticia2') embed = `<div id="app-${projecte}${slug ? `-${slug}` : ''}" class="embed-${projecte}"${datasets}></div>`;
            else embed = `<div id="app-${projecte}${slug ? `-${slug}` : ''}" class="embed-${projecte}"${datasets}${perHome ? ` data-embed-home="1"` : ''}></div>
	<link rel="stylesheet" href="${url}/projectes/${projecte}/dist/style.css">
	<script type="module" src="${url}/projectes/${projecte}/dist/index.js"></script>`;
            navigator.clipboard.writeText(embed);
            setText(`Embed copiat per ${targetLabel} al porta-retalls`);
            setTimeout(()=>setText(null), 5000);
        }
    };
    const handleVersio = (novaVersio)=>{
        localStorage.setItem('headerEmbedVersio', novaVersio ?? 'noticia_md');
        setVersioActiva(novaVersio);
        const url = new URL(window.location.href);
        // Editr search params
        const searchParams = new URLSearchParams(url.search);
        if (novaVersio === 'home') searchParams.set('embed-home', '1');
        else searchParams.delete('embed-home');
        const search = searchParams.toString();
        window.location.search = search;
    };
    const onVersio = (0, $jGswQ.useEffectEvent)((versio)=>{
        setVersioActiva(versio);
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        if (versio === 'home' && searchParams.get('embed-home') !== '1') {
            searchParams.set('embed-home', '1');
            window.location.search = searchParams.toString();
        }
        const appElement = document.querySelector(targetSelector);
        appElement.style.maxWidth = versio === 'home' && allowHomeEmbed ? (0, $26e1941f4b3bed1e$export$baf819189b0ccc9b).mida_home : (0, $26e1941f4b3bed1e$export$baf819189b0ccc9b)[`mida_${versio}`];
        appElement.style.margin = inFlow ? '0 auto 40px' : '220px auto 40px';
        appElement.style.boxShadow = '0 0 12px rgba(0, 0, 0, 0.15)';
        appElement.style.backgroundColor = '#ffffff';
    });
    (0, $jGswQ.useEffect)(()=>{
        const versio = localStorage.getItem('headerEmbedVersio');
        document.body.style.backgroundColor = '#f4f6f8';
        if (!versio) {
            localStorage.setItem('headerEmbedVersio', 'noticia_md');
            onVersio('noticia_md');
        } else onVersio(versio);
    }, []);
    return /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
        className: `${$49ec84144abdf02d$export$34e0f9847d4c02dd}${inFlow ? ` ${$49ec84144abdf02d$export$ca787a737bfba0a9}` : ''}`,
        children: [
            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                        children: "Copia el codi de l\u2019embed a:"
                    }),
                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)((0, $jGswQ.Activity), {
                        mode: allowHomeEmbed ? 'visible' : 'hidden',
                        children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("button", {
                            className: `ara-button${text !== null ? ' disabled' : ''}`,
                            onClick: ()=>handleClick('perHome'),
                            children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("span", {
                                children: "HOME"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("button", {
                        className: `ara-button${text !== null ? ' disabled' : ''}`,
                        onClick: ()=>handleClick('perNoticia1'),
                        children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("span", {
                            children: [
                                "NOT\xcdCIA ",
                                /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("span", {
                                    children: "(1r embed)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("button", {
                        className: `ara-button${text !== null ? ' disabled' : ''}`,
                        onClick: ()=>handleClick('perNoticia2'),
                        children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("span", {
                            children: [
                                "NOT\xcdCIA ",
                                /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("span", {
                                    children: "(2n embed i posteriors)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("span", {
                style: {
                    opacity: text ? 1 : 0
                },
                children: text
            }),
            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("div", {
                className: $49ec84144abdf02d$export$2e6c959c16ff56b8,
                children: $94aeed367a707789$var$VERSIONS.map(({ value: value, label: label })=>{
                    const radio = /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                        onClick: ()=>handleVersio(value),
                        children: [
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("input", {
                                type: "radio",
                                value: value,
                                name: "versio",
                                checked: versioActiva === value,
                                onChange: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("label", {
                                htmlFor: value,
                                style: {
                                    fontWeight: versioActiva === value ? 700 : 400
                                },
                                children: label
                            })
                        ]
                    }, value);
                    if (value === 'home') return /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)((0, $jGswQ.Activity), {
                        mode: allowHomeEmbed ? 'visible' : 'hidden',
                        children: radio
                    }, value);
                    return radio;
                })
            })
        ]
    });
};
var $94aeed367a707789$export$2e2bcd8739ae039 = $94aeed367a707789$var$HeaderEmbed;




function $0742004d729df9df$export$929dc6afe9d1d4f4(projecte, asset) {
    let basePath = 'https://';
    basePath += `${"widgets.ara.cat"}/assets`;
    return `${basePath}/${projecte}/${asset}`;
}
const $0742004d729df9df$export$30c8de7d8f611817 = (num)=>Number(num.toString().replaceAll('.', '').replaceAll(',', ''));
const $0742004d729df9df$export$b197258d753cc089 = (premi)=>{
    if (!premi || premi === '' || premi === '0') return '';
    return new Intl.NumberFormat('ca-ES').format($0742004d729df9df$export$30c8de7d8f611817(premi));
};
const $0742004d729df9df$export$69488a20d5f610d0 = (num, decimals = 2)=>{
    return new Intl.NumberFormat('ca-ES', {
        style: 'decimal',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(num);
};


function $ecdd03af44cd004e$export$2e2bcd8739ae039({ className: className, preview: preview, embedHome: embedHome }) {
    const [premis, setPremis] = (0, $jGswQ.useState)(null);
    (0, $jGswQ.useEffect)(()=>{
        fetch(`${"https://widgets.ara.cat/api"}/embeds/v1/loteria-nadal`).then((res)=>res.json()).then((json)=>setPremis(json.data)).catch((error)=>console.log(error));
    }, []);
    if (!premis) return null;
    return /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)((0, $40d3ecb62ca60c31$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)((0, $jGswQ.Activity), {
                mode: preview ? 'visible' : 'hidden',
                children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)((0, $94aeed367a707789$export$2e2bcd8739ae039), {
                    allowHomeEmbed: true
                })
            }),
            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                className: `content ${className || ''}`,
                children: [
                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                        className: "cap",
                        children: [
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                className: "l1 up",
                                children: "La rifa de Nadal"
                            }),
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                className: "l3",
                                children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)((0, $jGswQ.Activity), {
                                    mode: premis.link_noticia !== '' && embedHome ? 'visible' : 'hidden',
                                    children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("a", {
                                        href: premis.link_noticia,
                                        target: "_blank",
                                        children: [
                                            "Comprova el teu n\xfamero",
                                            ' ',
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "15px",
                                                viewBox: "0 -960 960 960",
                                                width: "15px",
                                                fill: "#000",
                                                children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("path", {
                                                    d: "m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                        className: "premis",
                        children: [
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                                className: "premi premi1",
                                children: [
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l2",
                                        children: "Primer premi"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l3",
                                        children: "4.000.000\u20AC"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("ul", {
                                        className: "p1",
                                        children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                            className: "l4",
                                            children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.primer_premi)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                                className: "premi premi2",
                                children: [
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l2",
                                        children: "Segon premi"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l3",
                                        children: "1.250.000\u20AC"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("ul", {
                                        className: "p2",
                                        children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                            className: "l4",
                                            children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.segon_premi)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                                className: "premi premi3",
                                children: [
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l2",
                                        children: "Tercer premi"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l3",
                                        children: "500.000\u20AC"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("ul", {
                                        className: "p3",
                                        children: /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                            className: "l4",
                                            children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.tercer_premi)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                                className: "premi premi4",
                                children: [
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l2",
                                        children: "Quarts premis"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l3",
                                        children: "200.000\u20AC"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.quart_premi1)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.quart_premi2)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("div", {
                                className: "premi premi5",
                                children: [
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l2",
                                        children: "Cinquens premis"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("p", {
                                        className: "l3",
                                        children: "60.000\u20AC"
                                    }),
                                    /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi1)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi2)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi3)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi4)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi5)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi6)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi7)
                                            }),
                                            /*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)("li", {
                                                className: "l5",
                                                children: (0, $0742004d729df9df$export$b197258d753cc089)(premis.cinque_premi8)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


document.addEventListener('DOMContentLoaded', ()=>{
    const container = document.getElementById('app-loteria-nadal');
    const lang = document.documentElement.lang || 'ca';
    const preview = new URLSearchParams(window.location.search).get('preview') === '1';
    const embedHome = new URLSearchParams(window.location.search).get('embed-home') === '1' || container.dataset.embedHome === '1';
    if (embedHome) {
        container.classList.add($80be266eed4217c0$export$711302eb3e721627);
        container.style.paddingInline = '0';
    }
    const root = (0, $9c391b1d92b7475a$exports.createRoot)(container);
    root.render(/*#__PURE__*/ (0, $40d3ecb62ca60c31$exports.jsx)((0, $ecdd03af44cd004e$export$2e2bcd8739ae039), {
        lang: lang,
        preview: preview,
        embedHome: embedHome
    }));
});


//# sourceMappingURL=index.js.map
